var Os = Object.defineProperty;
var Ts = (e, t, r) => t in e ? Os(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Ft = (e, t, r) => Ts(e, typeof t != "symbol" ? t + "" : t, r);
var Kr = function(e, t) {
  return Kr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Kr(e, t);
};
function De(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Kr(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var v = function() {
  return v = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, v.apply(this, arguments);
};
function Pe(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function xe(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function Me(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = s(0), a.throw = s(1), a.return = s(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (r = 0)), r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function ue(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Fr = "Invariant Violation", ei = Object.setPrototypeOf, Ds = ei === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : ei, wo = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      r === void 0 && (r = Fr);
      var n = e.call(this, typeof r == "number" ? Fr + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = Fr, Ds(n, t.prototype), n;
    }
    return t;
  })(Error)
);
function et(e, t) {
  if (!e)
    throw new wo(t);
}
var ko = ["debug", "log", "warn", "error", "silent"], Is = ko.indexOf("log");
function Yt(e) {
  return function() {
    if (ko.indexOf(e) >= Is) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = Yt("debug"), e.log = Yt("log"), e.warn = Yt("warn"), e.error = Yt("error");
})(et || (et = {}));
var En = "3.14.1";
function Oe(e) {
  try {
    return e();
  } catch {
  }
}
const fr = Oe(function() {
  return globalThis;
}) || Oe(function() {
  return window;
}) || Oe(function() {
  return self;
}) || Oe(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Oe(function() {
  return Oe.constructor("return this")();
});
var ti = /* @__PURE__ */ new Map();
function Hr(e) {
  var t = ti.get(e) || 1;
  return ti.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function Eo(e, t) {
  t === void 0 && (t = 0);
  var r = Hr("stringifyForDisplay");
  return JSON.stringify(e, function(n, i) {
    return i === void 0 ? r : i;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function Xt(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var i = t;
      t = Sn(i), t || (t = On(i, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var I = Object.assign(function(t, r) {
  for (var n = [], i = 2; i < arguments.length; i++)
    n[i - 2] = arguments[i];
  t || et(t, Sn(r, n) || On(r, n));
}, {
  debug: Xt(et.debug),
  log: Xt(et.log),
  warn: Xt(et.warn),
  error: Xt(et.error)
});
function ve(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new wo(Sn(e, t) || On(e, t));
}
var ri = Symbol.for("ApolloErrorMessageHandler_" + En);
function So(e) {
  if (typeof e == "string")
    return e;
  try {
    return Eo(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function Sn(e, t) {
  if (t === void 0 && (t = []), !!e)
    return fr[ri] && fr[ri](e, t.map(So));
}
function On(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: En,
      message: e,
      args: t.map(So)
    })));
}
var K = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function zs(e, t) {
  var r = !!e;
  if (!r)
    throw new Error("Unexpected invariant triggered.");
}
var Yr = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function Oo(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || zs(0), e.prototype.inspect = t, Yr && (e.prototype[Yr] = t);
}
var Rs = /* @__PURE__ */ (function() {
  function e(r, n, i) {
    this.start = r.start, this.end = n.end, this.startToken = r, this.endToken = n, this.source = i;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
})();
Oo(Rs);
var Ps = /* @__PURE__ */ (function() {
  function e(r, n, i, o, a, s, u) {
    this.kind = r, this.start = n, this.end = i, this.line = o, this.column = a, this.value = u, this.prev = s, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
})();
Oo(Ps);
function ni(e) {
  return e != null && typeof e.kind == "string";
}
function ir(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ir = function(r) {
    return typeof r;
  } : ir = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ir(e);
}
var Fs = 10, To = 2;
function Ns(e) {
  return _r(e, []);
}
function _r(e, t) {
  switch (ir(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : Cs(e, t);
    default:
      return String(e);
  }
}
function Cs(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var r = [].concat(t, [e]), n = Ms(e);
  if (n !== void 0) {
    var i = n.call(e);
    if (i !== e)
      return typeof i == "string" ? i : _r(i, r);
  } else if (Array.isArray(e))
    return xs(e, r);
  return As(e, r);
}
function As(e, t) {
  var r = Object.keys(e);
  if (r.length === 0)
    return "{}";
  if (t.length > To)
    return "[" + js(e) + "]";
  var n = r.map(function(i) {
    var o = _r(e[i], t);
    return i + ": " + o;
  });
  return "{ " + n.join(", ") + " }";
}
function xs(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > To)
    return "[Array]";
  for (var r = Math.min(Fs, e.length), n = e.length - r, i = [], o = 0; o < r; ++o)
    i.push(_r(e[o], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push("... ".concat(n, " more items")), "[" + i.join(", ") + "]";
}
function Ms(e) {
  var t = e[String(Yr)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function js(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
function $s(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = e.indexOf(`
`) === -1, i = e[0] === " " || e[0] === "	", o = e[e.length - 1] === '"', a = e[e.length - 1] === "\\", s = !n || o || a || r, u = "";
  return s && !(n && i) && (u += `
` + t), u += t ? e.replace(/\n/g, `
` + t) : e, s && (u += `
`), '"""' + u.replace(/"""/g, '\\"""') + '"""';
}
var Ls = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, wr = Object.freeze({});
function Te(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ls, n = void 0, i = Array.isArray(e), o = [e], a = -1, s = [], u = void 0, c = void 0, l = void 0, f = [], d = [], h = e;
  do {
    a++;
    var p = a === o.length, y = p && s.length !== 0;
    if (p) {
      if (c = d.length === 0 ? void 0 : f[f.length - 1], u = l, l = d.pop(), y) {
        if (i)
          u = u.slice();
        else {
          for (var b = {}, m = 0, _ = Object.keys(u); m < _.length; m++) {
            var k = _[m];
            b[k] = u[k];
          }
          u = b;
        }
        for (var S = 0, O = 0; O < s.length; O++) {
          var T = s[O][0], F = s[O][1];
          i && (T -= S), i && F === null ? (u.splice(T, 1), S++) : u[T] = F;
        }
      }
      a = n.index, o = n.keys, s = n.edits, i = n.inArray, n = n.prev;
    } else {
      if (c = l ? i ? a : o[a] : void 0, u = l ? l[c] : h, u == null)
        continue;
      l && f.push(c);
    }
    var P = void 0;
    if (!Array.isArray(u)) {
      if (!ni(u))
        throw new Error("Invalid AST Node: ".concat(Ns(u), "."));
      var x = Vs(t, u.kind, p);
      if (x) {
        if (P = x.call(t, u, c, l, f, d), P === wr)
          break;
        if (P === !1) {
          if (!p) {
            f.pop();
            continue;
          }
        } else if (P !== void 0 && (s.push([c, P]), !p))
          if (ni(P))
            u = P;
          else {
            f.pop();
            continue;
          }
      }
    }
    if (P === void 0 && y && s.push([c, u]), p)
      f.pop();
    else {
      var L;
      n = {
        inArray: i,
        index: a,
        keys: o,
        edits: s,
        prev: n
      }, i = Array.isArray(u), o = i ? u : (L = r[u.kind]) !== null && L !== void 0 ? L : [], a = -1, s = [], l && d.push(l), l = u;
    }
  } while (n !== void 0);
  return s.length !== 0 && (h = s[s.length - 1][1]), h;
}
function Vs(e, t, r) {
  var n = e[t];
  if (n) {
    if (!r && typeof n == "function")
      return n;
    var i = r ? n.leave : n.enter;
    if (typeof i == "function")
      return i;
  } else {
    var o = r ? e.leave : e.enter;
    if (o) {
      if (typeof o == "function")
        return o;
      var a = o[t];
      if (typeof a == "function")
        return a;
    }
  }
}
function qs(e) {
  return Te(e, {
    leave: Qs
  });
}
var Zs = 80, Qs = {
  Name: function(t) {
    return t.value;
  },
  Variable: function(t) {
    return "$" + t.name;
  },
  // Document
  Document: function(t) {
    return z(t.definitions, `

`) + `
`;
  },
  OperationDefinition: function(t) {
    var r = t.operation, n = t.name, i = G("(", z(t.variableDefinitions, ", "), ")"), o = z(t.directives, " "), a = t.selectionSet;
    return !n && !o && !i && r === "query" ? a : z([r, z([n, i]), o, a], " ");
  },
  VariableDefinition: function(t) {
    var r = t.variable, n = t.type, i = t.defaultValue, o = t.directives;
    return r + ": " + n + G(" = ", i) + G(" ", z(o, " "));
  },
  SelectionSet: function(t) {
    var r = t.selections;
    return Se(r);
  },
  Field: function(t) {
    var r = t.alias, n = t.name, i = t.arguments, o = t.directives, a = t.selectionSet, s = G("", r, ": ") + n, u = s + G("(", z(i, ", "), ")");
    return u.length > Zs && (u = s + G(`(
`, or(z(i, `
`)), `
)`)), z([u, z(o, " "), a], " ");
  },
  Argument: function(t) {
    var r = t.name, n = t.value;
    return r + ": " + n;
  },
  // Fragments
  FragmentSpread: function(t) {
    var r = t.name, n = t.directives;
    return "..." + r + G(" ", z(n, " "));
  },
  InlineFragment: function(t) {
    var r = t.typeCondition, n = t.directives, i = t.selectionSet;
    return z(["...", G("on ", r), z(n, " "), i], " ");
  },
  FragmentDefinition: function(t) {
    var r = t.name, n = t.typeCondition, i = t.variableDefinitions, o = t.directives, a = t.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(r).concat(G("(", z(i, ", "), ")"), " ") + "on ".concat(n, " ").concat(G("", z(o, " "), " ")) + a
    );
  },
  // Value
  IntValue: function(t) {
    var r = t.value;
    return r;
  },
  FloatValue: function(t) {
    var r = t.value;
    return r;
  },
  StringValue: function(t, r) {
    var n = t.value, i = t.block;
    return i ? $s(n, r === "description" ? "" : "  ") : JSON.stringify(n);
  },
  BooleanValue: function(t) {
    var r = t.value;
    return r ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(t) {
    var r = t.value;
    return r;
  },
  ListValue: function(t) {
    var r = t.values;
    return "[" + z(r, ", ") + "]";
  },
  ObjectValue: function(t) {
    var r = t.fields;
    return "{" + z(r, ", ") + "}";
  },
  ObjectField: function(t) {
    var r = t.name, n = t.value;
    return r + ": " + n;
  },
  // Directive
  Directive: function(t) {
    var r = t.name, n = t.arguments;
    return "@" + r + G("(", z(n, ", "), ")");
  },
  // Type
  NamedType: function(t) {
    var r = t.name;
    return r;
  },
  ListType: function(t) {
    var r = t.type;
    return "[" + r + "]";
  },
  NonNullType: function(t) {
    var r = t.type;
    return r + "!";
  },
  // Type System Definitions
  SchemaDefinition: Ee(function(e) {
    var t = e.directives, r = e.operationTypes;
    return z(["schema", z(t, " "), Se(r)], " ");
  }),
  OperationTypeDefinition: function(t) {
    var r = t.operation, n = t.type;
    return r + ": " + n;
  },
  ScalarTypeDefinition: Ee(function(e) {
    var t = e.name, r = e.directives;
    return z(["scalar", t, z(r, " ")], " ");
  }),
  ObjectTypeDefinition: Ee(function(e) {
    var t = e.name, r = e.interfaces, n = e.directives, i = e.fields;
    return z(["type", t, G("implements ", z(r, " & ")), z(n, " "), Se(i)], " ");
  }),
  FieldDefinition: Ee(function(e) {
    var t = e.name, r = e.arguments, n = e.type, i = e.directives;
    return t + (ii(r) ? G(`(
`, or(z(r, `
`)), `
)`) : G("(", z(r, ", "), ")")) + ": " + n + G(" ", z(i, " "));
  }),
  InputValueDefinition: Ee(function(e) {
    var t = e.name, r = e.type, n = e.defaultValue, i = e.directives;
    return z([t + ": " + r, G("= ", n), z(i, " ")], " ");
  }),
  InterfaceTypeDefinition: Ee(function(e) {
    var t = e.name, r = e.interfaces, n = e.directives, i = e.fields;
    return z(["interface", t, G("implements ", z(r, " & ")), z(n, " "), Se(i)], " ");
  }),
  UnionTypeDefinition: Ee(function(e) {
    var t = e.name, r = e.directives, n = e.types;
    return z(["union", t, z(r, " "), n && n.length !== 0 ? "= " + z(n, " | ") : ""], " ");
  }),
  EnumTypeDefinition: Ee(function(e) {
    var t = e.name, r = e.directives, n = e.values;
    return z(["enum", t, z(r, " "), Se(n)], " ");
  }),
  EnumValueDefinition: Ee(function(e) {
    var t = e.name, r = e.directives;
    return z([t, z(r, " ")], " ");
  }),
  InputObjectTypeDefinition: Ee(function(e) {
    var t = e.name, r = e.directives, n = e.fields;
    return z(["input", t, z(r, " "), Se(n)], " ");
  }),
  DirectiveDefinition: Ee(function(e) {
    var t = e.name, r = e.arguments, n = e.repeatable, i = e.locations;
    return "directive @" + t + (ii(r) ? G(`(
`, or(z(r, `
`)), `
)`) : G("(", z(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + z(i, " | ");
  }),
  SchemaExtension: function(t) {
    var r = t.directives, n = t.operationTypes;
    return z(["extend schema", z(r, " "), Se(n)], " ");
  },
  ScalarTypeExtension: function(t) {
    var r = t.name, n = t.directives;
    return z(["extend scalar", r, z(n, " ")], " ");
  },
  ObjectTypeExtension: function(t) {
    var r = t.name, n = t.interfaces, i = t.directives, o = t.fields;
    return z(["extend type", r, G("implements ", z(n, " & ")), z(i, " "), Se(o)], " ");
  },
  InterfaceTypeExtension: function(t) {
    var r = t.name, n = t.interfaces, i = t.directives, o = t.fields;
    return z(["extend interface", r, G("implements ", z(n, " & ")), z(i, " "), Se(o)], " ");
  },
  UnionTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.types;
    return z(["extend union", r, z(n, " "), i && i.length !== 0 ? "= " + z(i, " | ") : ""], " ");
  },
  EnumTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.values;
    return z(["extend enum", r, z(n, " "), Se(i)], " ");
  },
  InputObjectTypeExtension: function(t) {
    var r = t.name, n = t.directives, i = t.fields;
    return z(["extend input", r, z(n, " "), Se(i)], " ");
  }
};
function Ee(e) {
  return function(t) {
    return z([t.description, e(t)], `
`);
  };
}
function z(e) {
  var t, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e == null ? void 0 : e.filter(function(n) {
    return n;
  }).join(r)) !== null && t !== void 0 ? t : "";
}
function Se(e) {
  return G(`{
`, or(z(e, `
`)), `
}`);
}
function G(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + r : "";
}
function or(e) {
  return G("  ", e.replace(/\n/g, `
  `));
}
function Us(e) {
  return e.indexOf(`
`) !== -1;
}
function ii(e) {
  return e != null && e.some(Us);
}
function oi(e) {
  return e.kind === K.FIELD || e.kind === K.FRAGMENT_SPREAD || e.kind === K.INLINE_FRAGMENT;
}
function Kt(e, t) {
  var r = e.directives;
  return !r || !r.length ? !0 : Js(r).every(function(n) {
    var i = n.directive, o = n.ifArgument, a = !1;
    return o.value.kind === "Variable" ? (a = t && t[o.value.name.value], I(a !== void 0, 105, i.name.value)) : a = o.value.value, i.name.value === "skip" ? !a : a;
  });
}
function Ut(e, t, r) {
  var n = new Set(e), i = n.size;
  return Te(t, {
    Directive: function(o) {
      if (n.delete(o.name.value) && (!r || !n.size))
        return wr;
    }
  }), r ? !n.size : n.size < i;
}
function Bs(e) {
  return e && Ut(["client", "export"], e, !0);
}
function Ws(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function Js(e) {
  var t = [];
  return e && e.length && e.forEach(function(r) {
    if (Ws(r)) {
      var n = r.arguments, i = r.name.value;
      I(n && n.length === 1, 106, i);
      var o = n[0];
      I(o.name && o.name.value === "if", 107, i);
      var a = o.value;
      I(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 108, i), t.push({ directive: r, ifArgument: o });
    }
  }), t;
}
function Gs(e) {
  var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(o) {
    var a = o.name;
    return a.value === "unmask";
  });
  if (!n)
    return "mask";
  var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(o) {
    var a = o.name;
    return a.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === K.VARIABLE ? globalThis.__DEV__ !== !1 && I.warn(109) : i.value.kind !== K.STRING ? globalThis.__DEV__ !== !1 && I.warn(110) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && I.warn(111, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const Ks = () => /* @__PURE__ */ Object.create(null), { forEach: Hs, slice: ai } = Array.prototype, { hasOwnProperty: Ys } = Object.prototype;
class Ce {
  constructor(t = !0, r = Ks) {
    this.weakness = t, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let r = this;
    return Hs.call(t, (n) => r = r.getChildTrie(n)), Ys.call(r, "data") ? r.data : r.data = this.makeData(ai.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let r = this;
    for (let n = 0, i = t.length; r && n < i; ++n) {
      const o = r.mapFor(t[n], !1);
      r = o && o.get(t[n]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let r;
    if (t.length) {
      const n = t[0], i = this.mapFor(n, !1), o = i && i.get(n);
      o && (r = o.removeArray(ai.call(t, 1)), !o.data && !o.weak && !(o.strong && o.strong.size) && i.delete(n));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(t) {
    const r = this.mapFor(t, !0);
    let n = r.get(t);
    return n || r.set(t, n = new Ce(this.weakness, this.makeData)), n;
  }
  mapFor(t, r) {
    return this.weakness && Xs(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function Xs(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var eu = Oe(function() {
  return navigator.product;
}) == "ReactNative", nt = typeof WeakMap == "function" && !(eu && !global.HermesInternal), Tn = typeof WeakSet == "function", Do = typeof Symbol == "function" && typeof Symbol.for == "function", kr = Do && Symbol.asyncIterator;
Oe(function() {
  return window.document.createElement;
});
Oe(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function W(e) {
  return e !== null && typeof e == "object";
}
function tu(e, t) {
  var r = t, n = [];
  e.definitions.forEach(function(o) {
    if (o.kind === "OperationDefinition")
      throw ve(
        112,
        o.operation,
        o.name ? " named '".concat(o.name.value, "'") : ""
      );
    o.kind === "FragmentDefinition" && n.push(o);
  }), typeof r > "u" && (I(n.length === 1, 113, n.length), r = n[0].name.value);
  var i = v(v({}, e), { definitions: ue([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: r
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function Tt(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(r) {
    t[r.name.value] = r;
  }), t;
}
function Er(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var r = e.name.value;
      if (typeof t == "function")
        return t(r);
      var n = t && t[r];
      return I(n, 114, r), n || null;
    }
    default:
      return null;
  }
}
function ru(e) {
  var t = !0;
  return Te(e, {
    FragmentSpread: function(r) {
      if (t = !!r.directives && r.directives.some(function(n) {
        return n.name.value === "unmask";
      }), !t)
        return wr;
    }
  }), t;
}
function nu() {
}
class Xr {
  constructor(t = 1 / 0, r = nu) {
    this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
  }
}
function en() {
}
const iu = en, ou = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, au = typeof WeakMap < "u" ? WeakMap : Map, su = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: en,
    unregister: en
  };
}, uu = 10024;
class hr {
  constructor(t = 1 / 0, r = iu) {
    this.max = t, this.dispose = r, this.map = new au(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const n = this.unfinalizedNodes.values();
      for (let i = 0; i < uu; i++) {
        const o = n.next().value;
        if (!o)
          break;
        this.unfinalizedNodes.delete(o);
        const a = o.key;
        delete o.key, o.keyRef = new ou(a), this.registry.register(a, o, o);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new su(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const r = this.getNode(t);
    return r && r.value;
  }
  getNode(t) {
    const r = this.map.get(t);
    if (r && r !== this.newest) {
      const { older: n, newer: i } = r;
      i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
    }
    return r;
  }
  set(t, r) {
    let n = this.getNode(t);
    return n ? n.value = r : (n = {
      key: t,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const r = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
  }
  delete(t) {
    const r = this.map.get(t);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var Nr = /* @__PURE__ */ new WeakSet();
function Io(e) {
  e.size <= (e.max || -1) || Nr.has(e) || (Nr.add(e), setTimeout(function() {
    e.clean(), Nr.delete(e);
  }, 100));
}
var zo = function(e, t) {
  var r = new hr(e, t);
  return r.set = function(n, i) {
    var o = hr.prototype.set.call(this, n, i);
    return Io(this), o;
  }, r;
}, cu = function(e, t) {
  var r = new Xr(e, t);
  return r.set = function(n, i) {
    var o = Xr.prototype.set.call(this, n, i);
    return Io(this), o;
  }, r;
}, lu = Symbol.for("apollo.cacheSize"), Fe = v({}, fr[lu]), Ye = {};
function Ro(e, t) {
  Ye[e] = t;
}
var fu = globalThis.__DEV__ !== !1 ? vu : void 0, hu = globalThis.__DEV__ !== !1 ? yu : void 0, du = globalThis.__DEV__ !== !1 ? Po : void 0;
function pu() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var r = t[0], n = t[1];
    return [
      r,
      Fe[r] || n
    ];
  }));
}
function vu() {
  var e, t, r, n, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: pu(),
    sizes: v({ print: (e = Ye.print) === null || e === void 0 ? void 0 : e.call(Ye), parser: (t = Ye.parser) === null || t === void 0 ? void 0 : t.call(Ye), canonicalStringify: (r = Ye.canonicalStringify) === null || r === void 0 ? void 0 : r.call(Ye), links: rn(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: No(this.queryManager.documentTransform)
    } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
  };
}
function Po() {
  return {
    cache: {
      fragmentQueryDocuments: je(this.getFragmentDoc)
    }
  };
}
function yu() {
  var e = this.config.fragments;
  return v(v({}, Po.apply(this)), { addTypenameDocumentTransform: No(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: je(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: je(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: je(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: je(e == null ? void 0 : e.findFragmentSpreads),
    lookup: je(e == null ? void 0 : e.lookup),
    transform: je(e == null ? void 0 : e.transform)
  } });
}
function mu(e) {
  return !!e && "dirtyKey" in e;
}
function je(e) {
  return mu(e) ? e.size : void 0;
}
function Fo(e) {
  return e != null;
}
function No(e) {
  return tn(e).map(function(t) {
    return { cache: t };
  });
}
function tn(e) {
  return e ? ue(ue([
    je(e == null ? void 0 : e.performWork)
  ], tn(e == null ? void 0 : e.left), !0), tn(e == null ? void 0 : e.right), !0).filter(Fo) : [];
}
function rn(e) {
  var t;
  return e ? ue(ue([
    (t = e == null ? void 0 : e.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], rn(e == null ? void 0 : e.left), !0), rn(e == null ? void 0 : e.right), !0).filter(Fo) : [];
}
var Ve = Object.assign(function(t) {
  return JSON.stringify(t, gu);
}, {
  reset: function() {
    ut = new cu(
      Fe.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && Ro("canonicalStringify", function() {
  return ut.size;
});
var ut;
Ve.reset();
function gu(e, t) {
  if (t && typeof t == "object") {
    var r = Object.getPrototypeOf(t);
    if (r === Object.prototype || r === null) {
      var n = Object.keys(t);
      if (n.every(bu))
        return t;
      var i = JSON.stringify(n), o = ut.get(i);
      if (!o) {
        n.sort();
        var a = JSON.stringify(n);
        o = ut.get(a) || n, ut.set(i, o), ut.set(a, o);
      }
      var s = Object.create(r);
      return o.forEach(function(u) {
        s[u] = t[u];
      }), s;
    }
  }
  return t;
}
function bu(e, t, r) {
  return t === 0 || r[t - 1] <= e;
}
function pt(e) {
  return { __ref: String(e) };
}
function q(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function _u(e) {
  return W(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function wu(e) {
  return e.kind === "StringValue";
}
function ku(e) {
  return e.kind === "BooleanValue";
}
function Eu(e) {
  return e.kind === "IntValue";
}
function Su(e) {
  return e.kind === "FloatValue";
}
function Ou(e) {
  return e.kind === "Variable";
}
function Tu(e) {
  return e.kind === "ObjectValue";
}
function Du(e) {
  return e.kind === "ListValue";
}
function Iu(e) {
  return e.kind === "EnumValue";
}
function zu(e) {
  return e.kind === "NullValue";
}
function bt(e, t, r, n) {
  if (Eu(r) || Su(r))
    e[t.value] = Number(r.value);
  else if (ku(r) || wu(r))
    e[t.value] = r.value;
  else if (Tu(r)) {
    var i = {};
    r.fields.map(function(a) {
      return bt(i, a.name, a.value, n);
    }), e[t.value] = i;
  } else if (Ou(r)) {
    var o = (n || {})[r.name.value];
    e[t.value] = o;
  } else if (Du(r))
    e[t.value] = r.values.map(function(a) {
      var s = {};
      return bt(s, t, a, n), s[t.value];
    });
  else if (Iu(r))
    e[t.value] = r.value;
  else if (zu(r))
    e[t.value] = null;
  else
    throw ve(123, t.value, r.kind);
}
function Ru(e, t) {
  var r = null;
  e.directives && (r = {}, e.directives.forEach(function(i) {
    r[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
      var a = o.name, s = o.value;
      return bt(r[i.name.value], a, s, t);
    });
  }));
  var n = null;
  return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(i) {
    var o = i.name, a = i.value;
    return bt(n, o, a, t);
  })), Co(e.name.value, n, r);
}
var Pu = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Nt = Ve, Co = Object.assign(function(e, t, r) {
  if (t && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var n = r.connection.filter ? r.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(r.connection.key, "(").concat(Nt(i), ")");
    } else
      return r.connection.key;
  var o = e;
  if (t) {
    var a = Nt(t);
    o += "(".concat(a, ")");
  }
  return r && Object.keys(r).forEach(function(s) {
    Pu.indexOf(s) === -1 && (r[s] && Object.keys(r[s]).length ? o += "@".concat(s, "(").concat(Nt(r[s]), ")") : o += "@".concat(s));
  }), o;
}, {
  setStringify: function(e) {
    var t = Nt;
    return Nt = e, t;
  }
});
function Sr(e, t) {
  if (e.arguments && e.arguments.length) {
    var r = {};
    return e.arguments.forEach(function(n) {
      var i = n.name, o = n.value;
      return bt(r, i, o, t);
    }), r;
  }
  return null;
}
function Ne(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function nn(e, t, r) {
  for (var n, i = 0, o = t.selections; i < o.length; i++) {
    var a = o[i];
    if (qe(a)) {
      if (a.name.value === "__typename")
        return e[Ne(a)];
    } else n ? n.push(a) : n = [a];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (n)
    for (var s = 0, u = n; s < u.length; s++) {
      var a = u[s], c = nn(e, Er(a, r).selectionSet, r);
      if (typeof c == "string")
        return c;
    }
}
function qe(e) {
  return e.kind === "Field";
}
function Fu(e) {
  return e.kind === "InlineFragment";
}
function Dt(e) {
  I(e && e.kind === "Document", 115);
  var t = e.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw ve(116, r.kind);
    return r;
  });
  return I(t.length <= 1, 117, t.length), e;
}
function rt(e) {
  return Dt(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function jt(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function It(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function Ao(e) {
  var t = rt(e);
  return I(t && t.operation === "query", 118), t;
}
function xo(e) {
  I(e.kind === "Document", 119), I(e.definitions.length <= 1, 120);
  var t = e.definitions[0];
  return I(t.kind === "FragmentDefinition", 121), t;
}
function zt(e) {
  Dt(e);
  for (var t, r = 0, n = e.definitions; r < n.length; r++) {
    var i = n[r];
    if (i.kind === "OperationDefinition") {
      var o = i.operation;
      if (o === "query" || o === "mutation" || o === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw ve(122);
}
function Dn(e) {
  var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
  return r && r.length && r.forEach(function(n) {
    n.defaultValue && bt(t, n.variable.name, n.defaultValue);
  }), t;
}
let se = null;
const si = {};
let Nu = 1;
const Cu = () => class {
  constructor() {
    this.id = [
      "slot",
      Nu++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let t = se; t; t = t.parent)
      if (this.id in t.slots) {
        const r = t.slots[this.id];
        if (r === si)
          break;
        return t !== se && (se.slots[this.id] = r), !0;
      }
    return se && (se.slots[this.id] = si), !1;
  }
  getValue() {
    if (this.hasValue())
      return se.slots[this.id];
  }
  withValue(t, r, n, i) {
    const o = {
      __proto__: null,
      [this.id]: t
    }, a = se;
    se = { parent: a, slots: o };
    try {
      return r.apply(i, n);
    } finally {
      se = a;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(t) {
    const r = se;
    return function() {
      const n = se;
      try {
        return se = r, t.apply(this, arguments);
      } finally {
        se = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(t, r, n) {
    if (se) {
      const i = se;
      try {
        return se = null, t.apply(n, r);
      } finally {
        se = i;
      }
    } else
      return t.apply(n, r);
  }
};
function ui(e) {
  try {
    return e();
  } catch {
  }
}
const Cr = "@wry/context:Slot", Au = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  ui(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  ui(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), ci = Au, Rt = ci[Cr] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Cr] || (function(e) {
  try {
    Object.defineProperty(ci, Cr, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(Cu()), { bind: Qy, noContext: Uy } = Rt, Or = new Rt(), { hasOwnProperty: xu } = Object.prototype, In = Array.from || function(e) {
  const t = [];
  return e.forEach((r) => t.push(r)), t;
};
function zn(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const Bt = [], Mu = 100;
function _t(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function Mo(e, t) {
  const r = e.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === t.length && // The underlying value or exception must be the same.
    e[r - 1] === t[r - 1]
  );
}
function jo(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function $o(e) {
  return e.slice(0);
}
class Tr {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Tr.count;
  }
  peek() {
    if (this.value.length === 1 && !Ze(this))
      return li(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return _t(!this.recomputing, "already recomputing"), li(this), Ze(this) ? ju(this, t) : jo(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, Lo(this), zn(this));
  }
  dispose() {
    this.setDirty(), Uo(this), Rn(this, (t, r) => {
      t.setDirty(), Bo(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = Bt.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (In(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), Bt.push(this.deps), this.deps = null);
  }
}
Tr.count = 0;
function li(e) {
  const t = Or.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Ze(e) ? qo(t, e) : Zo(t, e), t;
}
function ju(e, t) {
  return Uo(e), Or.withValue(e, $u, [e, t]), Vu(e, t) && Lu(e), jo(e.value);
}
function $u(e, t) {
  e.recomputing = !0;
  const { normalizeResult: r } = e;
  let n;
  r && e.value.length === 1 && (n = $o(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), r && n && !Mo(n, e.value))
      try {
        e.value[0] = r(e.value[0], n[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function Ze(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function Lu(e) {
  e.dirty = !1, !Ze(e) && Vo(e);
}
function Lo(e) {
  Rn(e, qo);
}
function Vo(e) {
  Rn(e, Zo);
}
function Rn(e, t) {
  const r = e.parents.size;
  if (r) {
    const n = In(e.parents);
    for (let i = 0; i < r; ++i)
      t(n[i], e);
  }
}
function qo(e, t) {
  _t(e.childValues.has(t)), _t(Ze(t));
  const r = !Ze(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = Bt.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), r && Lo(e);
}
function Zo(e, t) {
  _t(e.childValues.has(t)), _t(!Ze(t));
  const r = e.childValues.get(t);
  r.length === 0 ? e.childValues.set(t, $o(t.value)) : Mo(r, t.value) || e.setDirty(), Qo(e, t), !Ze(e) && Vo(e);
}
function Qo(e, t) {
  const r = e.dirtyChildren;
  r && (r.delete(t), r.size === 0 && (Bt.length < Mu && Bt.push(r), e.dirtyChildren = null));
}
function Uo(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, r) => {
    Bo(e, r);
  }), e.forgetDeps(), _t(e.dirtyChildren === null);
}
function Bo(e, t) {
  t.parents.delete(e), e.childValues.delete(t), Qo(e, t);
}
function Vu(e, t) {
  if (typeof e.subscribe == "function")
    try {
      zn(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const qu = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function Wo(e) {
  const t = /* @__PURE__ */ new Map();
  function r(n) {
    const i = Or.getValue();
    if (i) {
      let o = t.get(n);
      o || t.set(n, o = /* @__PURE__ */ new Set()), i.dependOn(o);
    }
  }
  return r.dirty = function(i, o) {
    const a = t.get(i);
    if (a) {
      const s = o && xu.call(qu, o) ? o : "setDirty";
      In(a).forEach((u) => u[s]()), t.delete(i), zn(a);
    }
  }, r;
}
let fi;
function Zu(...e) {
  return (fi || (fi = new Ce(typeof WeakMap == "function"))).lookupArray(e);
}
const Ar = /* @__PURE__ */ new Set();
function Wt(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = Zu, normalizeResult: i, subscribe: o, cache: a = Xr } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof a == "function" ? new a(t, (d) => d.dispose()) : a, u = function() {
    const d = n.apply(null, r ? r.apply(null, arguments) : arguments);
    if (d === void 0)
      return e.apply(null, arguments);
    let h = s.get(d);
    h || (s.set(d, h = new Tr(e)), h.normalizeResult = i, h.subscribe = o, h.forget = () => s.delete(d));
    const p = h.recompute(Array.prototype.slice.call(arguments));
    return s.set(d, h), Ar.add(s), Or.hasValue() || (Ar.forEach((y) => y.clean()), Ar.clear()), p;
  };
  Object.defineProperty(u, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(u.options = {
    max: t,
    keyArgs: r,
    makeCacheKey: n,
    normalizeResult: i,
    subscribe: o,
    cache: s
  });
  function c(d) {
    const h = d && s.get(d);
    h && h.setDirty();
  }
  u.dirtyKey = c, u.dirty = function() {
    c(n.apply(null, arguments));
  };
  function l(d) {
    const h = d && s.get(d);
    if (h)
      return h.peek();
  }
  u.peekKey = l, u.peek = function() {
    return l(n.apply(null, arguments));
  };
  function f(d) {
    return d ? s.delete(d) : !1;
  }
  return u.forgetKey = f, u.forget = function() {
    return f(n.apply(null, arguments));
  }, u.makeCacheKey = n, u.getKey = r ? function() {
    return n.apply(null, r.apply(null, arguments));
  } : n, Object.freeze(u);
}
function Qu(e) {
  return e;
}
var Jo = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = Tn ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(Qu, { cache: !1 });
    }, e.split = function(t, r, n) {
      return n === void 0 && (n = e.identity()), Object.assign(new e(
        function(i) {
          var o = t(i) ? r : n;
          return o.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: n });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var r = new Ce(nt);
        this.performWork = Wt(e.prototype.performWork.bind(this), {
          makeCacheKey: function(n) {
            var i = t.getCacheKey(n);
            if (i)
              return I(Array.isArray(i), 104), r.lookupArray(i);
          },
          max: Fe["documentTransform.cache"],
          cache: hr
        });
      }
    }, e.prototype.performWork = function(t) {
      return Dt(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var r = this.performWork(t);
      return this.resultCache.add(r), r;
    }, e.prototype.concat = function(t) {
      var r = this;
      return Object.assign(new e(
        function(n) {
          return t.transformDocument(r.transformDocument(n));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), Vt, Le = Object.assign(function(e) {
  var t = Vt.get(e);
  return t || (t = qs(e), Vt.set(e, t)), t;
}, {
  reset: function() {
    Vt = new zo(
      Fe.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Le.reset();
globalThis.__DEV__ !== !1 && Ro("print", function() {
  return Vt ? Vt.size : 0;
});
var te = Array.isArray;
function Ie(e) {
  return Array.isArray(e) && e.length > 0;
}
var hi = {
  kind: K.FIELD,
  name: {
    kind: K.NAME,
    value: "__typename"
  }
};
function Go(e, t) {
  return !e || e.selectionSet.selections.every(function(r) {
    return r.kind === K.FRAGMENT_SPREAD && Go(t[r.name.value], t);
  });
}
function Uu(e) {
  return Go(rt(e) || xo(e), Tt(It(e))) ? null : e;
}
function Bu(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
  }), function(n) {
    var i = t.get(n.name.value);
    return !i && r.size && r.forEach(function(o, a) {
      a(n) && (i = o);
    }), i;
  };
}
function di(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var i = t.get(n);
    return i || t.set(n, i = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), i;
  };
}
function Ko(e, t) {
  Dt(t);
  for (var r = di(""), n = di(""), i = function(m) {
    for (var _ = 0, k = void 0; _ < m.length && (k = m[_]); ++_)
      if (!te(k)) {
        if (k.kind === K.OPERATION_DEFINITION)
          return r(k.name && k.name.value);
        if (k.kind === K.FRAGMENT_DEFINITION)
          return n(k.name.value);
      }
    return globalThis.__DEV__ !== !1 && I.error(124), null;
  }, o = 0, a = t.definitions.length - 1; a >= 0; --a)
    t.definitions[a].kind === K.OPERATION_DEFINITION && ++o;
  var s = Bu(e), u = function(m) {
    return Ie(m) && m.map(s).some(function(_) {
      return _ && _.remove;
    });
  }, c = /* @__PURE__ */ new Map(), l = !1, f = {
    enter: function(m) {
      if (u(m.directives))
        return l = !0, null;
    }
  }, d = Te(t, {
    // These two AST node types share the same implementation, defined above.
    Field: f,
    InlineFragment: f,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(m, _, k, S, O) {
        var T = i(O);
        T && T.variables.add(m.name.value);
      }
    },
    FragmentSpread: {
      enter: function(m, _, k, S, O) {
        if (u(m.directives))
          return l = !0, null;
        var T = i(O);
        T && T.fragmentSpreads.add(m.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(m, _, k, S) {
        c.set(JSON.stringify(S), m);
      },
      leave: function(m, _, k, S) {
        var O = c.get(JSON.stringify(S));
        if (m === O)
          return m;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          o > 0 && m.selectionSet.selections.every(function(T) {
            return T.kind === K.FIELD && T.name.value === "__typename";
          })
        )
          return n(m.name.value).removed = !0, l = !0, null;
      }
    },
    Directive: {
      leave: function(m) {
        if (s(m))
          return l = !0, null;
      }
    }
  });
  if (!l)
    return t;
  var h = function(m) {
    return m.transitiveVars || (m.transitiveVars = new Set(m.variables), m.removed || m.fragmentSpreads.forEach(function(_) {
      h(n(_)).transitiveVars.forEach(function(k) {
        m.transitiveVars.add(k);
      });
    })), m;
  }, p = /* @__PURE__ */ new Set();
  d.definitions.forEach(function(m) {
    m.kind === K.OPERATION_DEFINITION ? h(r(m.name && m.name.value)).fragmentSpreads.forEach(function(_) {
      p.add(_);
    }) : m.kind === K.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    o === 0 && !n(m.name.value).removed && p.add(m.name.value);
  }), p.forEach(function(m) {
    h(n(m)).fragmentSpreads.forEach(function(_) {
      p.add(_);
    });
  });
  var y = function(m) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(m) || n(m).removed);
  }, b = {
    enter: function(m) {
      if (y(m.name.value))
        return null;
    }
  };
  return Uu(Te(d, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: b,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: b,
    OperationDefinition: {
      leave: function(m) {
        if (m.variableDefinitions) {
          var _ = h(
            // If an operation is anonymous, we use the empty string as its key.
            r(m.name && m.name.value)
          ).transitiveVars;
          if (_.size < m.variableDefinitions.length)
            return v(v({}, m), { variableDefinitions: m.variableDefinitions.filter(function(k) {
              return _.has(k.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var Pn = Object.assign(function(e) {
  return Te(e, {
    SelectionSet: {
      enter: function(t, r, n) {
        if (!(n && n.kind === K.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var o = i.some(function(s) {
              return qe(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!o) {
              var a = n;
              if (!(qe(a) && a.directives && a.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return v(v({}, t), { selections: ue(ue([], i, !0), [hi], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === hi;
  }
});
function Wu(e) {
  var t = zt(e), r = t.operation;
  if (r === "query")
    return e;
  var n = Te(e, {
    OperationDefinition: {
      enter: function(i) {
        return v(v({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function Ho(e) {
  Dt(e);
  var t = Ko([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function Ju(e) {
  return Dt(e), Te(e, {
    FragmentSpread: function(t) {
      var r;
      if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
        return n.name.value === "unmask";
      })))
        return v(v({}, t), { directives: ue(ue([], t.directives || [], !0), [
          {
            kind: K.DIRECTIVE,
            name: { kind: K.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var Gu = Object.prototype.hasOwnProperty;
function pi() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Dr(e);
}
function Dr(e) {
  var t = e[0] || {}, r = e.length;
  if (r > 1)
    for (var n = new Qe(), i = 1; i < r; ++i)
      t = n.merge(t, e[i]);
  return t;
}
var Ku = function(e, t, r) {
  return this.merge(e[r], t[r]);
}, Qe = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = Ku), this.reconciler = t, this.isObject = W, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, r) {
      for (var n = this, i = [], o = 2; o < arguments.length; o++)
        i[o - 2] = arguments[o];
      return W(r) && W(t) ? (Object.keys(r).forEach(function(a) {
        if (Gu.call(t, a)) {
          var s = t[a];
          if (r[a] !== s) {
            var u = n.reconciler.apply(n, ue([
              t,
              r,
              a
            ], i, !1));
            u !== s && (t = n.shallowCopyForMerge(t), t[a] = u);
          }
        } else
          t = n.shallowCopyForMerge(t), t[a] = r[a];
      }), t) : r;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return W(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = v({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function Hu(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Yu(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yu(e, t) {
  if (e) {
    if (typeof e == "string") return vi(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return vi(e, t);
  }
}
function vi(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function yi(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Fn(e, t, r) {
  return t && yi(e.prototype, t), r && yi(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Nn = function() {
  return typeof Symbol == "function";
}, Cn = function(e) {
  return Nn() && !!Symbol[e];
}, An = function(e) {
  return Cn(e) ? Symbol[e] : "@@" + e;
};
Nn() && !Cn("observable") && (Symbol.observable = Symbol("observable"));
var Xu = An("iterator"), on = An("observable"), Yo = An("species");
function dr(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function Ct(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[Yo], t === null && (t = void 0)), t !== void 0 ? t : Q;
}
function ec(e) {
  return e instanceof Q;
}
function wt(e) {
  wt.log ? wt.log(e) : setTimeout(function() {
    throw e;
  });
}
function ar(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      wt(t);
    }
  });
}
function Xo(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = dr(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      wt(n);
    }
}
function an(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function tc(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (ea(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function ea(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var i = dr(n, t);
    switch (t) {
      case "next":
        i && i.call(n, r);
        break;
      case "error":
        if (an(e), i) i.call(n, r);
        else throw r;
        break;
      case "complete":
        an(e), i && i.call(n);
        break;
    }
  } catch (o) {
    wt(o);
  }
  e._state === "closed" ? Xo(e) : e._state === "running" && (e._state = "ready");
}
function xr(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], ar(function() {
        return tc(e);
      });
      return;
    }
    ea(e, t, r);
  }
}
var rc = /* @__PURE__ */ (function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var i = new nc(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (o) {
      i.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (an(this), Xo(this));
  }, Fn(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), nc = /* @__PURE__ */ (function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(n) {
    xr(this._subscription, "next", n);
  }, t.error = function(n) {
    xr(this._subscription, "error", n);
  }, t.complete = function() {
    xr(this._subscription, "complete");
  }, Fn(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), Q = /* @__PURE__ */ (function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new rc(n, this._subscriber);
  }, t.forEach = function(n) {
    var i = this;
    return new Promise(function(o, a) {
      if (typeof n != "function") {
        a(new TypeError(n + " is not a function"));
        return;
      }
      function s() {
        u.unsubscribe(), o();
      }
      var u = i.subscribe({
        next: function(c) {
          try {
            n(c, s);
          } catch (l) {
            a(l), u.unsubscribe();
          }
        },
        error: a,
        complete: o
      });
    });
  }, t.map = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Ct(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            s = n(s);
          } catch (u) {
            return a.error(u);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Ct(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            if (!n(s)) return;
          } catch (u) {
            return a.error(u);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Ct(this), a = arguments.length > 1, s = !1, u = arguments[1], c = u;
    return new o(function(l) {
      return i.subscribe({
        next: function(f) {
          var d = !s;
          if (s = !0, !d || a)
            try {
              c = n(c, f);
            } catch (h) {
              return l.error(h);
            }
          else
            c = f;
        },
        error: function(f) {
          l.error(f);
        },
        complete: function() {
          if (!s && !a) return l.error(new TypeError("Cannot reduce an empty sequence"));
          l.next(c), l.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    var s = Ct(this);
    return new s(function(u) {
      var c, l = 0;
      function f(d) {
        c = d.subscribe({
          next: function(h) {
            u.next(h);
          },
          error: function(h) {
            u.error(h);
          },
          complete: function() {
            l === o.length ? (c = void 0, u.complete()) : f(s.from(o[l++]));
          }
        });
      }
      return f(n), function() {
        c && (c.unsubscribe(), c = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var i = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Ct(this);
    return new o(function(a) {
      var s = [], u = i.subscribe({
        next: function(l) {
          if (n)
            try {
              l = n(l);
            } catch (d) {
              return a.error(d);
            }
          var f = o.from(l).subscribe({
            next: function(d) {
              a.next(d);
            },
            error: function(d) {
              a.error(d);
            },
            complete: function() {
              var d = s.indexOf(f);
              d >= 0 && s.splice(d, 1), c();
            }
          });
          s.push(f);
        },
        error: function(l) {
          a.error(l);
        },
        complete: function() {
          c();
        }
      });
      function c() {
        u.closed && s.length === 0 && a.complete();
      }
      return function() {
        s.forEach(function(l) {
          return l.unsubscribe();
        }), u.unsubscribe();
      };
    });
  }, t[on] = function() {
    return this;
  }, e.from = function(n) {
    var i = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var o = dr(n, on);
    if (o) {
      var a = o.call(n);
      if (Object(a) !== a) throw new TypeError(a + " is not an object");
      return ec(a) && a.constructor === i ? a : new i(function(s) {
        return a.subscribe(s);
      });
    }
    if (Cn("iterator") && (o = dr(n, Xu), o))
      return new i(function(s) {
        ar(function() {
          if (!s.closed) {
            for (var u = Hu(o.call(n)), c; !(c = u()).done; ) {
              var l = c.value;
              if (s.next(l), s.closed) return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(s) {
        ar(function() {
          if (!s.closed) {
            for (var u = 0; u < n.length; ++u)
              if (s.next(n[u]), s.closed) return;
            s.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    var a = typeof this == "function" ? this : e;
    return new a(function(s) {
      ar(function() {
        if (!s.closed) {
          for (var u = 0; u < i.length; ++u)
            if (s.next(i[u]), s.closed) return;
          s.complete();
        }
      });
    });
  }, Fn(e, null, [{
    key: Yo,
    get: function() {
      return this;
    }
  }]), e;
})();
Nn() && Object.defineProperty(Q, Symbol("extensions"), {
  value: {
    symbol: on,
    hostReportError: wt
  },
  configurable: !0
});
function ic(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var at;
typeof self < "u" ? at = self : typeof window < "u" ? at = window : typeof global < "u" ? at = global : typeof module < "u" ? at = module : at = Function("return this")();
ic(at);
var mi = Q.prototype, gi = "@@observable";
mi[gi] || (mi[gi] = function() {
  return this;
});
function oc(e) {
  return e.catch(function() {
  }), e;
}
var ac = Object.prototype.toString;
function ta(e) {
  return sn(e);
}
function sn(e, t) {
  switch (ac.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = e.slice(0);
      return t.set(e, r), r.forEach(function(i, o) {
        r[o] = sn(i, t);
      }), r;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = Object.create(Object.getPrototypeOf(e));
      return t.set(e, n), Object.keys(e).forEach(function(i) {
        n[i] = sn(e[i], t);
      }), n;
    }
    default:
      return e;
  }
}
function sc(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    W(r) && uc(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      W(r[n]) && t.add(r[n]);
    });
  }), e;
}
function uc(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function pr(e) {
  return globalThis.__DEV__ !== !1 && sc(e), e;
}
function qt(e, t, r) {
  var n = [];
  e.forEach(function(i) {
    return i[t] && n.push(i);
  }), n.forEach(function(i) {
    return i[t](r);
  });
}
function Mr(e, t, r) {
  return new Q(function(n) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(u) {
        return new Promise(function(c) {
          return c(u());
        });
      }
    };
    function o(u, c) {
      return function(l) {
        if (u) {
          var f = function() {
            return n.closed ? (
              /* will be swallowed */
              0
            ) : u(l);
          };
          i = i.then(f, f).then(function(d) {
            return n.next(d);
          }, function(d) {
            return n.error(d);
          });
        } else
          n[c](l);
      };
    }
    var a = {
      next: o(t, "next"),
      error: o(r, "error"),
      complete: function() {
        i.then(function() {
          return n.complete();
        });
      }
    }, s = e.subscribe(a);
    return function() {
      return s.unsubscribe();
    };
  });
}
function ra(e) {
  function t(r) {
    Object.defineProperty(e, r, { value: Q });
  }
  return Do && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function bi(e) {
  return e && typeof e.then == "function";
}
var st = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = e.call(this, function(i) {
        return n.addObserver(i), function() {
          return n.removeObserver(i);
        };
      }) || this;
      return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, o) {
        n.resolve = i, n.reject = o;
      }), n.handlers = {
        next: function(i) {
          n.sub !== null && (n.latest = ["next", i], n.notify("next", i), qt(n.observers, "next", i));
        },
        error: function(i) {
          var o = n.sub;
          o !== null && (o && setTimeout(function() {
            return o.unsubscribe();
          }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), qt(n.observers, "error", i));
        },
        complete: function() {
          var i = n, o = i.sub, a = i.sources, s = a === void 0 ? [] : a;
          if (o !== null) {
            var u = s.shift();
            u ? bi(u) ? u.then(function(c) {
              return n.sub = c.subscribe(n.handlers);
            }, n.handlers.error) : n.sub = u.subscribe(n.handlers) : (o && setTimeout(function() {
              return o.unsubscribe();
            }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), qt(n.observers, "complete"));
          }
        }
      }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
        n.reject(i), n.sources = [], n.handlers.error(i);
      }, n.promise.catch(function(i) {
      }), typeof r == "function" && (r = [new Q(r)]), bi(r) ? r.then(function(i) {
        return n.start(i);
      }, n.handlers.error) : n.start(r), n;
    }
    return t.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var n = this.latest[0], i = r[n];
        i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
      }
    }, t.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, t.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(r, n) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(o) {
        return o(r, n);
      }));
    }, t.prototype.beforeNext = function(r) {
      var n = !1;
      this.nextResultListeners.add(function(i, o) {
        n || (n = !0, r(i, o));
      });
    }, t;
  })(Q)
);
ra(st);
function vt(e) {
  return "incremental" in e;
}
function cc(e) {
  return "hasNext" in e && "data" in e;
}
function lc(e) {
  return vt(e) || cc(e);
}
function fc(e) {
  return W(e) && "payload" in e;
}
function na(e, t) {
  var r = e, n = new Qe();
  return vt(t) && Ie(t.incremental) && t.incremental.forEach(function(i) {
    for (var o = i.data, a = i.path, s = a.length - 1; s >= 0; --s) {
      var u = a[s], c = !isNaN(+u), l = c ? [] : {};
      l[u] = o, o = l;
    }
    r = n.merge(r, o);
  }), r;
}
function sr(e) {
  var t = un(e);
  return Ie(t);
}
function un(e) {
  var t = Ie(e.errors) ? e.errors.slice(0) : [];
  return vt(e) && Ie(e.incremental) && e.incremental.forEach(function(r) {
    r.errors && t.push.apply(t, r.errors);
  }), t;
}
function kt() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var o = n[i];
      o !== void 0 && (r[i] = o);
    });
  }), r;
}
function jr(e, t) {
  return kt(e, t, t.variables && {
    variables: kt(v(v({}, e && e.variables), t.variables))
  });
}
var $r, hc = Symbol.for("apollo.deprecations"), _i = Symbol.for("apollo.deprecations.slot"), cn = fr, ln = ($r = cn[_i]) !== null && $r !== void 0 ? $r : cn[_i] = new Rt();
function dc(e) {
  return cn[hc] || (ln.getValue() || []).includes(e);
}
function fe(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return ln.withValue.apply(ln, ue([Array.isArray(e) ? e : [e]], t, !1));
}
function re(e, t, r, n) {
  n === void 0 && (n = "Please remove this option."), tt(t, function() {
    t in e && globalThis.__DEV__ !== !1 && I.warn(103, r, t, n);
  });
}
function tt(e, t) {
  dc(e) || t();
}
function Lr(e) {
  return new Q(function(t) {
    t.error(e);
  });
}
var ia = function(e, t, r) {
  var n = new Error(r);
  throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
};
function pc(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var i = n[r];
    if (t.indexOf(i) < 0)
      throw ve(58, i);
  }
  return e;
}
function vc(e, t) {
  var r = v({}, e), n = function(o) {
    typeof o == "function" ? r = v(v({}, r), o(r)) : r = v(v({}, r), o);
  }, i = function() {
    return v({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function yc(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? jt(t.query) || void 0 : ""), t;
}
function mc(e, t) {
  var r = v({}, e), n = new Set(Object.keys(e));
  return Te(t, {
    Variable: function(i, o, a) {
      a && a.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete r[i];
  }), r;
}
function wi(e, t) {
  return t ? t(e) : Q.of();
}
function At(e) {
  return typeof e == "function" ? new Je(e) : e;
}
function er(e) {
  return e.request.length <= 1;
}
var Je = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Q.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(At).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var i = At(r), o = At(n || new e(wi)), a;
      return er(i) && er(o) ? a = new e(function(s) {
        return t(s) ? i.request(s) || Q.of() : o.request(s) || Q.of();
      }) : a = new e(function(s, u) {
        return t(s) ? i.request(s, u) || Q.of() : o.request(s, u) || Q.of();
      }), Object.assign(a, { left: i, right: o });
    }, e.execute = function(t, r) {
      return t.request(vc(r.context, yc(pc(r)))) || Q.of();
    }, e.concat = function(t, r) {
      var n = At(t);
      if (er(n))
        return globalThis.__DEV__ !== !1 && I.warn(47, n), n;
      var i = At(r), o;
      return er(i) ? o = new e(function(a) {
        return n.request(a, function(s) {
          return i.request(s) || Q.of();
        }) || Q.of();
      }) : o = new e(function(a, s) {
        return n.request(a, function(u) {
          return i.request(u, s) || Q.of();
        }) || Q.of();
      }), Object.assign(o, { left: n, right: i });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(wi)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw ve(48);
    }, e.prototype.onError = function(t, r) {
      if (globalThis.__DEV__ !== !1 && tt("onError", function() {
        globalThis.__DEV__ !== !1 && I.warn(49);
      }), r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && I.warn(50), this.onError = t, this;
    }, e;
  })()
), gc = Je.from, bc = Je.split, fn = Je.execute;
function _c(e) {
  var t, r = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return r.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function wc(e) {
  var t = null, r = null, n = !1, i = [], o = [];
  function a(f) {
    if (!r) {
      if (o.length) {
        var d = o.shift();
        if (Array.isArray(d) && d[0])
          return d[0]({ value: f, done: !1 });
      }
      i.push(f);
    }
  }
  function s(f) {
    r = f;
    var d = o.slice();
    d.forEach(function(h) {
      h[1](f);
    }), !t || t();
  }
  function u() {
    n = !0;
    var f = o.slice();
    f.forEach(function(d) {
      d[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", a), e.removeListener("error", s), e.removeListener("end", u), e.removeListener("finish", u), e.removeListener("close", u);
  }, e.on("data", a), e.on("error", s), e.on("end", u), e.on("finish", u), e.on("close", u);
  function c() {
    return new Promise(function(f, d) {
      if (r)
        return d(r);
      if (i.length)
        return f({ value: i.shift(), done: !1 });
      if (n)
        return f({ value: void 0, done: !0 });
      o.push([f, d]);
    });
  }
  var l = {
    next: function() {
      return c();
    }
  };
  return kr && (l[Symbol.asyncIterator] = function() {
    return this;
  }), l;
}
function kc(e) {
  var t = !1, r = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(n, i) {
        e.then(function(o) {
          n({ value: o, done: !1 });
        }).catch(i);
      }));
    }
  };
  return kr && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function ki(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return kr && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function Ec(e) {
  return !!e.body;
}
function Sc(e) {
  return !!e.getReader;
}
function Oc(e) {
  return !!(kr && e[Symbol.asyncIterator]);
}
function Tc(e) {
  return !!e.stream;
}
function Dc(e) {
  return !!e.arrayBuffer;
}
function Ic(e) {
  return !!e.pipe;
}
function zc(e) {
  var t = e;
  if (Ec(e) && (t = e.body), Oc(t))
    return _c(t);
  if (Sc(t))
    return ki(t.getReader());
  if (Tc(t))
    return ki(t.stream().getReader());
  if (Dc(t))
    return kc(t.arrayBuffer());
  if (Ic(t))
    return wc(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var xn = Symbol();
function Rc(e) {
  return e.extensions ? Array.isArray(e.extensions[xn]) : !1;
}
function oa(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var Pc = function(e) {
  var t = ue(ue(ue([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return W(r) && r.message || "Error message not found.";
  }).join(`
`);
}, $e = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = r.graphQLErrors, i = r.protocolErrors, o = r.clientErrors, a = r.networkError, s = r.errorMessage, u = r.extraInfo, c = e.call(this, s) || this;
      return c.name = "ApolloError", c.graphQLErrors = n || [], c.protocolErrors = i || [], c.clientErrors = o || [], c.networkError = a || null, c.message = s || Pc(c), c.extraInfo = u, c.cause = ue(ue(ue([
        a
      ], n || [], !0), i || [], !0), o || [], !0).find(function(l) {
        return !!l;
      }) || null, c.__proto__ = t.prototype, c;
    }
    return t;
  })(Error)
), Ei = Object.prototype.hasOwnProperty;
function Fc(e, t) {
  return xe(this, void 0, void 0, function() {
    var r, n, i, o, a, s, u, c, l, f, d, h, p, y, b, m, _, k, S, O, T, F, P, x;
    return Me(this, function(L) {
      switch (L.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), n = (x = e.headers) === null || x === void 0 ? void 0 : x.get("content-type"), i = "boundary=", o = n != null && n.includes(i) ? n == null ? void 0 : n.substring((n == null ? void 0 : n.indexOf(i)) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", a = `\r
--`.concat(o), s = "", u = zc(e), c = !0, L.label = 1;
        case 1:
          return c ? [4, u.next()] : [3, 3];
        case 2:
          for (l = L.sent(), f = l.value, d = l.done, h = typeof f == "string" ? f : r.decode(f), p = s.length - a.length + 1, c = !d, s += h, y = s.indexOf(a, p); y > -1; ) {
            if (b = void 0, F = [
              s.slice(0, y),
              s.slice(y + a.length)
            ], b = F[0], s = F[1], m = b.indexOf(`\r
\r
`), _ = Nc(b.slice(0, m)), k = _["content-type"], k && k.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (S = b.slice(m), S) {
              if (O = aa(e, S), Object.keys(O).length > 1 || "data" in O || "incremental" in O || "errors" in O || "payload" in O)
                if (fc(O)) {
                  if (T = {}, "payload" in O) {
                    if (Object.keys(O).length === 1 && O.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    T = v({}, O.payload);
                  }
                  "errors" in O && (T = v(v({}, T), { extensions: v(v({}, "extensions" in T ? T.extensions : null), (P = {}, P[xn] = O.errors, P)) })), t(T);
                } else
                  t(O);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(O).length === 1 && "hasNext" in O && !O.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            y = s.indexOf(a);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Nc(e) {
  var t = {};
  return e.split(`
`).forEach(function(r) {
    var n = r.indexOf(":");
    if (n > -1) {
      var i = r.slice(0, n).trim().toLowerCase(), o = r.slice(n + 1).trim();
      t[i] = o;
    }
  }), t;
}
function aa(e, t) {
  if (e.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    ia(e, r(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
  }
}
function Cc(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function Ac(e) {
  return function(t) {
    return t.text().then(function(r) {
      return aa(t, r);
    }).then(function(r) {
      return !Array.isArray(r) && !Ei.call(r, "data") && !Ei.call(r, "errors") && ia(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
        return n.operationName;
      }) : e.operationName, "'.")), r;
    });
  };
}
var hn = function(e, t) {
  var r;
  try {
    r = JSON.stringify(e);
  } catch (i) {
    var n = ve(54, t, i.message);
    throw n.parseError = i, n;
  }
  return r;
}, xc = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, Mc = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, jc = {
  method: "POST"
}, $c = {
  http: xc,
  headers: Mc,
  options: jc
}, Lc = function(e, t) {
  return t(e);
};
function Vc(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var i = {}, o = {};
  r.forEach(function(f) {
    i = v(v(v({}, i), f.options), { headers: v(v({}, i.headers), f.headers) }), f.credentials && (i.credentials = f.credentials), o = v(v({}, o), f.http);
  }), i.headers && (i.headers = qc(i.headers, o.preserveHeaderCase));
  var a = e.operationName, s = e.extensions, u = e.variables, c = e.query, l = { operationName: a, variables: u };
  return o.includeExtensions && (l.extensions = s), o.includeQuery && (l.query = t(c, Le)), {
    options: i,
    body: l
  };
}
function qc(e, t) {
  if (!t) {
    var r = {};
    return Object.keys(Object(e)).forEach(function(o) {
      r[o.toLowerCase()] = e[o];
    }), r;
  }
  var n = {};
  Object.keys(Object(e)).forEach(function(o) {
    n[o.toLowerCase()] = {
      originalName: o,
      value: e[o]
    };
  });
  var i = {};
  return Object.keys(n).forEach(function(o) {
    i[n[o].originalName] = n[o].value;
  }), i;
}
var Zc = function(e) {
  if (!e && typeof fetch > "u")
    throw ve(51);
}, Qc = function(e, t) {
  var r = e.getContext(), n = r.uri;
  return n || (typeof t == "function" ? t(e) : t || "/graphql");
};
function Uc(e, t) {
  var r = [], n = function(f, d) {
    r.push("".concat(f, "=").concat(encodeURIComponent(d)));
  };
  if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = hn(t.variables, "Variables map");
    } catch (f) {
      return { parseError: f };
    }
    n("variables", i);
  }
  if (t.extensions) {
    var o = void 0;
    try {
      o = hn(t.extensions, "Extensions map");
    } catch (f) {
      return { parseError: f };
    }
    n("extensions", o);
  }
  var a = "", s = e, u = e.indexOf("#");
  u !== -1 && (a = e.substr(u), s = e.substr(0, u));
  var c = s.indexOf("?") === -1 ? "?" : "&", l = s + c + r.join("&") + a;
  return { newURI: l };
}
var Si = Oe(function() {
  return fetch;
}), Bc = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, o = i === void 0 ? Lc : i, a = e.includeExtensions, s = e.preserveHeaderCase, u = e.useGETForQueries, c = e.includeUnusedVariables, l = c === void 0 ? !1 : c, f = Pe(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && Zc(n || Si);
  var d = {
    http: { includeExtensions: a, preserveHeaderCase: s },
    options: f.fetchOptions,
    credentials: f.credentials,
    headers: f.headers
  };
  return new Je(function(h) {
    var p = Qc(h, r), y = h.getContext(), b = {};
    if (y.clientAwareness) {
      var m = y.clientAwareness, _ = m.name, k = m.version;
      _ && (b["apollographql-client-name"] = _), k && (b["apollographql-client-version"] = k);
    }
    var S = v(v({}, b), y.headers), O = {
      http: y.http,
      options: y.fetchOptions,
      credentials: y.credentials,
      headers: S
    };
    if (Ut(["client"], h.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && I.warn(52);
      var T = Ho(h.query);
      if (!T)
        return Lr(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      h.query = T;
    }
    var F = Vc(h, o, $c, d, O), P = F.options, x = F.body;
    x.variables && !l && (x.variables = mc(x.variables, h.query));
    var L;
    !P.signal && typeof AbortController < "u" && (L = new AbortController(), P.signal = L.signal);
    var ke = function(A) {
      return A.kind === "OperationDefinition" && A.operation === "mutation";
    }, me = function(A) {
      return A.kind === "OperationDefinition" && A.operation === "subscription";
    }, ee = me(zt(h.query)), he = Ut(["defer"], h.query);
    if (u && !h.query.definitions.some(ke) && (P.method = "GET"), he || ee) {
      P.headers = P.headers || {};
      var C = "multipart/mixed;";
      ee && he && globalThis.__DEV__ !== !1 && I.warn(53), ee ? C += "boundary=graphql;subscriptionSpec=1.0,application/json" : he && (C += "deferSpec=20220824,application/json"), P.headers.accept = C;
    }
    if (P.method === "GET") {
      var U = Uc(p, x), N = U.newURI, M = U.parseError;
      if (M)
        return Lr(M);
      p = N;
    } else
      try {
        P.body = hn(x, "Payload");
      } catch (A) {
        return Lr(A);
      }
    return new Q(function(A) {
      var ce = n || Oe(function() {
        return fetch;
      }) || Si, $ = A.next.bind(A);
      return ce(p, P).then(function(de) {
        var Re;
        h.setContext({ response: de });
        var He = (Re = de.headers) === null || Re === void 0 ? void 0 : Re.get("content-type");
        return He !== null && /^multipart\/mixed/i.test(He) ? Fc(de, $) : Ac(h)(de).then($);
      }).then(function() {
        L = void 0, A.complete();
      }).catch(function(de) {
        L = void 0, Cc(de, A);
      }), function() {
        L && L.abort();
      };
    });
  });
}, sa = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, Bc(r).request) || this;
      return n.options = r, n;
    }
    return t;
  })(Je)
);
const { toString: Oi, hasOwnProperty: Wc } = Object.prototype, Ti = Function.prototype.toString, dn = /* @__PURE__ */ new Map();
function B(e, t) {
  try {
    return pn(e, t);
  } finally {
    dn.clear();
  }
}
function pn(e, t) {
  if (e === t)
    return !0;
  const r = Oi.call(e), n = Oi.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (Ii(e, t))
        return !0;
      const i = Di(e), o = Di(t), a = i.length;
      if (a !== o.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!Wc.call(t, i[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const u = i[s];
        if (!pn(e[u], t[u]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (Ii(e, t))
        return !0;
      const i = e.entries(), o = r === "[object Map]";
      for (; ; ) {
        const a = i.next();
        if (a.done)
          break;
        const [s, u] = a.value;
        if (!t.has(s) || o && !pn(u, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = Ti.call(e);
      return i !== Ti.call(t) ? !1 : !Kc(i, Gc);
    }
  }
  return !1;
}
function Di(e) {
  return Object.keys(e).filter(Jc, e);
}
function Jc(e) {
  return this[e] !== void 0;
}
const Gc = "{ [native code] }";
function Kc(e, t) {
  const r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function Ii(e, t) {
  let r = dn.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    dn.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
function ua(e, t, r, n) {
  var i = t.data, o = Pe(t, ["data"]), a = r.data, s = Pe(r, ["data"]);
  return B(o, s) && ur(zt(e).selectionSet, i, a, {
    fragmentMap: Tt(It(e)),
    variables: n
  });
}
function ur(e, t, r, n) {
  if (t === r)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(o) {
    if (i.has(o) || (i.add(o), !Kt(o, n.variables)) || zi(o))
      return !0;
    if (qe(o)) {
      var a = Ne(o), s = t && t[a], u = r && r[a], c = o.selectionSet;
      if (!c)
        return B(s, u);
      var l = Array.isArray(s), f = Array.isArray(u);
      if (l !== f)
        return !1;
      if (l && f) {
        var d = s.length;
        if (u.length !== d)
          return !1;
        for (var h = 0; h < d; ++h)
          if (!ur(c, s[h], u[h], n))
            return !1;
        return !0;
      }
      return ur(c, s, u, n);
    } else {
      var p = Er(o, n.fragmentMap);
      if (p)
        return zi(p) ? !0 : ur(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          r,
          n
        );
    }
  });
}
function zi(e) {
  return !!e.directives && e.directives.some(Hc);
}
function Hc(e) {
  return e.name.value === "nonreactive";
}
var ca = nt ? WeakMap : Map, la = Tn ? WeakSet : Set, Mn = new Rt(), Ri = !1;
function fa() {
  Ri || (Ri = !0, globalThis.__DEV__ !== !1 && I.warn(64));
}
function ha(e, t, r) {
  return Mn.withValue(!0, function() {
    var n = $t(e, t, r, !1);
    return Object.isFrozen(e) && pr(n), n;
  });
}
function Yc(e, t) {
  if (t.has(e))
    return t.get(e);
  var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, r), r;
}
function $t(e, t, r, n, i) {
  var o, a = r.knownChanged, s = Yc(e, r.mutableTargets);
  if (Array.isArray(e)) {
    for (var u = 0, c = Array.from(e.entries()); u < c.length; u++) {
      var l = c[u], f = l[0], d = l[1];
      if (d === null) {
        s[f] = null;
        continue;
      }
      var h = $t(d, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(f, "]") : void 0);
      a.has(h) && a.add(s), s[f] = h;
    }
    return a.has(s) ? s : e;
  }
  for (var p = 0, y = t.selections; p < y.length; p++) {
    var b = y[p], m = void 0;
    if (n && a.add(s), b.kind === K.FIELD) {
      var _ = Ne(b), k = b.selectionSet;
      if (m = s[_] || e[_], m === void 0)
        continue;
      if (k && m !== null) {
        var h = $t(e[_], k, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(_) : void 0);
        a.has(h) && (m = h);
      }
      globalThis.__DEV__ === !1 && (s[_] = m), globalThis.__DEV__ !== !1 && (n && _ !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((o = Object.getOwnPropertyDescriptor(s, _)) === null || o === void 0) && o.value) ? Object.defineProperty(s, _, Xc(_, m, i || "", r.operationName, r.operationType)) : (delete s[_], s[_] = m));
    }
    if (b.kind === K.INLINE_FRAGMENT && (!b.typeCondition || r.cache.fragmentMatches(b, e.__typename)) && (m = $t(e, b.selectionSet, r, n, i)), b.kind === K.FRAGMENT_SPREAD) {
      var S = b.name.value, O = r.fragmentMap[S] || (r.fragmentMap[S] = r.cache.lookupFragment(S));
      I(O, 59, S);
      var T = Gs(b);
      T !== "mask" && (m = $t(e, O.selectionSet, r, T === "migrate", i));
    }
    a.has(m) && a.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && a.add(s), a.has(s) ? s : e;
}
function Xc(e, t, r, n, i) {
  var o = function() {
    return Mn.getValue() || (globalThis.__DEV__ !== !1 && I.warn(60, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), o = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return o();
    },
    set: function(a) {
      o = function() {
        return a;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function da(e, t, r, n) {
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && fa(), e;
  var i = t.definitions.filter(function(a) {
    return a.kind === K.FRAGMENT_DEFINITION;
  });
  typeof n > "u" && (I(i.length === 1, 61, i.length), n = i[0].name.value);
  var o = i.find(function(a) {
    return a.name.value === n;
  });
  return I(!!o, 62, n), e == null || B(e, {}) ? e : ha(e, o.selectionSet, {
    operationType: "fragment",
    operationName: o.name.value,
    fragmentMap: Tt(It(t)),
    cache: r,
    mutableTargets: new ca(),
    knownChanged: new la()
  });
}
function el(e, t, r) {
  var n;
  if (!r.fragmentMatches)
    return globalThis.__DEV__ !== !1 && fa(), e;
  var i = rt(t);
  return I(i, 63), e == null ? e : ha(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
    fragmentMap: Tt(It(t)),
    cache: r,
    mutableTargets: new ca(),
    knownChanged: new la()
  });
}
var pa = (
  /** @class */
  (function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = Wt(tu, {
        max: Fe["cache.fragmentQueryDocuments"] || 1e3,
        cache: hr
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var r = this, n = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(r);
      }, n), i;
    }, e.prototype.recordOptimisticTransaction = function(t, r) {
      this.performTransaction(t, r);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && re(t, "canonizeResults", "cache.readQuery"), fe("canonizeResults", function() {
        return n.read(v(v({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: r }));
      });
    }, e.prototype.watchFragment = function(t) {
      var r = this, n = t.fragment, i = t.fragmentName, o = t.from, a = t.optimistic, s = a === void 0 ? !0 : a, u = Pe(t, ["fragment", "fragmentName", "from", "optimistic"]), c = this.getFragmentDoc(n, i), l = typeof o > "u" || typeof o == "string" ? o : this.identify(o), f = !!t[Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var d = i || xo(n).name.value;
        l || globalThis.__DEV__ !== !1 && I.warn(1, d);
      }
      var h = v(v({}, u), { returnPartialData: !0, id: l, query: c, optimistic: s }), p;
      return new Q(function(y) {
        return r.watch(v(v({}, h), { immediate: !0, callback: function(b) {
          var m = f ? da(b.result, n, r, i) : b.result;
          if (
            // Always ensure we deliver the first result
            !(p && ua(
              c,
              { data: p.result },
              { data: m },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var _ = {
              data: m,
              complete: !!b.complete
            };
            b.missing && (_.missing = Dr(b.missing.map(function(k) {
              return k.missing;
            }))), p = v(v({}, b), { result: m }), y.next(_);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, r) {
      var n = this;
      return r === void 0 && (r = !!t.optimistic), globalThis.__DEV__ !== !1 && re(t, "canonizeResults", "cache.readFragment"), fe("canonizeResults", function() {
        return n.read(v(v({}, t), { query: n.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: r }));
      });
    }, e.prototype.writeQuery = function(t) {
      var r = t.id, n = t.data, i = Pe(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: r || "ROOT_QUERY",
        result: n
      }));
    }, e.prototype.writeFragment = function(t) {
      var r = t.id, n = t.data, i = t.fragment, o = t.fragmentName, a = Pe(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(a, {
        query: this.getFragmentDoc(i, o),
        dataId: r,
        result: n
      }));
    }, e.prototype.updateQuery = function(t, r) {
      return globalThis.__DEV__ !== !1 && re(t, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(n) {
          var i = fe("canonizeResults", function() {
            return n.readQuery(t);
          }), o = r(i);
          return o == null ? i : (n.writeQuery(v(v({}, t), { data: o })), o);
        }
      });
    }, e.prototype.updateFragment = function(t, r) {
      return globalThis.__DEV__ !== !1 && re(t, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(n) {
          var i = fe("canonizeResults", function() {
            return n.readFragment(t);
          }), o = r(i);
          return o == null ? i : (n.writeFragment(v(v({}, t), { data: o })), o);
        }
      });
    }, e;
  })()
);
globalThis.__DEV__ !== !1 && (pa.prototype.getMemoryInternals = du);
var va = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r, n, i, o) {
      var a, s = e.call(this, r) || this;
      if (s.message = r, s.path = n, s.query = i, s.variables = o, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var u = s.path.length - 1; u >= 0; --u)
          s.missing = (a = {}, a[s.path[u]] = s.missing, a);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  })(Error)
), oe = Object.prototype.hasOwnProperty;
function xt(e) {
  return e == null;
}
function ya(e, t) {
  var r = e.__typename, n = e.id, i = e._id;
  if (typeof r == "string" && (t && (t.keyObject = xt(n) ? xt(i) ? void 0 : { _id: i } : { id: n }), xt(n) && !xt(i) && (n = i), !xt(n)))
    return "".concat(r, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var ma = {
  dataIdFromObject: ya,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function tl(e) {
  return kt(ma, e);
}
function ga(e) {
  var t = e.canonizeResults;
  return t === void 0 ? ma.canonizeResults : t;
}
function rl(e, t) {
  return q(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var ba = /^[_a-z][_0-9a-z]*/i;
function Ue(e) {
  var t = e.match(ba);
  return t ? t[0] : e;
}
function vn(e, t, r) {
  return W(t) ? te(t) ? t.every(function(n) {
    return vn(e, n, r);
  }) : e.selections.every(function(n) {
    if (qe(n) && Kt(n, r)) {
      var i = Ne(n);
      return oe.call(t, i) && (!n.selectionSet || vn(n.selectionSet, t[i], r));
    }
    return !0;
  }) : !1;
}
function ct(e) {
  return W(e) && !q(e) && !te(e);
}
function nl() {
  return new Qe();
}
function _a(e, t) {
  var r = Tt(It(e));
  return {
    fragmentMap: r,
    lookupFragment: function(n) {
      var i = r[n];
      return !i && t && (i = t.lookup(n)), i || null;
    }
  };
}
var cr = /* @__PURE__ */ Object.create(null), Vr = function() {
  return cr;
}, Pi = /* @__PURE__ */ Object.create(null), Jt = (
  /** @class */
  (function() {
    function e(t, r) {
      var n = this;
      this.policies = t, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
        return pr(q(i) ? n.get(i.__ref, o) : i && i[o]);
      }, this.canRead = function(i) {
        return q(i) ? n.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, o) {
        if (typeof i == "string")
          return pt(i);
        if (q(i))
          return i;
        var a = n.policies.identify(i)[0];
        if (a) {
          var s = pt(a);
          return o && n.merge(a, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return v({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, r) {
      if (this.group.depend(t, r), oe.call(this.data, t)) {
        var n = this.data[t];
        if (n && oe.call(n, r))
          return n[r];
      }
      if (r === "__typename" && oe.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof Ae)
        return this.parent.get(t, r);
    }, e.prototype.lookup = function(t, r) {
      if (r && this.group.depend(t, "__exists"), oe.call(this.data, t))
        return this.data[t];
      if (this instanceof Ae)
        return this.parent.lookup(t, r);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, r) {
      var n = this, i;
      q(t) && (t = t.__ref), q(r) && (r = r.__ref);
      var o = typeof t == "string" ? this.lookup(i = t) : t, a = typeof r == "string" ? this.lookup(i = r) : r;
      if (a) {
        I(typeof i == "string", 2);
        var s = new Qe(ol).merge(o, a);
        if (this.data[i] = s, s !== o && (delete this.refs[i], this.group.caching)) {
          var u = /* @__PURE__ */ Object.create(null);
          o || (u.__exists = 1), Object.keys(a).forEach(function(c) {
            if (!o || o[c] !== s[c]) {
              u[c] = 1;
              var l = Ue(c);
              l !== c && !n.policies.hasKeyArgs(s.__typename, l) && (u[l] = 1), s[c] === void 0 && !(n instanceof Ae) && delete s[c];
            }
          }), u.__typename && !(o && o.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete u.__typename, Object.keys(u).forEach(function(c) {
            return n.group.dirty(i, c);
          });
        }
      }
    }, e.prototype.modify = function(t, r) {
      var n = this, i = this.lookup(t);
      if (i) {
        var o = /* @__PURE__ */ Object.create(null), a = !1, s = !0, u = {
          DELETE: cr,
          INVALIDATE: Pi,
          isReference: q,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(c, l) {
            return n.policies.readField(typeof c == "string" ? {
              fieldName: c,
              from: l || pt(t)
            } : c, { store: n });
          }
        };
        if (Object.keys(i).forEach(function(c) {
          var l = Ue(c), f = i[c];
          if (f !== void 0) {
            var d = typeof r == "function" ? r : r[c] || r[l];
            if (d) {
              var h = d === Vr ? cr : d(pr(f), v(v({}, u), { fieldName: l, storeFieldName: c, storage: n.getStorage(t, c) }));
              if (h === Pi)
                n.group.dirty(t, c);
              else if (h === cr && (h = void 0), h !== f && (o[c] = h, a = !0, f = h, globalThis.__DEV__ !== !1)) {
                var p = function(O) {
                  if (n.lookup(O.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && I.warn(3, O), !0;
                };
                if (q(h))
                  p(h);
                else if (Array.isArray(h))
                  for (var y = !1, b = void 0, m = 0, _ = h; m < _.length; m++) {
                    var k = _[m];
                    if (q(k)) {
                      if (y = !0, p(k))
                        break;
                    } else if (typeof k == "object" && k) {
                      var S = n.policies.identify(k)[0];
                      S && (b = k);
                    }
                    if (y && b !== void 0) {
                      globalThis.__DEV__ !== !1 && I.warn(4, b);
                      break;
                    }
                  }
              }
            }
            f !== void 0 && (s = !1);
          }
        }), a)
          return this.merge(t, o), s && (this instanceof Ae ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, r, n) {
      var i, o = this.lookup(t);
      if (o) {
        var a = this.getFieldValue(o, "__typename"), s = r && n ? this.policies.getStoreFieldName({ typename: a, fieldName: r, args: n }) : r;
        return this.modify(t, s ? (i = {}, i[s] = Vr, i) : Vr);
      }
      return !1;
    }, e.prototype.evict = function(t, r) {
      var n = !1;
      return t.id && (oe.call(this.data, t.id) && (n = this.delete(t.id, t.fieldName, t.args)), this instanceof Ae && this !== r && (n = this.parent.evict(t, r) || n), (t.fieldName || n) && this.group.dirty(t.id, t.fieldName || "__exists")), n;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, r = this.toObject(), n = [];
      return this.getRootIdSet().forEach(function(i) {
        oe.call(t.policies.rootTypenamesById, i) || n.push(i);
      }), n.length && (r.__META = { extraRootIds: n.sort() }), r;
    }, e.prototype.replace = function(t) {
      var r = this;
      if (Object.keys(this.data).forEach(function(o) {
        t && oe.call(t, o) || r.delete(o);
      }), t) {
        var n = t.__META, i = Pe(t, ["__META"]);
        Object.keys(i).forEach(function(o) {
          r.merge(o, i[o]);
        }), n && n.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var r = --this.rootIds[t];
        return r || delete this.rootIds[t], r;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof Ae ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, r = this.getRootIdSet(), n = this.toObject();
      r.forEach(function(a) {
        oe.call(n, a) && (Object.keys(t.findChildRefIds(a)).forEach(r.add, r), delete n[a]);
      });
      var i = Object.keys(n);
      if (i.length) {
        for (var o = this; o instanceof Ae; )
          o = o.parent;
        i.forEach(function(a) {
          return o.delete(a);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!oe.call(this.refs, t)) {
        var r = this.refs[t] = /* @__PURE__ */ Object.create(null), n = this.data[t];
        if (!n)
          return r;
        var i = /* @__PURE__ */ new Set([n]);
        i.forEach(function(o) {
          q(o) && (r[o.__ref] = !0), W(o) && Object.keys(o).forEach(function(a) {
            var s = o[a];
            W(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  })()
), wa = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = null), this.caching = t, this.parent = r, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? Wo() : null, this.keyMaker = new Ce(nt);
    }, e.prototype.depend = function(t, r) {
      if (this.d) {
        this.d(qr(t, r));
        var n = Ue(r);
        n !== r && this.d(qr(t, n)), this.parent && this.parent.depend(t, r);
      }
    }, e.prototype.dirty = function(t, r) {
      this.d && this.d.dirty(
        qr(t, r),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        r === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  })()
);
function qr(e, t) {
  return t + "#" + e;
}
function Fi(e, t) {
  Zt(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    (function(r) {
      De(n, r);
      function n(i) {
        var o = i.policies, a = i.resultCaching, s = a === void 0 ? !0 : a, u = i.seed, c = r.call(this, o, new wa(s)) || this;
        return c.stump = new il(c), c.storageTrie = new Ce(nt), u && c.replace(u), c;
      }
      return n.prototype.addLayer = function(i, o) {
        return this.stump.addLayer(i, o);
      }, n.prototype.removeLayer = function() {
        return this;
      }, n.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, n;
    })(e)
  );
  e.Root = t;
})(Jt || (Jt = {}));
var Ae = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r, n, i, o) {
      var a = e.call(this, n.policies, o) || this;
      return a.id = r, a.parent = n, a.replay = i, a.group = o, i(a), a;
    }
    return t.prototype.addLayer = function(r, n) {
      return new t(r, this, n, this.group);
    }, t.prototype.removeLayer = function(r) {
      var n = this, i = this.parent.removeLayer(r);
      return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
        var a = n.data[o], s = i.lookup(o);
        s ? a ? a !== s && Object.keys(a).forEach(function(u) {
          B(a[u], s[u]) || n.group.dirty(o, u);
        }) : (n.group.dirty(o, "__exists"), Object.keys(s).forEach(function(u) {
          n.group.dirty(o, u);
        })) : n.delete(o);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return v(v({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(r) {
      var n = this.parent.findChildRefIds(r);
      return oe.call(this.data, r) ? v(v({}, n), e.prototype.findChildRefIds.call(this, r)) : n;
    }, t.prototype.getStorage = function() {
      for (var r = this.parent; r.parent; )
        r = r.parent;
      return r.getStorage.apply(
        r,
        // @ts-expect-error
        arguments
      );
    }, t;
  })(Jt)
), il = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      return e.call(this, "EntityStore.Stump", r, function() {
      }, new wa(r.group.caching, r.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(r, n) {
      return this.parent.merge(r, n);
    }, t;
  })(Ae)
);
function ol(e, t, r) {
  var n = e[r], i = t[r];
  return B(n, i) ? n : i;
}
function Zt(e) {
  return !!(e instanceof Jt && e.group.caching);
}
function al(e) {
  return W(e) ? te(e) ? e.slice(0) : v({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var Ni = (
  /** @class */
  (function() {
    function e() {
      this.known = new (Tn ? WeakSet : Set)(), this.pool = new Ce(nt), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return W(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (W(t)) {
        var r = al(t);
        return this.passes.set(r, t), r;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var r = this;
      if (W(t)) {
        var n = this.passes.get(t);
        if (n)
          return n;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var o = t.map(this.admit, this), a = this.pool.lookupArray(o);
            return a.array || (this.known.add(a.array = o), globalThis.__DEV__ !== !1 && Object.freeze(o)), a.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), u = [s], c = this.sortedKeys(t);
            u.push(c.json);
            var l = u.length;
            c.sorted.forEach(function(h) {
              u.push(r.admit(t[h]));
            });
            var a = this.pool.lookupArray(u);
            if (!a.object) {
              var f = a.object = Object.create(s);
              this.known.add(f), c.sorted.forEach(function(h, p) {
                f[h] = u[l + p];
              }), globalThis.__DEV__ !== !1 && Object.freeze(f);
            }
            return a.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var r = Object.keys(t), n = this.pool.lookupArray(r);
      if (!n.keys) {
        r.sort();
        var i = JSON.stringify(r);
        (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: r, json: i });
      }
      return n.keys;
    }, e;
  })()
);
function Ci(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var sl = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.knownResults = new (nt ? WeakMap : Map)(), this.config = kt(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: ga(t)
      }), this.canon = t.canon || new Ni(), this.executeSelectionSet = Wt(function(n) {
        var i, o = n.context.canonizeResults, a = Ci(n);
        a[3] = !o;
        var s = (i = r.executeSelectionSet).peek.apply(i, a);
        return s ? o ? v(v({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: r.canon.admit(s.result)
        }) : s : (Fi(n.context.store, n.enclosingRef.__ref), r.execSelectionSetImpl(n));
      }, {
        max: this.config.resultCacheMaxSize || Fe["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: Ci,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(n, i, o, a) {
          if (Zt(o.store))
            return o.store.makeCacheKey(n, q(i) ? i.__ref : i, o.varString, a);
        }
      }), this.executeSubSelectedArray = Wt(function(n) {
        return Fi(n.context.store, n.enclosingRef.__ref), r.execSubSelectedArrayImpl(n);
      }, {
        max: this.config.resultCacheMaxSize || Fe["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(n) {
          var i = n.field, o = n.array, a = n.context;
          if (Zt(a.store))
            return a.store.makeCacheKey(i, o, a.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new Ni();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var r = t.store, n = t.query, i = t.rootId, o = i === void 0 ? "ROOT_QUERY" : i, a = t.variables, s = t.returnPartialData, u = s === void 0 ? !0 : s, c = t.canonizeResults, l = c === void 0 ? this.config.canonizeResults : c, f = this.config.cache.policies;
      a = v(v({}, Dn(Ao(n))), a);
      var d = pt(o), h = this.executeSelectionSet({
        selectionSet: zt(n).selectionSet,
        objectOrReference: d,
        enclosingRef: d,
        context: v({ store: r, query: n, policies: f, variables: a, varString: Ve(a), canonizeResults: l }, _a(n, this.config.fragments))
      }), p;
      if (h.missing && (p = [
        new va(ul(h.missing), h.missing, n, a)
      ], !u))
        throw p[0];
      return {
        result: h.result,
        complete: !p,
        missing: p
      };
    }, e.prototype.isFresh = function(t, r, n, i) {
      if (Zt(i.store) && this.knownResults.get(t) === n) {
        var o = this.executeSelectionSet.peek(
          n,
          r,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (o && t === o.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var r = this, n = t.selectionSet, i = t.objectOrReference, o = t.enclosingRef, a = t.context;
      if (q(i) && !a.policies.rootTypenamesById[i.__ref] && !a.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = a.variables, u = a.policies, c = a.store, l = c.getFieldValue(i, "__typename"), f = [], d, h = new Qe();
      this.config.addTypename && typeof l == "string" && !u.rootIdsByTypename[l] && f.push({ __typename: l });
      function p(k, S) {
        var O;
        return k.missing && (d = h.merge(d, (O = {}, O[S] = k.missing, O))), k.result;
      }
      var y = new Set(n.selections);
      y.forEach(function(k) {
        var S, O;
        if (Kt(k, s))
          if (qe(k)) {
            var T = u.readField({
              fieldName: k.name.value,
              field: k,
              variables: a.variables,
              from: i
            }, a), F = Ne(k);
            T === void 0 ? Pn.added(k) || (d = h.merge(d, (S = {}, S[F] = "Can't find field '".concat(k.name.value, "' on ").concat(q(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), S))) : te(T) ? T.length > 0 && (T = p(r.executeSubSelectedArray({
              field: k,
              array: T,
              enclosingRef: o,
              context: a
            }), F)) : k.selectionSet ? T != null && (T = p(r.executeSelectionSet({
              selectionSet: k.selectionSet,
              objectOrReference: T,
              enclosingRef: q(T) ? T : o,
              context: a
            }), F)) : a.canonizeResults && (T = r.canon.pass(T)), T !== void 0 && f.push((O = {}, O[F] = T, O));
          } else {
            var P = Er(k, a.lookupFragment);
            if (!P && k.kind === K.FRAGMENT_SPREAD)
              throw ve(10, k.name.value);
            P && u.fragmentMatches(P, l) && P.selectionSet.selections.forEach(y.add, y);
          }
      });
      var b = Dr(f), m = { result: b, missing: d }, _ = a.canonizeResults ? this.canon.admit(m) : pr(m);
      return _.result && this.knownResults.set(_.result, n), _;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var r = this, n = t.field, i = t.array, o = t.enclosingRef, a = t.context, s, u = new Qe();
      function c(l, f) {
        var d;
        return l.missing && (s = u.merge(s, (d = {}, d[f] = l.missing, d))), l.result;
      }
      return n.selectionSet && (i = i.filter(a.store.canRead)), i = i.map(function(l, f) {
        return l === null ? null : te(l) ? c(r.executeSubSelectedArray({
          field: n,
          array: l,
          enclosingRef: o,
          context: a
        }), f) : n.selectionSet ? c(r.executeSelectionSet({
          selectionSet: n.selectionSet,
          objectOrReference: l,
          enclosingRef: q(l) ? l : o,
          context: a
        }), f) : (globalThis.__DEV__ !== !1 && cl(a.store, n, l), l);
      }), {
        result: a.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  })()
);
function ul(e) {
  try {
    JSON.stringify(e, function(t, r) {
      if (typeof r == "string")
        throw r;
      return r;
    });
  } catch (t) {
    return t;
  }
}
function cl(e, t, r) {
  if (!t.selectionSet) {
    var n = /* @__PURE__ */ new Set([r]);
    n.forEach(function(i) {
      W(i) && (I(
        !q(i),
        11,
        rl(e, i),
        t.name.value
      ), Object.values(i).forEach(n.add, n));
    });
  }
}
var jn = new Rt(), Ai = /* @__PURE__ */ new WeakMap();
function Qt(e) {
  var t = Ai.get(e);
  return t || Ai.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: Wo()
  }), t;
}
function xi(e) {
  Qt(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function ll(e) {
  Qt(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function fl(e) {
  var t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = function(o) {
    if (arguments.length > 0) {
      if (e !== o) {
        e = o, t.forEach(function(u) {
          Qt(u).dep.dirty(n), hl(u);
        });
        var a = Array.from(r);
        r.clear(), a.forEach(function(u) {
          return u(e);
        });
      }
    } else {
      var s = jn.getValue();
      s && (i(s), Qt(s).dep(n));
    }
    return e;
  };
  n.onNextChange = function(o) {
    return r.add(o), function() {
      r.delete(o);
    };
  };
  var i = n.attachCache = function(o) {
    return t.add(o), Qt(o).vars.add(n), n;
  };
  return n.forgetCache = function(o) {
    return t.delete(o);
  }, n;
}
function hl(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var Mi = /* @__PURE__ */ Object.create(null);
function $n(e) {
  var t = JSON.stringify(e);
  return Mi[t] || (Mi[t] = /* @__PURE__ */ Object.create(null));
}
function ji(e) {
  var t = $n(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(r, n) {
    var i = function(a, s) {
      return n.readField(s, a);
    }, o = n.keyObject = Ln(e, function(a) {
      var s = yt(
        n.storeObject,
        a,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && r !== n.storeObject && oe.call(r, a[0]) && (s = yt(r, a, Ea)), I(s !== void 0, 5, a.join("."), r), s;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(o));
  });
}
function $i(e) {
  var t = $n(e);
  return t.keyArgsFn || (t.keyArgsFn = function(r, n) {
    var i = n.field, o = n.variables, a = n.fieldName, s = Ln(e, function(c) {
      var l = c[0], f = l.charAt(0);
      if (f === "@") {
        if (i && Ie(i.directives)) {
          var d = l.slice(1), h = i.directives.find(function(m) {
            return m.name.value === d;
          }), p = h && Sr(h, o);
          return p && yt(
            p,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            c.slice(1)
          );
        }
        return;
      }
      if (f === "$") {
        var y = l.slice(1);
        if (o && oe.call(o, y)) {
          var b = c.slice(0);
          return b[0] = y, yt(o, b);
        }
        return;
      }
      if (r)
        return yt(r, c);
    }), u = JSON.stringify(s);
    return (r || u !== "{}") && (a += ":" + u), a;
  });
}
function Ln(e, t) {
  var r = new Qe();
  return ka(e).reduce(function(n, i) {
    var o, a = t(i);
    if (a !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        a = (o = {}, o[i[s]] = a, o);
      n = r.merge(n, a);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function ka(e) {
  var t = $n(e);
  if (!t.paths) {
    var r = t.paths = [], n = [];
    e.forEach(function(i, o) {
      te(i) ? (ka(i).forEach(function(a) {
        return r.push(n.concat(a));
      }), n.length = 0) : (n.push(i), te(e[o + 1]) || (r.push(n.slice(0)), n.length = 0));
    });
  }
  return t.paths;
}
function Ea(e, t) {
  return e[t];
}
function yt(e, t, r) {
  return r = r || Ea, Sa(t.reduce(function n(i, o) {
    return te(i) ? i.map(function(a) {
      return n(a, o);
    }) : i && r(i, o);
  }, e));
}
function Sa(e) {
  return W(e) ? te(e) ? e.map(Sa) : Ln(Object.keys(e).sort(), function(t) {
    return yt(e, t);
  }) : e;
}
function yn(e) {
  return e.args !== void 0 ? e.args : e.field ? Sr(e.field, e.variables) : null;
}
var dl = function() {
}, Li = function(e, t) {
  return t.fieldName;
}, Vi = function(e, t, r) {
  var n = r.mergeObjects;
  return n(e, t);
}, qi = function(e, t) {
  return t;
}, pl = (
  /** @class */
  (function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = v({ dataIdFromObject: ya }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, r) {
      var n, i = this, o = r && (r.typename || ((n = r.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || t.__typename;
      if (o === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var a = r && r.storeObject || t, s = v(v({}, r), { typename: o, storeObject: a, readField: r && r.readField || function() {
        var f = Vn(arguments, a);
        return i.readField(f, {
          store: i.cache.data,
          variables: f.variables
        });
      } }), u, c = o && this.getTypePolicy(o), l = c && c.keyFn || this.config.dataIdFromObject;
      return Mn.withValue(!0, function() {
        for (; l; ) {
          var f = l(v(v({}, t), a), s);
          if (te(f))
            l = ji(f);
          else {
            u = f;
            break;
          }
        }
      }), u = u ? String(u) : void 0, s.keyObject ? [u, s.keyObject] : [u];
    }, e.prototype.addTypePolicies = function(t) {
      var r = this;
      Object.keys(t).forEach(function(n) {
        var i = t[n], o = i.queryType, a = i.mutationType, s = i.subscriptionType, u = Pe(i, ["queryType", "mutationType", "subscriptionType"]);
        o && r.setRootTypename("Query", n), a && r.setRootTypename("Mutation", n), s && r.setRootTypename("Subscription", n), oe.call(r.toBeAdded, n) ? r.toBeAdded[n].push(u) : r.toBeAdded[n] = [u];
      });
    }, e.prototype.updateTypePolicy = function(t, r, n) {
      var i = this.getTypePolicy(t), o = r.keyFields, a = r.fields;
      function s(u, c) {
        u.merge = typeof c == "function" ? c : c === !0 ? Vi : c === !1 ? qi : u.merge;
      }
      s(i, r.merge), i.keyFn = // Pass false to disable normalization for this typename.
      o === !1 ? dl : te(o) ? ji(o) : typeof o == "function" ? o : i.keyFn, a && Object.keys(a).forEach(function(u) {
        var c = n[u];
        (!c || (c == null ? void 0 : c.typename) !== t) && (c = n[u] = { typename: t });
        var l = a[u];
        if (typeof l == "function")
          c.read = l;
        else {
          var f = l.keyArgs, d = l.read, h = l.merge;
          c.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          f === !1 ? Li : te(f) ? $i(f) : typeof f == "function" ? f : c.keyFn, typeof d == "function" && (c.read = d), s(c, h);
        }
        c.read && c.merge && (c.keyFn = c.keyFn || Li);
      });
    }, e.prototype.setRootTypename = function(t, r) {
      r === void 0 && (r = t);
      var n = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[n];
      r !== i && (I(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[r] = n, this.rootTypenamesById[n] = r);
    }, e.prototype.addPossibleTypes = function(t) {
      var r = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(n) {
        r.getSupertypeSet(n, !0), t[n].forEach(function(i) {
          r.getSupertypeSet(i, !0).add(n);
          var o = i.match(ba);
          (!o || o[0] !== i) && r.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var r = this;
      if (!oe.call(this.typePolicies, t)) {
        var n = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        n.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(a, s) {
          if (a.test(t)) {
            var u = r.supertypeMap.get(s);
            u && u.forEach(function(c) {
              return i.add(c);
            });
          }
        })), i && i.size && i.forEach(function(a) {
          var s = r.getTypePolicy(a), u = s.fields, c = Pe(s, ["fields"]);
          Object.assign(n, c), Object.assign(n.fields, u);
        });
      }
      var o = this.toBeAdded[t];
      return o && o.length && o.splice(0).forEach(function(a) {
        r.updateTypePolicy(t, a, r.typePolicies[t].fields);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, r) {
      if (t)
        return this.getTypePolicy(t).fields[r];
    }, e.prototype.getSupertypeSet = function(t, r) {
      var n = this.supertypeMap.get(t);
      return !n && r && this.supertypeMap.set(t, n = /* @__PURE__ */ new Set()), n;
    }, e.prototype.fragmentMatches = function(t, r, n, i) {
      var o = this;
      if (!t.typeCondition)
        return !0;
      if (!r)
        return !1;
      var a = t.typeCondition.name.value;
      if (r === a)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(a))
        for (var s = this.getSupertypeSet(r, !0), u = [s], c = function(p) {
          var y = o.getSupertypeSet(p, !1);
          y && y.size && u.indexOf(y) < 0 && u.push(y);
        }, l = !!(n && this.fuzzySubtypes.size), f = !1, d = 0; d < u.length; ++d) {
          var h = u[d];
          if (h.has(a))
            return s.has(a) || (f && globalThis.__DEV__ !== !1 && I.warn(7, r, a), s.add(a)), !0;
          h.forEach(c), l && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          d === u.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          vn(t.selectionSet, n, i) && (l = !1, f = !0, this.fuzzySubtypes.forEach(function(p, y) {
            var b = r.match(p);
            b && b[0] === r && c(y);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return !!(n && n.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var r = t.typename, n = t.fieldName, i = this.getFieldPolicy(r, n), o, a = i && i.keyFn;
      if (a && r)
        for (var s = {
          typename: r,
          fieldName: n,
          field: t.field || null,
          variables: t.variables
        }, u = yn(t); a; ) {
          var c = a(u, s);
          if (te(c))
            a = $i(c);
          else {
            o = c || n;
            break;
          }
        }
      return o === void 0 && (o = t.field ? Ru(t.field, t.variables) : Co(n, yn(t))), o === !1 ? n : n === Ue(o) ? o : n + ":" + o;
    }, e.prototype.readField = function(t, r) {
      var n = t.from;
      if (n) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var o = r.store.getFieldValue(n, "__typename");
            o && (t.typename = o);
          }
          var a = this.getStoreFieldName(t), s = Ue(a), u = r.store.getFieldValue(n, a), c = this.getFieldPolicy(t.typename, s), l = c && c.read;
          if (l) {
            var f = Zi(this, n, t, r, r.store.getStorage(q(n) ? n.__ref : n, a));
            return jn.withValue(this.cache, l, [
              u,
              f
            ]);
          }
          return u;
        }
      }
    }, e.prototype.getReadFunction = function(t, r) {
      var n = this.getFieldPolicy(t, r);
      return n && n.read;
    }, e.prototype.getMergeFunction = function(t, r, n) {
      var i = this.getFieldPolicy(t, r), o = i && i.merge;
      return !o && n && (i = this.getTypePolicy(n), o = i && i.merge), o;
    }, e.prototype.runMergeFunction = function(t, r, n, i, o) {
      var a = n.field, s = n.typename, u = n.merge;
      return u === Vi ? Oa(i.store)(t, r) : u === qi ? r : (i.overwrite && (t = void 0), u(t, r, Zi(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: a.name.value,
          field: a,
          variables: i.variables
        },
        i,
        o || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  })()
);
function Zi(e, t, r, n, i) {
  var o = e.getStoreFieldName(r), a = Ue(o), s = r.variables || n.variables, u = n.store, c = u.toReference, l = u.canRead;
  return {
    args: yn(r),
    field: r.field || null,
    fieldName: a,
    storeFieldName: o,
    variables: s,
    isReference: q,
    toReference: c,
    storage: i,
    cache: e.cache,
    canRead: l,
    readField: function() {
      return e.readField(Vn(arguments, t, s), n);
    },
    mergeObjects: Oa(n.store)
  };
}
function Vn(e, t, r) {
  var n = e[0], i = e[1], o = e.length, a;
  return typeof n == "string" ? a = {
    fieldName: n,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: o > 1 ? i : t
  } : (a = v({}, n), oe.call(a, "from") || (a.from = t)), globalThis.__DEV__ !== !1 && a.from === void 0 && globalThis.__DEV__ !== !1 && I.warn(8, Eo(Array.from(e))), a.variables === void 0 && (a.variables = r), a;
}
function Oa(e) {
  return function(r, n) {
    if (te(r) || te(n))
      throw ve(9);
    if (W(r) && W(n)) {
      var i = e.getFieldValue(r, "__typename"), o = e.getFieldValue(n, "__typename"), a = i && o && i !== o;
      if (a)
        return n;
      if (q(r) && ct(n))
        return e.merge(r.__ref, n), r;
      if (ct(r) && q(n))
        return e.merge(r, n.__ref), n;
      if (ct(r) && ct(n))
        return v(v({}, r), n);
    }
    return n;
  };
}
function Zr(e, t, r) {
  var n = "".concat(t).concat(r), i = e.flavors.get(n);
  return i || e.flavors.set(n, i = e.clientOnly === t && e.deferred === r ? e : v(v({}, e), { clientOnly: t, deferred: r })), i;
}
var vl = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.cache = t, this.reader = r, this.fragments = n;
    }
    return e.prototype.writeToStore = function(t, r) {
      var n = this, i = r.query, o = r.result, a = r.dataId, s = r.variables, u = r.overwrite, c = rt(i), l = nl();
      s = v(v({}, Dn(c)), s);
      var f = v(v({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(h, p) {
        return l.merge(h, p);
      }, variables: s, varString: Ve(s) }, _a(i, this.fragments)), { overwrite: !!u, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), d = this.processSelectionSet({
        result: o || /* @__PURE__ */ Object.create(null),
        dataId: a,
        selectionSet: c.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: f
      });
      if (!q(d))
        throw ve(12, o);
      return f.incomingById.forEach(function(h, p) {
        var y = h.storeObject, b = h.mergeTree, m = h.fieldNodeSet, _ = pt(p);
        if (b && b.map.size) {
          var k = n.applyMerges(b, _, y, f);
          if (q(k))
            return;
          y = k;
        }
        if (globalThis.__DEV__ !== !1 && !f.overwrite) {
          var S = /* @__PURE__ */ Object.create(null);
          m.forEach(function(F) {
            F.selectionSet && (S[F.name.value] = !0);
          });
          var O = function(F) {
            return S[Ue(F)] === !0;
          }, T = function(F) {
            var P = b && b.map.get(F);
            return !!(P && P.info && P.info.merge);
          };
          Object.keys(y).forEach(function(F) {
            O(F) && !T(F) && yl(_, y, F, f.store);
          });
        }
        t.merge(p, y);
      }), t.retain(d.__ref), d;
    }, e.prototype.processSelectionSet = function(t) {
      var r = this, n = t.dataId, i = t.result, o = t.selectionSet, a = t.context, s = t.mergeTree, u = this.cache.policies, c = /* @__PURE__ */ Object.create(null), l = n && u.rootTypenamesById[n] || nn(i, o, a.fragmentMap) || n && a.store.get(n, "__typename");
      typeof l == "string" && (c.__typename = l);
      var f = function() {
        var k = Vn(arguments, c, a.variables);
        if (q(k.from)) {
          var S = a.incomingById.get(k.from.__ref);
          if (S) {
            var O = u.readField(v(v({}, k), { from: S.storeObject }), a);
            if (O !== void 0)
              return O;
          }
        }
        return u.readField(k, a);
      }, d = /* @__PURE__ */ new Set();
      this.flattenFields(
        o,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        a,
        l
      ).forEach(function(k, S) {
        var O, T = Ne(S), F = i[T];
        if (d.add(S), F !== void 0) {
          var P = u.getStoreFieldName({
            typename: l,
            fieldName: S.name.value,
            field: S,
            variables: k.variables
          }), x = Qi(s, P), L = r.processFieldValue(
            F,
            S,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            S.selectionSet ? Zr(k, !1, !1) : k,
            x
          ), ke = void 0;
          S.selectionSet && (q(L) || ct(L)) && (ke = f("__typename", L));
          var me = u.getMergeFunction(l, S.name.value, ke);
          me ? x.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: S,
            typename: l,
            merge: me
          } : Ui(s, P), c = k.merge(c, (O = {}, O[P] = L, O));
        } else globalThis.__DEV__ !== !1 && !k.clientOnly && !k.deferred && !Pn.added(S) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !u.getReadFunction(l, S.name.value) && globalThis.__DEV__ !== !1 && I.error(13, Ne(S), i);
      });
      try {
        var h = u.identify(i, {
          typename: l,
          selectionSet: o,
          fragmentMap: a.fragmentMap,
          storeObject: c,
          readField: f
        }), p = h[0], y = h[1];
        n = n || p, y && (c = a.merge(c, y));
      } catch (k) {
        if (!n)
          throw k;
      }
      if (typeof n == "string") {
        var b = pt(n), m = a.written[n] || (a.written[n] = []);
        if (m.indexOf(o) >= 0 || (m.push(o), this.reader && this.reader.isFresh(i, b, o, a)))
          return b;
        var _ = a.incomingById.get(n);
        return _ ? (_.storeObject = a.merge(_.storeObject, c), _.mergeTree = mn(_.mergeTree, s), d.forEach(function(k) {
          return _.fieldNodeSet.add(k);
        })) : a.incomingById.set(n, {
          storeObject: c,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: vr(s) ? void 0 : s,
          fieldNodeSet: d
        }), b;
      }
      return c;
    }, e.prototype.processFieldValue = function(t, r, n, i) {
      var o = this;
      return !r.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? ta(t) : t : te(t) ? t.map(function(a, s) {
        var u = o.processFieldValue(a, r, n, Qi(i, s));
        return Ui(i, s), u;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: r.selectionSet,
        context: n,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, r, n, i) {
      i === void 0 && (i = nn(r, t, n.fragmentMap));
      var o = /* @__PURE__ */ new Map(), a = this.cache.policies, s = new Ce(!1);
      return (function u(c, l) {
        var f = s.lookup(
          c,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          l.clientOnly,
          l.deferred
        );
        f.visited || (f.visited = !0, c.selections.forEach(function(d) {
          if (Kt(d, n.variables)) {
            var h = l.clientOnly, p = l.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(h && p) && Ie(d.directives) && d.directives.forEach(function(m) {
                var _ = m.name.value;
                if (_ === "client" && (h = !0), _ === "defer") {
                  var k = Sr(m, n.variables);
                  (!k || k.if !== !1) && (p = !0);
                }
              }), qe(d)
            ) {
              var y = o.get(d);
              y && (h = h && y.clientOnly, p = p && y.deferred), o.set(d, Zr(n, h, p));
            } else {
              var b = Er(d, n.lookupFragment);
              if (!b && d.kind === K.FRAGMENT_SPREAD)
                throw ve(14, d.name.value);
              b && a.fragmentMatches(b, i, r, n.variables) && u(b.selectionSet, Zr(n, h, p));
            }
          }
        }));
      })(t, n), o;
    }, e.prototype.applyMerges = function(t, r, n, i, o) {
      var a, s = this;
      if (t.map.size && !q(n)) {
        var u = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !te(n) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (q(r) || ct(r)) ? r : void 0
        ), c = n;
        u && !o && (o = [q(u) ? u.__ref : u]);
        var l, f = function(d, h) {
          return te(d) ? typeof h == "number" ? d[h] : void 0 : i.store.getFieldValue(d, String(h));
        };
        t.map.forEach(function(d, h) {
          var p = f(u, h), y = f(c, h);
          if (y !== void 0) {
            o && o.push(h);
            var b = s.applyMerges(d, p, y, i, o);
            b !== y && (l = l || /* @__PURE__ */ new Map(), l.set(h, b)), o && I(o.pop() === h);
          }
        }), l && (n = te(c) ? c.slice(0) : v({}, c), l.forEach(function(d, h) {
          n[h] = d;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(r, n, t.info, i, o && (a = i.store).getStorage.apply(a, o)) : n;
    }, e;
  })()
), Ta = [];
function Qi(e, t) {
  var r = e.map;
  return r.has(t) || r.set(t, Ta.pop() || { map: /* @__PURE__ */ new Map() }), r.get(t);
}
function mn(e, t) {
  if (e === t || !t || vr(t))
    return e;
  if (!e || vr(e))
    return t;
  var r = e.info && t.info ? v(v({}, e.info), t.info) : e.info || t.info, n = e.map.size && t.map.size, i = n ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, o = { info: r, map: i };
  if (n) {
    var a = new Set(t.map.keys());
    e.map.forEach(function(s, u) {
      o.map.set(u, mn(s, t.map.get(u))), a.delete(u);
    }), a.forEach(function(s) {
      o.map.set(s, mn(t.map.get(s), e.map.get(s)));
    });
  }
  return o;
}
function vr(e) {
  return !e || !(e.info || e.map.size);
}
function Ui(e, t) {
  var r = e.map, n = r.get(t);
  n && vr(n) && (Ta.push(n), r.delete(t));
}
var Bi = /* @__PURE__ */ new Set();
function yl(e, t, r, n) {
  var i = function(f) {
    var d = n.getFieldValue(f, r);
    return typeof d == "object" && d;
  }, o = i(e);
  if (o) {
    var a = i(t);
    if (a && !q(o) && !B(o, a) && !Object.keys(o).every(function(f) {
      return n.getFieldValue(a, f) !== void 0;
    })) {
      var s = n.getFieldValue(e, "__typename") || n.getFieldValue(t, "__typename"), u = Ue(r), c = "".concat(s, ".").concat(u);
      if (!Bi.has(c)) {
        Bi.add(c);
        var l = [];
        !te(o) && !te(a) && [o, a].forEach(function(f) {
          var d = n.getFieldValue(f, "__typename");
          typeof d == "string" && !l.includes(d) && l.push(d);
        }), globalThis.__DEV__ !== !1 && I.warn(15, u, s, l.length ? "either ensure all objects of type " + l.join(" and ") + " have an ID or a custom merge function, or " : "", c, v({}, o), v({}, a));
      }
    }
  }
}
var Da = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this) || this;
      return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new Jo(Pn), n.assumeImmutableResults = !0, n.makeVar = fl, n.txCount = 0, globalThis.__DEV__ !== !1 && (re(r, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), re(r, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), n.config = tl(r), n.addTypename = !!n.config.addTypename, n.policies = new pl({
        cache: n,
        dataIdFromObject: n.config.dataIdFromObject,
        possibleTypes: n.config.possibleTypes,
        typePolicies: n.config.typePolicies
      }), n.init(), n;
    }
    return t.prototype.init = function() {
      var r = this.data = new Jt.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = r.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(r) {
      var n = this, i = this.storeReader, o = this.config.fragments;
      this.addTypenameTransform.resetCache(), o == null || o.resetCaches(), this.storeWriter = new vl(this, this.storeReader = new sl({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: ga(this.config),
        canon: r ? void 0 : i && i.canon,
        fragments: o
      }), o), this.maybeBroadcastWatch = Wt(function(a, s) {
        return n.broadcastWatch(a, s);
      }, {
        max: this.config.resultCacheMaxSize || Fe["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(a) {
          var s = a.optimistic ? n.optimisticData : n.data;
          if (Zt(s)) {
            var u = a.optimistic, c = a.id, l = a.variables;
            return s.makeCacheKey(
              a.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              a.callback,
              Ve({ optimistic: u, id: c, variables: l })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(a) {
        return a.resetCaching();
      });
    }, t.prototype.restore = function(r) {
      return this.init(), r && this.data.replace(r), this;
    }, t.prototype.extract = function(r) {
      return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(r) {
      globalThis.__DEV__ !== !1 && re(r, "canonizeResults", "cache.read");
      var n = r.returnPartialData, i = n === void 0 ? !1 : n;
      try {
        return this.storeReader.diffQueryAgainstStore(v(v({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (o) {
        if (o instanceof va)
          return null;
        throw o;
      }
    }, t.prototype.write = function(r) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(r) {
      if (oe.call(r, "id") && !r.id)
        return !1;
      var n = r.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, n.modify(r.id || "ROOT_QUERY", r.fields);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(r) {
      return globalThis.__DEV__ !== !1 && re(r, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(v(v({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(r) {
      var n = this;
      return this.watches.size || ll(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
        n.watches.delete(r) && !n.watches.size && xi(n), n.maybeBroadcastWatch.forget(r);
      };
    }, t.prototype.gc = function(r) {
      globalThis.__DEV__ !== !1 && re(r || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), Ve.reset(), Le.reset();
      var n = this.optimisticData.gc();
      return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), n;
    }, t.prototype.retain = function(r, n) {
      return (n ? this.optimisticData : this.data).retain(r);
    }, t.prototype.release = function(r, n) {
      return (n ? this.optimisticData : this.data).release(r);
    }, t.prototype.identify = function(r) {
      if (q(r))
        return r.__ref;
      try {
        return this.policies.identify(r)[0];
      } catch (n) {
        globalThis.__DEV__ !== !1 && I.warn(n);
      }
    }, t.prototype.evict = function(r) {
      if (!r.id) {
        if (oe.call(r, "id"))
          return !1;
        r = v(v({}, r), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(r, this.data);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(r) {
      var n = this;
      return this.init(), Ve.reset(), r && r.discardWatches ? (this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), xi(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(r) {
      var n = this.optimisticData.removeLayer(r);
      n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
    }, t.prototype.batch = function(r) {
      var n = this, i = r.update, o = r.optimistic, a = o === void 0 ? !0 : o, s = r.removeOptimistic, u = r.onWatchUpdated, c, l = function(d) {
        var h = n, p = h.data, y = h.optimisticData;
        ++n.txCount, d && (n.data = n.optimisticData = d);
        try {
          return c = i(n);
        } finally {
          --n.txCount, n.data = p, n.optimisticData = y;
        }
      }, f = /* @__PURE__ */ new Set();
      return u && !this.txCount && this.broadcastWatches(v(v({}, r), { onWatchUpdated: function(d) {
        return f.add(d), !1;
      } })), typeof a == "string" ? this.optimisticData = this.optimisticData.addLayer(a, l) : a === !1 ? l(this.data) : l(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), u && f.size ? (this.broadcastWatches(v(v({}, r), { onWatchUpdated: function(d, h) {
        var p = u.call(this, d, h);
        return p !== !1 && f.delete(d), p;
      } })), f.size && f.forEach(function(d) {
        return n.maybeBroadcastWatch.dirty(d);
      })) : this.broadcastWatches(r), c;
    }, t.prototype.performTransaction = function(r, n) {
      return this.batch({
        update: r,
        optimistic: n || n !== null
      });
    }, t.prototype.transformDocument = function(r) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(r));
    }, t.prototype.fragmentMatches = function(r, n) {
      return this.policies.fragmentMatches(r, n);
    }, t.prototype.lookupFragment = function(r) {
      var n;
      return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(r)) || null;
    }, t.prototype.broadcastWatches = function(r) {
      var n = this;
      this.txCount || this.watches.forEach(function(i) {
        return n.maybeBroadcastWatch(i, r);
      });
    }, t.prototype.addFragmentsToDocument = function(r) {
      var n = this.config.fragments;
      return n ? n.transform(r) : r;
    }, t.prototype.addTypenameToDocument = function(r) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
    }, t.prototype.broadcastWatch = function(r, n) {
      var i = this, o = r.lastDiff, a = fe("canonizeResults", function() {
        return i.diff(r);
      });
      n && (r.optimistic && typeof n.optimistic == "string" && (a.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, r, a, o) === !1) || (!o || !B(o.result, a.result)) && r.callback(r.lastDiff = a, o);
    }, t;
  })(pa)
);
globalThis.__DEV__ !== !1 && (Da.prototype.getMemoryInternals = hu);
var V;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(V || (V = {}));
function lt(e) {
  return e ? e < 7 : !1;
}
var Wi = Object.assign, ml = Object.hasOwnProperty, lr = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = r.queryManager, i = r.queryInfo, o = r.options, a = this, s = t.inactiveOnCreation.getValue();
      a = e.call(this, function(m) {
        a._getOrCreateQuery();
        try {
          var _ = m._subscription._observer;
          _ && !_.error && (_.error = gl);
        } catch {
        }
        var k = !a.observers.size;
        a.observers.add(m);
        var S = a.last;
        return S && S.error ? m.error && m.error(S.error) : S && S.result && m.next && m.next(a.maskResult(S.result)), k && a.reobserve().catch(function() {
        }), function() {
          a.observers.delete(m) && !a.observers.size && a.tearDownQuery();
        };
      }) || this, a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.dirty = !1, a._getOrCreateQuery = function() {
        return s && (n.queries.set(a.queryId, i), s = !1), a.queryManager.getOrCreateQuery(a.queryId);
      }, a.queryInfo = i, a.queryManager = n, a.waitForOwnResult = Qr(o.fetchPolicy), a.isTornDown = !1, a.subscribeToMore = a.subscribeToMore.bind(a), a.maskResult = a.maskResult.bind(a);
      var u = n.defaultOptions.watchQuery, c = u === void 0 ? {} : u, l = c.fetchPolicy, f = l === void 0 ? "cache-first" : l, d = o.fetchPolicy, h = d === void 0 ? f : d, p = o.initialFetchPolicy, y = p === void 0 ? h === "standby" ? f : h : p;
      a.options = v(v({}, o), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: y,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: h
      }), a.queryId = i.queryId || n.generateQueryId();
      var b = rt(a.query);
      return a.queryName = b && b.name && b.name.value, a;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var r = this;
      return globalThis.__DEV__ !== !1 && tt("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && I.warn(23);
      }), new Promise(function(n, i) {
        var o = {
          next: function(s) {
            n(s), r.observers.delete(o), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              a.unsubscribe();
            }, 0);
          },
          error: i
        }, a = r.subscribe(o);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(r) {
      var n = this;
      r === void 0 && (r = !0);
      var i = fe("getLastResult", function() {
        return n.getLastResult(!0);
      }), o = this.queryInfo.networkStatus || i && i.networkStatus || V.ready, a = v(v({}, i), { loading: lt(o), networkStatus: o }), s = this.options.fetchPolicy, u = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Qr(u) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var c = this.queryInfo.getDiff();
        (c.complete || this.options.returnPartialData) && (a.data = c.result), B(a.data, {}) && (a.data = void 0), c.complete ? (delete a.partial, c.complete && a.networkStatus === V.loading && (u === "cache-first" || u === "cache-only") && (a.networkStatus = V.ready, a.loading = !1)) : a.partial = !0, a.networkStatus === V.ready && (a.error || a.errors) && (a.networkStatus = V.error), globalThis.__DEV__ !== !1 && !c.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && Ia(c.missing);
      }
      return r && this.updateLastResult(a), a;
    }, t.prototype.getCurrentResult = function(r) {
      return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
    }, t.prototype.isDifferentFromLastResult = function(r, n) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), o = this.queryManager.dataMasking, a = o ? i.nonReactiveQuery : this.query, s = o || i.hasNonreactiveDirective ? !ua(a, this.last.result, r, this.variables) : !B(this.last.result, r);
      return s || n && !B(this.last.variables, n);
    }, t.prototype.getLast = function(r, n) {
      var i = this.last;
      if (i && i[r] && (!n || B(i.variables, this.variables)))
        return i[r];
    }, t.prototype.getLastResult = function(r) {
      return globalThis.__DEV__ !== !1 && tt("getLastResult", function() {
        globalThis.__DEV__ !== !1 && I.warn(24);
      }), this.getLast("result", r);
    }, t.prototype.getLastError = function(r) {
      return globalThis.__DEV__ !== !1 && tt("getLastError", function() {
        globalThis.__DEV__ !== !1 && I.warn(25);
      }), this.getLast("error", r);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && tt("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && I.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && I.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(r) {
      var n, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, o = this.options.fetchPolicy;
      if (o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && ml.call(r, "variables")) {
        var a = Ao(this.query), s = a.variableDefinitions;
        (!s || !s.some(function(u) {
          return u.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && I.warn(
          28,
          r,
          ((n = a.name) === null || n === void 0 ? void 0 : n.value) || a
        );
      }
      return r && !B(this.options.variables, r) && (i.variables = this.options.variables = v(v({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, V.refetch);
    }, t.prototype.fetchMore = function(r) {
      var n = this, i = v(v({}, r.query ? r : v(v(v(v({}, this.options), { query: this.options.query }), r), { variables: v(v({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var o = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
      var a = this.queryInfo, s = a.networkStatus;
      a.networkStatus = V.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var u = /* @__PURE__ */ new Set(), c = r == null ? void 0 : r.updateQuery, l = this.options.fetchPolicy !== "no-cache";
      return l || I(c, 29), this.queryManager.fetchQuery(o, i, V.fetchMore).then(function(f) {
        if (n.queryManager.removeQuery(o), a.networkStatus === V.fetchMore && (a.networkStatus = s), l)
          n.queryManager.cache.batch({
            update: function(p) {
              var y = r.updateQuery;
              y ? p.updateQuery({
                query: n.query,
                variables: n.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(b) {
                return y(b, {
                  fetchMoreResult: f.data,
                  variables: i.variables
                });
              }) : p.writeQuery({
                query: i.query,
                variables: i.variables,
                data: f.data
              });
            },
            onWatchUpdated: function(p) {
              u.add(p.query);
            }
          });
        else {
          var d = n.getLast("result"), h = c(d.data, {
            fetchMoreResult: f.data,
            variables: i.variables
          });
          n.reportResult(v(v({}, d), { networkStatus: s, loading: lt(s), data: h }), n.variables);
        }
        return n.maskResult(f);
      }).finally(function() {
        l && !u.has(n.query) && n.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(r) {
      var n = this, i = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(o) {
          var a = r.updateQuery;
          a && n.updateQuery(function(s, u) {
            return a(s, v({ subscriptionData: o }, u));
          });
        },
        error: function(o) {
          if (r.onError) {
            r.onError(o);
            return;
          }
          globalThis.__DEV__ !== !1 && I.error(30, o);
        }
      });
      return this.subscriptions.add(i), function() {
        n.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(r) {
      return globalThis.__DEV__ !== !1 && (re(r, "canonizeResults", "setOptions"), tt("setOptions", function() {
        globalThis.__DEV__ !== !1 && I.warn(31);
      })), this.reobserve(r);
    }, t.prototype.silentSetOptions = function(r) {
      var n = kt(this.options, r || {});
      Wi(this.options, n);
    }, t.prototype.setVariables = function(r) {
      var n = this;
      return B(this.variables, r) ? this.observers.size ? fe("observableQuery.result", function() {
        return n.result();
      }) : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, V.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(r) {
      var n = this.queryManager, i = n.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), o = i.result, a = i.complete, s = r(o, {
        variables: this.variables,
        complete: !!a,
        previousData: o
      });
      s && (n.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), n.broadcastQueries());
    }, t.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(r, n) {
      if (n.nextFetchPolicy) {
        var i = n.fetchPolicy, o = i === void 0 ? "cache-first" : i, a = n.initialFetchPolicy, s = a === void 0 ? o : a;
        o === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(o, {
          reason: r,
          options: n,
          observable: this,
          initialFetchPolicy: s
        }) : r === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
      }
      return n.fetchPolicy;
    }, t.prototype.fetch = function(r, n, i) {
      var o = this._getOrCreateQuery();
      return o.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(o, r, n, i);
    }, t.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var n = this, i = n.pollingInfo, o = n.options.pollInterval;
        if (!o || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === o)) {
          I(o, 32);
          var a = i || (this.pollingInfo = {});
          a.interval = o;
          var s = function() {
            var c, l;
            r.pollingInfo && (!lt(r.queryInfo.networkStatus) && !(!((l = (c = r.options).skipPollAttempt) === null || l === void 0) && l.call(c)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, V.poll).then(u, u) : u());
          }, u = function() {
            var c = r.pollingInfo;
            c && (clearTimeout(c.timeout), c.timeout = setTimeout(s, c.interval));
          };
          u();
        }
      }
    }, t.prototype.updateLastResult = function(r, n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var o = fe("getLastError", function() {
        return i.getLastError();
      });
      return o && this.last && !B(n, this.last.variables) && (o = void 0), this.last = v({ result: this.queryManager.assumeImmutableResults ? r : ta(r), variables: n }, o ? { error: o } : null);
    }, t.prototype.reobserveAsConcast = function(r, n) {
      var i = this;
      this.isTornDown = !1;
      var o = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        n === V.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        n === V.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        n === V.poll
      ), a = this.options.variables, s = this.options.fetchPolicy, u = kt(this.options, r || {}), c = o ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        u
      ) : Wi(this.options, u), l = this.transformDocument(c.query);
      this.lastQuery = l, o || (this.updatePolling(), r && r.variables && !B(r.variables, a) && // Don't mess with the fetchPolicy if it's currently "standby".
      c.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (c.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof c.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", c), n === void 0 && (n = V.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Qr(c.fetchPolicy));
      var f = function() {
        i.concast === p && (i.waitForOwnResult = !1);
      }, d = c.variables && v({}, c.variables), h = this.fetch(c, n, l), p = h.concast, y = h.fromLink, b = {
        next: function(m) {
          B(i.variables, d) && (f(), i.reportResult(m, d));
        },
        error: function(m) {
          B(i.variables, d) && (oa(m) || (m = new $e({ networkError: m })), f(), i.reportError(m, d));
        }
      };
      return !o && (y || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = b), p.addObserver(b), p;
    }, t.prototype.reobserve = function(r, n) {
      return oc(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = this.last;
      fe("resetLastResults", function() {
        return r.resetLastResults();
      });
      var a = this.subscribe.apply(this, n);
      return this.last = o, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(r, n) {
      var i = this, o = fe("getLastError", function() {
        return i.getLastError();
      }), a = this.isDifferentFromLastResult(r, n);
      (o || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (o || a) && qt(this.observers, "next", this.maskResult(r));
    }, t.prototype.reportError = function(r, n) {
      var i = this, o = v(v({}, fe("getLastResult", function() {
        return i.getLastResult();
      })), { error: r, errors: r.graphQLErrors, networkStatus: V.error, loading: !1 });
      this.updateLastResult(o, n), qt(this.observers, "error", this.last.error = r);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, t.prototype.maskResult = function(r) {
      return r && "data" in r ? v(v({}, r), { data: this.queryManager.maskOperation({
        document: this.query,
        data: r.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : r;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var r = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !lt(this.queryInfo.networkStatus))) {
        var r = this.queryInfo.getDiff();
        r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var r = this.options, n = r.fetchPolicy, i = r.nextFetchPolicy;
      return n === "cache-and-network" || n === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(o, a) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(o, a) : n;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new Rt(), t;
  })(Q)
);
ra(lr);
function gl(e) {
  globalThis.__DEV__ !== !1 && I.error(33, e.message, e.stack);
}
function Ia(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && I.debug(34, e);
}
function Qr(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var ft = new (nt ? WeakMap : Map)();
function Ur(e, t) {
  var r = e[t];
  typeof r == "function" && (e[t] = function() {
    return ft.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (ft.get(e) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
var Br = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var n = this.cache = t.cache;
      ft.has(n) || (ft.set(n, 0), Ur(n, "evict"), Ur(n, "modify"), Ur(n, "reset"));
    }
    return e.prototype.init = function(t) {
      var r = t.networkStatus || V.loading;
      return this.variables && this.networkStatus !== V.loading && !B(this.variables, t.variables) && (r = V.setVariables), B(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, r = this.getDiffOptions();
      if (this.lastDiff && B(r, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var n = this.observableQuery;
      if (n && n.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = fe("canonizeResults", function() {
        return t.cache.diff(r);
      });
      return this.updateLastDiff(i, r), i;
    }, e.prototype.updateLastDiff = function(t, r) {
      this.lastDiff = t ? {
        diff: t,
        options: r || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var r;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var r = this, n, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && fe("getLastError", function() {
        var o;
        return (o = r.observableQuery) === null || o === void 0 ? void 0 : o.getLastError();
      }) || (this.updateLastDiff(t), B(i && i.result, t && t.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var r = this.observableQuery;
        r && r.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var r = this;
      t === void 0 && (t = this.variables);
      var n = this.observableQuery;
      if (!(n && n.options.fetchPolicy === "no-cache")) {
        var i = v(v({}, this.getDiffOptions(t)), { watcher: this, callback: function(o) {
          return r.setDiff(o);
        } });
        (!this.lastWatch || !B(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, r) {
      var n = this.lastWrite;
      return !(n && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      n.dmCount === ft.get(this.cache) && B(r, n.variables) && B(t.data, n.result.data));
    }, e.prototype.markResult = function(t, r, n, i) {
      var o = this, a, s = new Qe(), u = Ie(t.errors) ? t.errors.slice(0) : [];
      if ((a = this.observableQuery) === null || a === void 0 || a.resetNotifications(), "incremental" in t && Ie(t.incremental)) {
        var c = na(this.getDiff().result, t);
        t.data = c;
      } else if ("hasNext" in t && t.hasNext) {
        var l = this.getDiff();
        t.data = s.merge(l.result, t.data);
      }
      this.graphQLErrors = u, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (gn(t, n.errorPolicy) ? this.cache.performTransaction(function(f) {
        if (o.shouldWrite(t, n.variables))
          f.writeQuery({
            query: r,
            data: t.data,
            variables: n.variables,
            overwrite: i === 1
          }), o.lastWrite = {
            result: t,
            variables: n.variables,
            dmCount: ft.get(o.cache)
          };
        else if (o.lastDiff && o.lastDiff.diff.complete) {
          t.data = o.lastDiff.diff.result;
          return;
        }
        var d = o.getDiffOptions(n.variables), h = fe("canonizeResults", function() {
          return f.diff(d);
        });
        !o.stopped && B(o.variables, n.variables) && o.updateWatch(n.variables), o.updateLastDiff(h, d), h.complete && (t.data = h.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = V.ready;
    }, e.prototype.markError = function(t) {
      var r;
      return this.networkStatus = V.error, this.lastWrite = void 0, (r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function gn(e, t) {
  t === void 0 && (t = "none");
  var r = t === "ignore" || t === "all", n = !sr(e);
  return !n && r && e.data && (n = !0), n;
}
var bl = Object.prototype.hasOwnProperty, Ji = /* @__PURE__ */ Object.create(null), _l = (
  /** @class */
  (function() {
    function e(t) {
      var r = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new zo(
        Fe["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Ce(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var n = new Jo(
        function(o) {
          return r.cache.transformDocument(o);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(r, n) {
        t.stopQueryNoBroadcast(n);
      }), this.cancelPendingFetches(ve(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(r) {
        return r(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return xe(this, arguments, void 0, function(r) {
        var n, i, o, a, s, u, c, l = r.mutation, f = r.variables, d = r.optimisticResponse, h = r.updateQueries, p = r.refetchQueries, y = p === void 0 ? [] : p, b = r.awaitRefetchQueries, m = b === void 0 ? !1 : b, _ = r.update, k = r.onQueryUpdated, S = r.fetchPolicy, O = S === void 0 ? ((u = this.defaultOptions.mutate) === null || u === void 0 ? void 0 : u.fetchPolicy) || "network-only" : S, T = r.errorPolicy, F = T === void 0 ? ((c = this.defaultOptions.mutate) === null || c === void 0 ? void 0 : c.errorPolicy) || "none" : T, P = r.keepRootFields, x = r.context;
        return Me(this, function(L) {
          switch (L.label) {
            case 0:
              return I(l, 36), I(O === "network-only" || O === "no-cache", 37), n = this.generateMutationId(), l = this.cache.transformForLink(this.transform(l)), i = this.getDocumentInfo(l).hasClientExports, f = this.getVariables(l, f), i ? [4, this.localState.addExportedVariables(l, f, x)] : [3, 2];
            case 1:
              f = L.sent(), L.label = 2;
            case 2:
              return o = this.mutationStore && (this.mutationStore[n] = {
                mutation: l,
                variables: f,
                loading: !0,
                error: null
              }), a = d && this.markMutationOptimistic(d, {
                mutationId: n,
                document: l,
                variables: f,
                fetchPolicy: O,
                errorPolicy: F,
                context: x,
                updateQueries: h,
                update: _,
                keepRootFields: P
              }), this.broadcastQueries(), s = this, [2, new Promise(function(ke, me) {
                return Mr(s.getObservableFromLink(l, v(v({}, x), { optimisticResponse: a ? d : void 0 }), f, {}, !1), function(ee) {
                  if (sr(ee) && F === "none")
                    throw new $e({
                      graphQLErrors: un(ee)
                    });
                  o && (o.loading = !1, o.error = null);
                  var he = v({}, ee);
                  return typeof y == "function" && (y = y(he)), F === "ignore" && sr(he) && delete he.errors, s.markMutationResult({
                    mutationId: n,
                    result: he,
                    document: l,
                    variables: f,
                    fetchPolicy: O,
                    errorPolicy: F,
                    context: x,
                    update: _,
                    updateQueries: h,
                    awaitRefetchQueries: m,
                    refetchQueries: y,
                    removeOptimistic: a ? n : void 0,
                    onQueryUpdated: k,
                    keepRootFields: P
                  });
                }).subscribe({
                  next: function(ee) {
                    s.broadcastQueries(), (!("hasNext" in ee) || ee.hasNext === !1) && ke(v(v({}, ee), { data: s.maskOperation({
                      document: l,
                      data: ee.data,
                      fetchPolicy: O,
                      id: n
                    }) }));
                  },
                  error: function(ee) {
                    o && (o.loading = !1, o.error = ee), a && s.cache.removeOptimistic(n), s.broadcastQueries(), me(ee instanceof $e ? ee : new $e({
                      networkError: ee
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, r) {
      var n = this;
      r === void 0 && (r = this.cache);
      var i = t.result, o = [], a = t.fetchPolicy === "no-cache";
      if (!a && gn(i, t.errorPolicy)) {
        if (vt(i) || o.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), vt(i) && Ie(i.incremental)) {
          var s = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), u = void 0;
          s.result && (u = na(s.result, i)), typeof u < "u" && (i.data = u, o.push({
            result: u,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var c = t.updateQueries;
        c && this.queries.forEach(function(f, d) {
          var h = f.observableQuery, p = h && h.queryName;
          if (!(!p || !bl.call(c, p))) {
            var y = c[p], b = n.queries.get(d), m = b.document, _ = b.variables, k = r.diff({
              query: m,
              variables: _,
              returnPartialData: !0,
              optimistic: !1
            }), S = k.result, O = k.complete;
            if (O && S) {
              var T = y(S, {
                mutationResult: i,
                queryName: m && jt(m) || void 0,
                queryVariables: _
              });
              T && o.push({
                result: T,
                dataId: "ROOT_QUERY",
                query: m,
                variables: _
              });
            }
          }
        });
      }
      if (o.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var l = [];
        if (this.refetchQueries({
          updateCache: function(f) {
            a || o.forEach(function(y) {
              return f.write(y);
            });
            var d = t.update, h = !lc(i) || vt(i) && !i.hasNext;
            if (d) {
              if (!a) {
                var p = f.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: n.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (i = v(v({}, i), { data: p.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              h && d(f, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !a && !t.keepRootFields && h && f.modify({
              id: "ROOT_MUTATION",
              fields: function(y, b) {
                var m = b.fieldName, _ = b.DELETE;
                return m === "__typename" ? y : _;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(f) {
          return l.push(f);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(l).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, r) {
      var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: Ji }) : t;
      return i === Ji ? !1 : (this.cache.recordOptimisticTransaction(function(o) {
        try {
          n.markMutationResult(v(v({}, r), { result: { data: i } }), o);
        } catch (a) {
          globalThis.__DEV__ !== !1 && I.error(a);
        }
      }, r.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, r, n) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), r, n).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, n) {
        t[n] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var r = this.queries.get(t);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var r = this.transformCache;
      if (!r.has(t)) {
        var n = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: Bs(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: Ut(["nonreactive"], t),
          nonReactiveQuery: Ju(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: Ko([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: Dn(rt(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: v(v({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? v(v({}, i), { operation: "query" }) : i;
          }) })
        };
        r.set(t, n);
      }
      return r.get(t);
    }, e.prototype.getVariables = function(t, r) {
      return v(v({}, this.getDocumentInfo(t).defaultVars), r);
    }, e.prototype.watchQuery = function(t) {
      var r = this.transform(t.query);
      t = v(v({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new Br(this), i = new lr({
        queryManager: this,
        queryInfo: n,
        options: t
      });
      return i.lastQuery = r, lr.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
        document: r,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, r) {
      var n = this;
      r === void 0 && (r = this.generateQueryId()), I(t.query, 38), I(t.query.kind === "Document", 39), I(!t.returnPartialData, 40), I(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(r, v(v({}, t), { query: i })).then(function(o) {
        return o && v(v({}, o), { data: n.maskOperation({
          document: i,
          data: o.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      }).finally(function() {
        return n.stopQuery(r);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var r = this.queries.get(t);
      r && r.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(ve(42)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = V.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = "active");
      var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), o.set(s, !1);
        else if (_u(s)) {
          var u = Le(r.transform(s));
          i.set(u, jt(s)), o.set(u, !1);
        } else W(s) && s.query && a.add(s);
      }), this.queries.forEach(function(s, u) {
        var c = s.observableQuery, l = s.document;
        if (c) {
          if (t === "all") {
            n.set(u, c);
            return;
          }
          var f = c.queryName, d = c.options.fetchPolicy;
          if (d === "standby" || t === "active" && !c.hasObservers())
            return;
          (t === "active" || f && o.has(f) || l && o.has(Le(l))) && (n.set(u, c), f && o.set(f, !0), l && o.set(Le(l), !0));
        }
      }), a.size && a.forEach(function(s) {
        var u = Hr("legacyOneTimeQuery"), c = r.getOrCreateQuery(u).init({
          document: s.query,
          variables: s.variables
        }), l = new lr({
          queryManager: r,
          queryInfo: c,
          options: v(v({}, s), { fetchPolicy: "network-only" })
        });
        I(l.queryId === u), c.setObservableQuery(l), n.set(u, l);
      }), globalThis.__DEV__ !== !1 && o.size && o.forEach(function(s, u) {
        if (!s) {
          var c = i.get(u);
          c ? globalThis.__DEV__ !== !1 && I.warn(43, c) : globalThis.__DEV__ !== !1 && I.warn(44);
        }
      }), n;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var r = this;
      t === void 0 && (t = !1);
      var n = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, o) {
        var a = i.options.fetchPolicy;
        fe("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || a !== "standby" && a !== "cache-only") && n.push(i.refetch()), (r.queries.get(o) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(n);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var r = this, n = t.query, i = t.variables, o = t.fetchPolicy, a = t.errorPolicy, s = a === void 0 ? "none" : a, u = t.context, c = u === void 0 ? {} : u, l = t.extensions, f = l === void 0 ? {} : l;
      n = this.transform(n), i = this.getVariables(n, i);
      var d = function(p) {
        return r.getObservableFromLink(n, c, p, f).map(function(y) {
          o !== "no-cache" && (gn(y, s) && r.cache.write({
            query: n,
            result: y.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), r.broadcastQueries());
          var b = sr(y), m = Rc(y);
          if (b || m) {
            var _ = {};
            if (b && (_.graphQLErrors = y.errors), m && (_.protocolErrors = y.extensions[xn]), s === "none" || m)
              throw new $e(_);
          }
          return s === "ignore" && delete y.errors, y;
        });
      };
      if (this.getDocumentInfo(n).hasClientExports) {
        var h = this.localState.addExportedVariables(n, i, c).then(d);
        return new Q(function(p) {
          var y = null;
          return h.then(function(b) {
            return y = b.subscribe(p);
          }, p.error), function() {
            return y && y.unsubscribe();
          };
        });
      }
      return d(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var r;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((r = this.queries.get(t)) === null || r === void 0 || r.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var r;
        return (r = t.observableQuery) === null || r === void 0 ? void 0 : r.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, r, n, i, o) {
      var a = this, s;
      o === void 0 && (o = (s = r == null ? void 0 : r.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var u, c = this.getDocumentInfo(t), l = c.serverQuery, f = c.clientQuery;
      if (l) {
        var d = this, h = d.inFlightLinkObservables, p = d.link, y = {
          query: l,
          variables: n,
          operationName: jt(l) || void 0,
          context: this.prepareContext(v(v({}, r), { forceFetch: !o })),
          extensions: i
        };
        if (r = y.context, o) {
          var b = Le(l), m = Ve(n), _ = h.lookup(b, m);
          if (u = _.observable, !u) {
            var k = new st([
              fn(p, y)
            ]);
            u = _.observable = k, k.beforeNext(function S(O, T) {
              O === "next" && "hasNext" in T && T.hasNext ? k.beforeNext(S) : h.remove(b, m);
            });
          }
        } else
          u = new st([
            fn(p, y)
          ]);
      } else
        u = new st([Q.of({ data: {} })]), r = this.prepareContext(r);
      return f && (u = Mr(u, function(S) {
        return a.localState.runResolvers({
          document: f,
          remoteResult: S,
          context: r,
          variables: n
        });
      })), u;
    }, e.prototype.getResultsFromLink = function(t, r, n) {
      var i = t.lastRequestId = this.generateRequestId(), o = this.cache.transformForLink(n.query);
      return Mr(this.getObservableFromLink(o, n.context, n.variables), function(a) {
        var s = un(a), u = s.length > 0, c = n.errorPolicy;
        if (i >= t.lastRequestId) {
          if (u && c === "none")
            throw t.markError(new $e({
              graphQLErrors: s
            }));
          t.markResult(a, o, n, r), t.markReady();
        }
        var l = {
          data: a.data,
          loading: !1,
          networkStatus: V.ready
        };
        return u && c === "none" && (l.data = void 0), u && c !== "ignore" && (l.errors = s, l.networkStatus = V.error), l;
      }, function(a) {
        var s = oa(a) ? a : new $e({ networkError: a });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
      var o = this;
      n === void 0 && (n = V.loading), i === void 0 && (i = r.query);
      var a = this.getVariables(i, r.variables), s = this.defaultOptions.watchQuery, u = r.fetchPolicy, c = u === void 0 ? s && s.fetchPolicy || "cache-first" : u, l = r.errorPolicy, f = l === void 0 ? s && s.errorPolicy || "none" : l, d = r.returnPartialData, h = d === void 0 ? !1 : d, p = r.notifyOnNetworkStatusChange, y = p === void 0 ? !1 : p, b = r.context, m = b === void 0 ? {} : b, _ = Object.assign({}, r, {
        query: i,
        variables: a,
        fetchPolicy: c,
        errorPolicy: f,
        returnPartialData: h,
        notifyOnNetworkStatusChange: y,
        context: m
      }), k = function(P) {
        _.variables = P;
        var x = o.fetchQueryByPolicy(t, _, n);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          _.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          x.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", r), x
        );
      }, S = function() {
        return o.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(P) {
        S(), setTimeout(function() {
          return O.cancel(P);
        });
      });
      var O, T;
      if (this.getDocumentInfo(_.query).hasClientExports)
        O = new st(this.localState.addExportedVariables(_.query, _.variables, _.context).then(k).then(function(P) {
          return P.sources;
        })), T = !0;
      else {
        var F = k(_.variables);
        T = F.fromLink, O = new st(F.sources);
      }
      return O.promise.then(S, S), {
        concast: O,
        fromLink: T
      };
    }, e.prototype.refetchQueries = function(t) {
      var r = this, n = t.updateCache, i = t.include, o = t.optimistic, a = o === void 0 ? !1 : o, s = t.removeOptimistic, u = s === void 0 ? a ? Hr("refetchQueries") : void 0 : s, c = t.onQueryUpdated, l = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(d, h) {
        l.set(h, {
          oq: d,
          lastDiff: (r.queries.get(h) || d.queryInfo).getDiff()
        });
      });
      var f = /* @__PURE__ */ new Map();
      return n && this.cache.batch({
        update: n,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: a && u || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: u,
        onWatchUpdated: function(d, h, p) {
          var y = d.watcher instanceof Br && d.watcher.observableQuery;
          if (y) {
            if (c) {
              l.delete(y.queryId);
              var b = c(y, h, p);
              return b === !0 && (b = y.refetch()), b !== !1 && f.set(y, b), b;
            }
            c !== null && l.set(y.queryId, { oq: y, lastDiff: p, diff: h });
          }
        }
      }), l.size && l.forEach(function(d, h) {
        var p = d.oq, y = d.lastDiff, b = d.diff, m;
        c && (b || (b = fe("canonizeResults", function() {
          return r.cache.diff(p.queryInfo.getDiffOptions());
        })), m = c(p, b, y)), (!c || m === !0) && (m = p.refetch()), m !== !1 && f.set(p, m), h.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(h);
      }), u && this.cache.removeOptimistic(u), f;
    }, e.prototype.maskOperation = function(t) {
      var r, n, i, o = t.document, a = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, u = t.id, c = (r = rt(o)) === null || r === void 0 ? void 0 : r.operation, l = ((n = c == null ? void 0 : c[0]) !== null && n !== void 0 ? n : "o") + u;
        this.dataMasking && s === "no-cache" && !ru(o) && !this.noCacheWarningsByQueryId.has(l) && (this.noCacheWarningsByQueryId.add(l), globalThis.__DEV__ !== !1 && I.warn(
          45,
          (i = jt(o)) !== null && i !== void 0 ? i : "Unnamed ".concat(c ?? "operation")
        ));
      }
      return this.dataMasking ? el(a, o, this.cache) : a;
    }, e.prototype.maskFragment = function(t) {
      var r = t.data, n = t.fragment, i = t.fragmentName;
      return this.dataMasking ? da(r, n, this.cache, i) : r;
    }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
      var i = this, o = r.query, a = r.variables, s = r.fetchPolicy, u = r.refetchWritePolicy, c = r.errorPolicy, l = r.returnPartialData, f = r.context, d = r.notifyOnNetworkStatusChange, h = t.networkStatus;
      t.init({
        document: o,
        variables: a,
        networkStatus: n
      });
      var p = function() {
        return t.getDiff();
      }, y = function(S, O) {
        O === void 0 && (O = t.networkStatus || V.loading);
        var T = S.result;
        globalThis.__DEV__ !== !1 && !l && !B(T, {}) && Ia(S.missing);
        var F = function(P) {
          return Q.of(v({ data: P, loading: lt(O), networkStatus: O }, S.complete ? null : { partial: !0 }));
        };
        return T && i.getDocumentInfo(o).hasForcedResolvers ? i.localState.runResolvers({
          document: o,
          remoteResult: { data: T },
          context: f,
          variables: a,
          onlyRunForcedResolvers: !0
        }).then(function(P) {
          return F(P.data || void 0);
        }) : c === "none" && O === V.refetch && Array.isArray(S.missing) ? F(void 0) : F(T);
      }, b = s === "no-cache" ? 0 : n === V.refetch && u !== "merge" ? 1 : 2, m = function() {
        return i.getResultsFromLink(t, b, {
          query: o,
          variables: a,
          context: f,
          fetchPolicy: s,
          errorPolicy: c
        });
      }, _ = d && typeof h == "number" && h !== n && lt(n);
      switch (s) {
        default:
        case "cache-first": {
          var k = p();
          return k.complete ? {
            fromLink: !1,
            sources: [y(k, t.markReady())]
          } : l || _ ? {
            fromLink: !0,
            sources: [y(k), m()]
          } : { fromLink: !0, sources: [m()] };
        }
        case "cache-and-network": {
          var k = p();
          return k.complete || l || _ ? {
            fromLink: !0,
            sources: [y(k), m()]
          } : { fromLink: !0, sources: [m()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [y(p(), t.markReady())]
          };
        case "network-only":
          return _ ? {
            fromLink: !0,
            sources: [y(p()), m()]
          } : { fromLink: !0, sources: [m()] };
        case "no-cache":
          return _ ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [y(t.getDiff()), m()]
          } : { fromLink: !0, sources: [m()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new Br(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var r = this.localState.prepareContext(t);
      return v(v(v({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), wl = (
  /** @class */
  (function() {
    function e(t) {
      var r = t.cache, n = t.client, i = t.resolvers, o = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
    }
    return e.prototype.addResolvers = function(t) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
        r.resolvers = pi(r.resolvers, n);
      }) : this.resolvers = pi(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return xe(this, arguments, void 0, function(r) {
        var n = r.document, i = r.remoteResult, o = r.context, a = r.variables, s = r.onlyRunForcedResolvers, u = s === void 0 ? !1 : s;
        return Me(this, function(c) {
          return n ? [2, this.resolveDocument(n, i.data, o, a, this.fragmentMatcher, u).then(function(l) {
            return v(v({}, i), { data: l.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return Ut(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return Ho(t);
    }, e.prototype.prepareContext = function(t) {
      var r = this.cache;
      return v(v({}, t), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(n) {
          return r.identify(n);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return xe(this, arguments, void 0, function(r, n, i) {
        return n === void 0 && (n = {}), i === void 0 && (i = {}), Me(this, function(o) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(a) {
            return v(v({}, n), a.exportedVariables);
          })] : [2, v({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var r = !1;
      return Te(t, {
        Directive: {
          enter: function(n) {
            if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), r))
              return wr;
          }
        }
      }), r;
    }, e.prototype.buildRootValueFromCache = function(t, r) {
      return this.cache.diff({
        query: Wu(t),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, r) {
      return xe(this, arguments, void 0, function(n, i, o, a, s, u) {
        var c, l, f, d, h, p, y, b, m, _, k;
        return o === void 0 && (o = {}), a === void 0 && (a = {}), s === void 0 && (s = function() {
          return !0;
        }), u === void 0 && (u = !1), Me(this, function(S) {
          return c = zt(n), l = It(n), f = Tt(l), d = this.collectSelectionsToResolve(c, f), h = c.operation, p = h ? h.charAt(0).toUpperCase() + h.slice(1) : "Query", y = this, b = y.cache, m = y.client, _ = {
            fragmentMap: f,
            context: v(v({}, o), { cache: b, client: m }),
            variables: a,
            fragmentMatcher: s,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: d,
            onlyRunForcedResolvers: u
          }, k = !1, [2, this.resolveSelectionSet(c.selectionSet, k, i, _).then(function(O) {
            return {
              result: O,
              exportedVariables: _.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
      return xe(this, void 0, void 0, function() {
        var o, a, s, u, c, l = this;
        return Me(this, function(f) {
          return o = i.fragmentMap, a = i.context, s = i.variables, u = [n], c = function(d) {
            return xe(l, void 0, void 0, function() {
              var h, p;
              return Me(this, function(y) {
                return !r && !i.selectionsToResolve.has(d) ? [
                  2
                  /*return*/
                ] : Kt(d, s) ? qe(d) ? [2, this.resolveField(d, r, n, i).then(function(b) {
                  var m;
                  typeof b < "u" && u.push((m = {}, m[Ne(d)] = b, m));
                })] : (Fu(d) ? h = d : (h = o[d.name.value], I(h, 21, d.name.value)), h && h.typeCondition && (p = h.typeCondition.name.value, i.fragmentMatcher(n, p, a)) ? [2, this.resolveSelectionSet(h.selectionSet, r, n, i).then(function(b) {
                  u.push(b);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(c)).then(function() {
            return Dr(u);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, r, n, i) {
      return xe(this, void 0, void 0, function() {
        var o, a, s, u, c, l, f, d, h, p = this;
        return Me(this, function(y) {
          return n ? (o = i.variables, a = t.name.value, s = Ne(t), u = a !== s, c = n[s] || n[a], l = Promise.resolve(c), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (f = n.__typename || i.defaultOperationType, d = this.resolvers && this.resolvers[f], d && (h = d[u ? a : s], h && (l = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            jn.withValue(this.cache, h, [
              n,
              Sr(t, o),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, l.then(function(b) {
            var m, _;
            if (b === void 0 && (b = c), t.directives && t.directives.forEach(function(S) {
              S.name.value === "export" && S.arguments && S.arguments.forEach(function(O) {
                O.name.value === "as" && O.value.kind === "StringValue" && (i.exportedVariables[O.value.value] = b);
              });
            }), !t.selectionSet || b == null)
              return b;
            var k = (_ = (m = t.directives) === null || m === void 0 ? void 0 : m.some(function(S) {
              return S.name.value === "client";
            })) !== null && _ !== void 0 ? _ : !1;
            if (Array.isArray(b))
              return p.resolveSubSelectedArray(t, r || k, b, i);
            if (t.selectionSet)
              return p.resolveSelectionSet(t.selectionSet, r || k, b, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
      var o = this;
      return Promise.all(n.map(function(a) {
        if (a === null)
          return null;
        if (Array.isArray(a))
          return o.resolveSubSelectedArray(t, r, a, i);
        if (t.selectionSet)
          return o.resolveSelectionSet(t.selectionSet, r, a, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, r) {
      var n = function(a) {
        return !Array.isArray(a);
      }, i = this.selectionsToResolveCache;
      function o(a) {
        if (!i.has(a)) {
          var s = /* @__PURE__ */ new Set();
          i.set(a, s), Te(a, {
            Directive: function(u, c, l, f, d) {
              u.name.value === "client" && d.forEach(function(h) {
                n(h) && oi(h) && s.add(h);
              });
            },
            FragmentSpread: function(u, c, l, f, d) {
              var h = r[u.name.value];
              I(h, 22, u.name.value);
              var p = o(h);
              p.size > 0 && (d.forEach(function(y) {
                n(y) && oi(y) && s.add(y);
              }), s.add(u), p.forEach(function(y) {
                s.add(y);
              }));
            }
          });
        }
        return i.get(a);
      }
      return o(t);
    }, e;
  })()
), Gi = !1, za = (
  /** @class */
  (function() {
    function e(t) {
      var r = this, n, i, o;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw ve(16);
      var a = t.uri, s = t.credentials, u = t.headers, c = t.cache, l = t.documentTransform, f = t.ssrMode, d = f === void 0 ? !1 : f, h = t.ssrForceFetchDelay, p = h === void 0 ? 0 : h, y = t.connectToDevTools, b = t.queryDeduplication, m = b === void 0 ? !0 : b, _ = t.defaultOptions, k = t.defaultContext, S = t.assumeImmutableResults, O = S === void 0 ? c.assumeImmutableResults : S, T = t.resolvers, F = t.typeDefs, P = t.fragmentMatcher, x = t.clientAwareness, L = t.name, ke = t.version, me = t.devtools, ee = t.dataMasking;
      globalThis.__DEV__ !== !1 && (re(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), re(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), re(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), re(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), re(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), re(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), re(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && I.warn(17));
      var he = t.link;
      he || (he = a ? new sa({ uri: a, credentials: s, headers: u }) : Je.empty()), this.link = he, this.cache = c, this.disableNetworkFetches = d || p > 0, this.queryDeduplication = m, this.defaultOptions = _ || /* @__PURE__ */ Object.create(null), this.typeDefs = F, this.devtoolsConfig = v(v({}, me), { enabled: (n = me == null ? void 0 : me.enabled) !== null && n !== void 0 ? n : y }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), p && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, p), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = En, this.localState = new wl({
        cache: c,
        client: this,
        resolvers: T,
        fragmentMatcher: P
      }), this.queryManager = new _l({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: k,
        documentTransform: l,
        queryDeduplication: m,
        ssrMode: d,
        dataMasking: !!ee,
        clientAwareness: {
          name: (i = x == null ? void 0 : x.name) !== null && i !== void 0 ? i : L,
          version: (o = x == null ? void 0 : x.version) !== null && o !== void 0 ? o : ke
        },
        localState: this.localState,
        assumeImmutableResults: O,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, r = Symbol.for("apollo.devtools");
        (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !Gi && globalThis.__DEV__ !== !1 && (Gi = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var n = window.navigator, i = n && n.userAgent, o = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? o = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (o = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), o && globalThis.__DEV__ !== !1 && I.log("Download the Apollo DevTools for a better development experience: %s", o);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = jr(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = v(v({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (re(t, "canonizeResults", "client.watchQuery"), re(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = jr(this.defaultOptions.query, t)), I(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = v(v({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (re(t, "canonizeResults", "client.query"), re(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && I.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = jr(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var r = this, n = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return v(v({}, i), { data: r.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      });
    }, e.prototype.readQuery = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(t, r);
    }, e.prototype.watchFragment = function(t) {
      var r;
      return this.cache.watchFragment(v(v({}, t), (r = {}, r[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
    }, e.prototype.readFragment = function(t, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(t, r);
    }, e.prototype.writeQuery = function(t) {
      var r = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.writeFragment = function(t) {
      var r = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return fn(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var r = this;
      return this.resetStoreCallbacks.push(t), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var r = this;
      return this.clearStoreCallbacks.push(t), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
          return n !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var r = this.queryManager.refetchQueries(t), n = [], i = [];
      r.forEach(function(a, s) {
        n.push(s), i.push(a);
      });
      var o = Promise.all(i);
      return o.queries = n, o.results = i, o.catch(function(a) {
        globalThis.__DEV__ !== !1 && I.debug(20, a);
      }), o;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (za.prototype.getMemoryInternals = fu);
function kl(e) {
  return W(e) && "code" in e && "reason" in e;
}
function El(e) {
  var t;
  return W(e) && ((t = e.target) === null || t === void 0 ? void 0 : t.readyState) === WebSocket.CLOSED;
}
var Sl = (
  /** @class */
  (function(e) {
    De(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.client = r, n;
    }
    return t.prototype.request = function(r) {
      var n = this;
      return new Q(function(i) {
        return n.client.subscribe(v(v({}, r), { query: Le(r.query) }), {
          next: i.next.bind(i),
          complete: i.complete.bind(i),
          error: function(o) {
            if (o instanceof Error)
              return i.error(o);
            var a = kl(o);
            return a || El(o) ? i.error(
              // reason will be available on clean closes
              new Error("Socket closed".concat(a ? " with event ".concat(o.code) : "").concat(a ? " ".concat(o.reason) : ""))
            ) : i.error(new $e({
              graphQLErrors: Array.isArray(o) ? o : [o]
            }));
          }
          // casting around a wrong type in graphql-ws, which incorrectly expects `Sink<ExecutionResult>`
        });
      });
    }, t;
  })(Je)
);
function ge(e) {
  return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
}
function Xe(e) {
  return ge(e) === "object";
}
function Ol(e) {
  return Array.isArray(e) && // must be at least one error
  e.length > 0 && // error has at least a message
  e.every((t) => "message" in t);
}
function Ki(e, t) {
  return e.length < 124 ? e : t;
}
const Tl = "graphql-transport-ws";
var _e;
(function(e) {
  e[e.InternalServerError = 4500] = "InternalServerError", e[e.InternalClientError = 4005] = "InternalClientError", e[e.BadRequest = 4400] = "BadRequest", e[e.BadResponse = 4004] = "BadResponse", e[e.Unauthorized = 4401] = "Unauthorized", e[e.Forbidden = 4403] = "Forbidden", e[e.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", e[e.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", e[e.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", e[e.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", e[e.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(_e || (_e = {}));
var ne;
(function(e) {
  e.ConnectionInit = "connection_init", e.ConnectionAck = "connection_ack", e.Ping = "ping", e.Pong = "pong", e.Subscribe = "subscribe", e.Next = "next", e.Error = "error", e.Complete = "complete";
})(ne || (ne = {}));
function Ra(e) {
  if (!Xe(e))
    throw new Error(`Message is expected to be an object, but got ${ge(e)}`);
  if (!e.type)
    throw new Error("Message is missing the 'type' property");
  if (typeof e.type != "string")
    throw new Error(`Message is expects the 'type' property to be a string, but got ${ge(e.type)}`);
  switch (e.type) {
    case ne.ConnectionInit:
    case ne.ConnectionAck:
    case ne.Ping:
    case ne.Pong: {
      if (e.payload != null && !Xe(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${e.payload}"`);
      break;
    }
    case ne.Subscribe: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ge(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!Xe(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object, but got ${ge(e.payload)}`);
      if (typeof e.payload.query != "string")
        throw new Error(`"${e.type}" message payload expects the 'query' property to be a string, but got ${ge(e.payload.query)}`);
      if (e.payload.variables != null && !Xe(e.payload.variables))
        throw new Error(`"${e.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${ge(e.payload.variables)}`);
      if (e.payload.operationName != null && ge(e.payload.operationName) !== "string")
        throw new Error(`"${e.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${ge(e.payload.operationName)}`);
      if (e.payload.extensions != null && !Xe(e.payload.extensions))
        throw new Error(`"${e.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${ge(e.payload.extensions)}`);
      break;
    }
    case ne.Next: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ge(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!Xe(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an object, but got ${ge(e.payload)}`);
      break;
    }
    case ne.Error: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ge(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      if (!Ol(e.payload))
        throw new Error(`"${e.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(e.payload)}`);
      break;
    }
    case ne.Complete: {
      if (typeof e.id != "string")
        throw new Error(`"${e.type}" message expects the 'id' property to be a string, but got ${ge(e.id)}`);
      if (!e.id)
        throw new Error(`"${e.type}" message requires a non-empty 'id' property`);
      break;
    }
    default:
      throw new Error(`Invalid message 'type' property "${e.type}"`);
  }
  return e;
}
function Dl(e, t) {
  return Ra(typeof e == "string" ? JSON.parse(e, t) : e);
}
function Mt(e, t) {
  return Ra(e), JSON.stringify(e, t);
}
var mt = function(e) {
  return this instanceof mt ? (this.v = e, this) : new mt(e);
}, Il = function(e, t, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(e, t || []), i, o = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), s("next"), s("throw"), s("return", a), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function a(h) {
    return function(p) {
      return Promise.resolve(p).then(h, f);
    };
  }
  function s(h, p) {
    n[h] && (i[h] = function(y) {
      return new Promise(function(b, m) {
        o.push([h, y, b, m]) > 1 || u(h, y);
      });
    }, p && (i[h] = p(i[h])));
  }
  function u(h, p) {
    try {
      c(n[h](p));
    } catch (y) {
      d(o[0][3], y);
    }
  }
  function c(h) {
    h.value instanceof mt ? Promise.resolve(h.value.v).then(l, f) : d(o[0][2], h);
  }
  function l(h) {
    u("next", h);
  }
  function f(h) {
    u("throw", h);
  }
  function d(h, p) {
    h(p), o.shift(), o.length && u(o[0][0], o[0][1]);
  }
};
function zl(e) {
  const {
    url: t,
    connectionParams: r,
    lazy: n = !0,
    onNonLazyError: i = console.error,
    lazyCloseTimeout: o = 0,
    keepAlive: a = 0,
    disablePong: s,
    connectionAckWaitTimeout: u = 0,
    retryAttempts: c = 5,
    retryWait: l = async function(U) {
      let N = 1e3;
      for (let M = 0; M < U; M++)
        N *= 2;
      await new Promise((M) => setTimeout(M, N + // add random timeout from 300ms to 3s
      Math.floor(Math.random() * 2700 + 300)));
    },
    shouldRetry: f = Wr,
    isFatalConnectionProblem: d,
    on: h,
    webSocketImpl: p,
    /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */
    generateID: y = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (U) => {
        const N = Math.random() * 16 | 0;
        return (U == "x" ? N : N & 3 | 8).toString(16);
      });
    },
    jsonMessageReplacer: b,
    jsonMessageReviver: m
  } = e;
  let _;
  if (p) {
    if (!Pl(p))
      throw new Error("Invalid WebSocket implementation provided");
    _ = p;
  } else typeof WebSocket < "u" ? _ = WebSocket : typeof global < "u" ? _ = global.WebSocket || // @ts-expect-error: Support more browsers
  global.MozWebSocket : typeof window < "u" && (_ = window.WebSocket || // @ts-expect-error: Support more browsers
  window.MozWebSocket);
  if (!_)
    throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
  const k = _, S = (() => {
    const C = /* @__PURE__ */ (() => {
      const N = {};
      return {
        on(M, A) {
          return N[M] = A, () => {
            delete N[M];
          };
        },
        emit(M) {
          var A;
          "id" in M && ((A = N[M.id]) === null || A === void 0 || A.call(N, M));
        }
      };
    })(), U = {
      connecting: h != null && h.connecting ? [h.connecting] : [],
      opened: h != null && h.opened ? [h.opened] : [],
      connected: h != null && h.connected ? [h.connected] : [],
      ping: h != null && h.ping ? [h.ping] : [],
      pong: h != null && h.pong ? [h.pong] : [],
      message: h != null && h.message ? [C.emit, h.message] : [C.emit],
      closed: h != null && h.closed ? [h.closed] : [],
      error: h != null && h.error ? [h.error] : []
    };
    return {
      onMessage: C.on,
      on(N, M) {
        const A = U[N];
        return A.push(M), () => {
          A.splice(A.indexOf(M), 1);
        };
      },
      emit(N, ...M) {
        for (const A of [...U[N]])
          A(...M);
      }
    };
  })();
  function O(C) {
    const U = [
      // errors are fatal and more critical than close events, throw them first
      S.on("error", (N) => {
        U.forEach((M) => M()), C(N);
      }),
      // closes can be graceful and not fatal, throw them second (if error didnt throw)
      S.on("closed", (N) => {
        U.forEach((M) => M()), C(N);
      })
    ];
  }
  let T, F = 0, P, x = !1, L = 0, ke = !1;
  async function me() {
    clearTimeout(P);
    const [C, U] = await (T ?? (T = new Promise((A, ce) => (async () => {
      if (x) {
        if (await l(L), !F)
          return T = void 0, ce({ code: 1e3, reason: "All Subscriptions Gone" });
        L++;
      }
      S.emit("connecting", x);
      const $ = new k(typeof t == "function" ? await t() : t, Tl);
      let de, Re;
      function He() {
        isFinite(a) && a > 0 && (clearTimeout(Re), Re = setTimeout(() => {
          $.readyState === k.OPEN && ($.send(Mt({ type: ne.Ping })), S.emit("ping", !1, void 0));
        }, a));
      }
      O((le) => {
        T = void 0, clearTimeout(de), clearTimeout(Re), ce(le), le instanceof Hi && ($.close(4499, "Terminated"), $.onerror = null, $.onclose = null);
      }), $.onerror = (le) => S.emit("error", le), $.onclose = (le) => S.emit("closed", le), $.onopen = async () => {
        try {
          S.emit("opened", $);
          const le = typeof r == "function" ? await r() : r;
          if ($.readyState !== k.OPEN)
            return;
          $.send(Mt(le ? {
            type: ne.ConnectionInit,
            payload: le
          } : {
            type: ne.ConnectionInit
            // payload is completely absent if not provided
          }, b)), isFinite(u) && u > 0 && (de = setTimeout(() => {
            $.close(_e.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
          }, u)), He();
        } catch (le) {
          S.emit("error", le), $.close(_e.InternalClientError, Ki(le instanceof Error ? le.message : new Error(le).message, "Internal client error"));
        }
      };
      let ot = !1;
      $.onmessage = ({ data: le }) => {
        try {
          const ae = Dl(le, m);
          if (S.emit("message", ae), ae.type === "ping" || ae.type === "pong") {
            S.emit(ae.type, !0, ae.payload), ae.type === "pong" ? He() : s || ($.send(Mt(ae.payload ? {
              type: ne.Pong,
              payload: ae.payload
            } : {
              type: ne.Pong
              // payload is completely absent if not provided
            })), S.emit("pong", !1, ae.payload));
            return;
          }
          if (ot)
            return;
          if (ae.type !== ne.ConnectionAck)
            throw new Error(`First message cannot be of type ${ae.type}`);
          clearTimeout(de), ot = !0, S.emit("connected", $, ae.payload, x), x = !1, L = 0, A([
            $,
            new Promise((Vy, Ss) => O(Ss))
          ]);
        } catch (ae) {
          $.onmessage = null, S.emit("error", ae), $.close(_e.BadResponse, Ki(ae instanceof Error ? ae.message : new Error(ae).message, "Bad response"));
        }
      };
    })())));
    C.readyState === k.CLOSING && await U;
    let N = () => {
    };
    const M = new Promise((A) => N = A);
    return [
      C,
      N,
      Promise.race([
        // wait for
        M.then(() => {
          if (!F) {
            const A = () => C.close(1e3, "Normal Closure");
            isFinite(o) && o > 0 ? P = setTimeout(() => {
              C.readyState === k.OPEN && A();
            }, o) : A();
          }
        }),
        // or
        U
      ])
    ];
  }
  function ee(C) {
    if (Wr(C) && (Rl(C.code) || [
      _e.InternalServerError,
      _e.InternalClientError,
      _e.BadRequest,
      _e.BadResponse,
      _e.Unauthorized,
      // CloseCode.Forbidden, might grant access out after retry
      _e.SubprotocolNotAcceptable,
      // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
      // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
      _e.SubscriberAlreadyExists,
      _e.TooManyInitialisationRequests
      // 4499, // Terminated, probably because the socket froze, we want to retry
    ].includes(C.code)))
      throw C;
    if (ke)
      return !1;
    if (Wr(C) && C.code === 1e3)
      return F > 0;
    if (!c || L >= c || !f(C) || d != null && d(C))
      throw C;
    return x = !0;
  }
  n || (async () => {
    for (F++; ; )
      try {
        const [, , C] = await me();
        await C;
      } catch (C) {
        try {
          if (!ee(C))
            return;
        } catch (U) {
          return i == null ? void 0 : i(U);
        }
      }
  })();
  function he(C, U) {
    const N = y(C);
    let M = !1, A = !1, ce = () => {
      F--, M = !0;
    };
    return (async () => {
      for (F++; ; )
        try {
          const [$, de, Re] = await me();
          if (M)
            return de();
          const He = S.onMessage(N, (ot) => {
            switch (ot.type) {
              case ne.Next: {
                U.next(ot.payload);
                return;
              }
              case ne.Error: {
                A = !0, M = !0, U.error(ot.payload), ce();
                return;
              }
              case ne.Complete: {
                M = !0, ce();
                return;
              }
            }
          });
          $.send(Mt({
            id: N,
            type: ne.Subscribe,
            payload: C
          }, b)), ce = () => {
            !M && $.readyState === k.OPEN && $.send(Mt({
              id: N,
              type: ne.Complete
            }, b)), F--, M = !0, de();
          }, await Re.finally(He);
          return;
        } catch ($) {
          if (!ee($))
            return;
        }
    })().then(() => {
      A || U.complete();
    }).catch(($) => {
      U.error($);
    }), () => {
      M || ce();
    };
  }
  return {
    on: S.on,
    subscribe: he,
    iterate(C) {
      const U = [], N = {
        done: !1,
        error: null,
        resolve: () => {
        }
      }, M = he(C, {
        next(ce) {
          U.push(ce), N.resolve();
        },
        error(ce) {
          N.done = !0, N.error = ce, N.resolve();
        },
        complete() {
          N.done = !0, N.resolve();
        }
      }), A = (function() {
        return Il(this, arguments, function* () {
          for (; ; ) {
            for (U.length || (yield mt(new Promise((de) => N.resolve = de))); U.length; )
              yield yield mt(U.shift());
            if (N.error)
              throw N.error;
            if (N.done)
              return yield mt(void 0);
          }
        });
      })();
      return A.throw = async (ce) => (N.done || (N.done = !0, N.error = ce, N.resolve()), { done: !0, value: void 0 }), A.return = async () => (M(), { done: !0, value: void 0 }), A;
    },
    async dispose() {
      if (ke = !0, T) {
        const [C] = await T;
        C.close(1e3, "Normal Closure");
      }
    },
    terminate() {
      T && S.emit("closed", new Hi());
    }
  };
}
class Hi extends Error {
  constructor() {
    super(...arguments), this.name = "TerminatedCloseEvent", this.message = "4499: Terminated", this.code = 4499, this.reason = "Terminated", this.wasClean = !1;
  }
}
function Wr(e) {
  return Xe(e) && "code" in e && "reason" in e;
}
function Rl(e) {
  return [
    1e3,
    // Normal Closure is not an erroneous close code
    1001,
    // Going Away
    1006,
    // Abnormal Closure
    1005,
    // No Status Received
    1012,
    // Service Restart
    1013,
    // Try Again Later
    1014
    // Bad Gateway
  ].includes(e) ? !1 : e >= 1e3 && e <= 1999;
}
function Pl(e) {
  return typeof e == "function" && "constructor" in e && "CLOSED" in e && "CLOSING" in e && "CONNECTING" in e && "OPEN" in e;
}
const Fl = (e, t) => {
  const r = new sa({
    credentials: "include",
    uri: e
  }), n = new Sl(
    zl({
      url: t,
      lazy: !0
    })
  ), i = bc(
    ({ query: a }) => {
      const s = zt(a);
      return s.kind === "OperationDefinition" && s.operation === "subscription";
    },
    n,
    r
  );
  return new za({
    cache: new Da(),
    link: gc([i]),
    credentials: "include"
  });
};
class By {
  constructor(t, r) {
    Ft(this, "endpoint");
    Ft(this, "apolloClient");
    Ft(this, "uploadToS3", async (t, r, n) => {
      const i = {};
      return new Q((o) => {
        const a = new FormData(), { url: s } = i.data.presignedFormData, u = JSON.parse(
          i.data.presignedFormData.fields
        );
        Object.keys(u).forEach((l) => {
          a.append(l, u[l]);
        }), a.append("file", t);
        const c = new XMLHttpRequest();
        c.open("POST", s), c.upload.addEventListener("progress", (l) => {
          const f = l.loaded / l.total;
          o.next({ progress: f });
        }), c.upload.addEventListener("load", () => {
          c.upload.removeEventListener("progress", () => null), o.complete();
        }), c.send(a);
      });
    });
    this.endpoint = t;
    try {
      this.apolloClient = Fl(
        `${t}/graphql`,
        `${r}`
      );
    } catch (n) {
      throw console.error(n), new Error("Failed to create apollo client");
    }
  }
  downloadS3File(t, r = null) {
    return new Promise((n) => {
      const i = `${this.endpoint}/download?bucket=${t.bucket}&key=${t.key}&isFolder=${t.isFolder ? 1 : 0}${r ? `&limit=${r}` : ""}`, o = new XMLHttpRequest();
      o.withCredentials = !0, o.open("GET", i, !0), o.setRequestHeader("Content-Type", "application/json"), o.responseType = "blob", o.addEventListener("load", function() {
        return n(this.response);
      }), o.send(JSON.stringify({ ...t, limit: r }));
    });
  }
  async refreshToken() {
    fetch(`${this.endpoint}/refreshToken`, {
      method: "POST",
      credentials: "include"
    });
  }
}
function w(e, t, r) {
  function n(s, u) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: u,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, u);
    const c = a.prototype, l = Object.keys(c);
    for (let f = 0; f < l.length; f++) {
      const d = l[f];
      d in s || (s[d] = c[d].bind(s));
    }
  }
  const i = (r == null ? void 0 : r.Parent) ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var u;
    const c = r != null && r.Parent ? new o() : this;
    n(c, s), (u = c._zod).deferred ?? (u.deferred = []);
    for (const l of c._zod.deferred)
      l();
    return c;
  }
  return Object.defineProperty(a, "init", { value: n }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var u, c;
      return r != null && r.Parent && s instanceof r.Parent ? !0 : (c = (u = s == null ? void 0 : s._zod) == null ? void 0 : u.traits) == null ? void 0 : c.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class gt extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Pa extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Fa = {};
function Be(e) {
  return Fa;
}
function Na(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, i]) => t.indexOf(+n) === -1).map(([n, i]) => i);
}
function bn(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function qn(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Zn(e) {
  return e == null;
}
function Qn(e) {
  const t = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, r);
}
function Nl(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = t.toString();
  let i = (n.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(n)) {
    const u = n.match(/\d?e-(\d?)/);
    u != null && u[1] && (i = Number.parseInt(u[1]));
  }
  const o = r > i ? r : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const Yi = Symbol("evaluating");
function Z(e, t, r) {
  let n;
  Object.defineProperty(e, t, {
    get() {
      if (n !== Yi)
        return n === void 0 && (n = Yi, n = r()), n;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function it(e, t, r) {
  Object.defineProperty(e, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Ge(...e) {
  const t = {};
  for (const r of e) {
    const n = Object.getOwnPropertyDescriptors(r);
    Object.assign(t, n);
  }
  return Object.defineProperties({}, t);
}
function Xi(e) {
  return JSON.stringify(e);
}
function Cl(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const Ca = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function yr(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Al = qn(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function Et(e) {
  if (yr(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const r = t.prototype;
  return !(yr(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function Aa(e) {
  return Et(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const xl = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function St(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Ke(e, t, r) {
  const n = new e._zod.constr(t ?? e._zod.def);
  return (!t || r != null && r.parent) && (n._zod.parent = e), n;
}
function R(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Ml(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const jl = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function $l(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const o = Ge(e._zod.def, {
    get shape() {
      const a = {};
      for (const s in t) {
        if (!(s in r.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && (a[s] = r.shape[s]);
      }
      return it(this, "shape", a), a;
    },
    checks: []
  });
  return Ke(e, o);
}
function Ll(e, t) {
  const r = e._zod.def, n = r.checks;
  if (n && n.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const o = Ge(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape };
      for (const s in t) {
        if (!(s in r.shape))
          throw new Error(`Unrecognized key: "${s}"`);
        t[s] && delete a[s];
      }
      return it(this, "shape", a), a;
    },
    checks: []
  });
  return Ke(e, o);
}
function Vl(e, t) {
  if (!Et(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = e._zod.def.checks;
  if (r && r.length > 0) {
    const o = e._zod.def.shape;
    for (const a in t)
      if (Object.getOwnPropertyDescriptor(o, a) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const i = Ge(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return it(this, "shape", o), o;
    }
  });
  return Ke(e, i);
}
function ql(e, t) {
  if (!Et(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const r = Ge(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape, ...t };
      return it(this, "shape", n), n;
    }
  });
  return Ke(e, r);
}
function Zl(e, t) {
  const r = Ge(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape, ...t._zod.def.shape };
      return it(this, "shape", n), n;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Ke(e, r);
}
function Ql(e, t, r) {
  const i = t._zod.def.checks;
  if (i && i.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const a = Ge(t._zod.def, {
    get shape() {
      const s = t._zod.def.shape, u = { ...s };
      if (r)
        for (const c in r) {
          if (!(c in s))
            throw new Error(`Unrecognized key: "${c}"`);
          r[c] && (u[c] = e ? new e({
            type: "optional",
            innerType: s[c]
          }) : s[c]);
        }
      else
        for (const c in s)
          u[c] = e ? new e({
            type: "optional",
            innerType: s[c]
          }) : s[c];
      return it(this, "shape", u), u;
    },
    checks: []
  });
  return Ke(t, a);
}
function Ul(e, t, r) {
  const n = Ge(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (r)
        for (const a in r) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          r[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return it(this, "shape", o), o;
    }
  });
  return Ke(t, n);
}
function ht(e, t = 0) {
  var r;
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (((r = e.issues[n]) == null ? void 0 : r.continue) !== !0)
      return !0;
  return !1;
}
function dt(e, t) {
  return t.map((r) => {
    var n;
    return (n = r).path ?? (n.path = []), r.path.unshift(e), r;
  });
}
function tr(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function We(e, t, r) {
  var i, o, a, s, u, c;
  const n = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const l = tr((a = (o = (i = e.inst) == null ? void 0 : i._zod.def) == null ? void 0 : o.error) == null ? void 0 : a.call(o, e)) ?? tr((s = t == null ? void 0 : t.error) == null ? void 0 : s.call(t, e)) ?? tr((u = r.customError) == null ? void 0 : u.call(r, e)) ?? tr((c = r.localeError) == null ? void 0 : c.call(r, e)) ?? "Invalid input";
    n.message = l;
  }
  return delete n.inst, delete n.continue, t != null && t.reportInput || delete n.input, n;
}
function Un(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Gt(...e) {
  const [t, r, n] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: n
  } : { ...t };
}
const xa = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, bn, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, Ma = w("$ZodError", xa), ja = w("$ZodError", xa, { Parent: Error });
function Bl(e, t = (r) => r.message) {
  const r = {}, n = [];
  for (const i of e.issues)
    i.path.length > 0 ? (r[i.path[0]] = r[i.path[0]] || [], r[i.path[0]].push(t(i))) : n.push(t(i));
  return { formErrors: n, fieldErrors: r };
}
function Wl(e, t = (r) => r.message) {
  const r = { _errors: [] }, n = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => n({ issues: a }));
      else if (o.code === "invalid_key")
        n({ issues: o.issues });
      else if (o.code === "invalid_element")
        n({ issues: o.issues });
      else if (o.path.length === 0)
        r._errors.push(t(o));
      else {
        let a = r, s = 0;
        for (; s < o.path.length; ) {
          const u = o.path[s];
          s === o.path.length - 1 ? (a[u] = a[u] || { _errors: [] }, a[u]._errors.push(t(o))) : a[u] = a[u] || { _errors: [] }, a = a[u], s++;
        }
      }
  };
  return n(e), r;
}
const Bn = (e) => (t, r, n, i) => {
  const o = n ? Object.assign(n, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: r, issues: [] }, o);
  if (a instanceof Promise)
    throw new gt();
  if (a.issues.length) {
    const s = new ((i == null ? void 0 : i.Err) ?? e)(a.issues.map((u) => We(u, o, Be())));
    throw Ca(s, i == null ? void 0 : i.callee), s;
  }
  return a.value;
}, Wn = (e) => async (t, r, n, i) => {
  const o = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: r, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new ((i == null ? void 0 : i.Err) ?? e)(a.issues.map((u) => We(u, o, Be())));
    throw Ca(s, i == null ? void 0 : i.callee), s;
  }
  return a.value;
}, Ir = (e) => (t, r, n) => {
  const i = n ? { ...n, async: !1 } : { async: !1 }, o = t._zod.run({ value: r, issues: [] }, i);
  if (o instanceof Promise)
    throw new gt();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? Ma)(o.issues.map((a) => We(a, i, Be())))
  } : { success: !0, data: o.value };
}, Jl = /* @__PURE__ */ Ir(ja), zr = (e) => async (t, r, n) => {
  const i = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: r, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => We(a, i, Be())))
  } : { success: !0, data: o.value };
}, Gl = /* @__PURE__ */ zr(ja), Kl = (e) => (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Bn(e)(t, r, i);
}, Hl = (e) => (t, r, n) => Bn(e)(t, r, n), Yl = (e) => async (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Wn(e)(t, r, i);
}, Xl = (e) => async (t, r, n) => Wn(e)(t, r, n), ef = (e) => (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return Ir(e)(t, r, i);
}, tf = (e) => (t, r, n) => Ir(e)(t, r, n), rf = (e) => async (t, r, n) => {
  const i = n ? Object.assign(n, { direction: "backward" }) : { direction: "backward" };
  return zr(e)(t, r, i);
}, nf = (e) => async (t, r, n) => zr(e)(t, r, n), of = /^[cC][^\s-]{8,}$/, af = /^[0-9a-z]+$/, sf = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, uf = /^[0-9a-vA-V]{20}$/, cf = /^[A-Za-z0-9]{27}$/, lf = /^[a-zA-Z0-9_-]{21}$/, ff = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, hf = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, eo = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, df = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, pf = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function vf() {
  return new RegExp(pf, "u");
}
const yf = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, mf = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, gf = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, bf = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, _f = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, $a = /^[A-Za-z0-9_-]*$/, wf = /^\+[1-9]\d{6,14}$/, La = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", kf = /* @__PURE__ */ new RegExp(`^${La}$`);
function Va(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Ef(e) {
  return new RegExp(`^${Va(e)}$`);
}
function Sf(e) {
  const t = Va({ precision: e.precision }), r = ["Z"];
  e.local && r.push(""), e.offset && r.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const n = `${t}(?:${r.join("|")})`;
  return new RegExp(`^${La}T(?:${n})$`);
}
const Of = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Tf = /^-?\d+$/, qa = /^-?\d+(?:\.\d+)?$/, Df = /^(?:true|false)$/i, If = /^[^A-Z]*$/, zf = /^[^a-z]*$/, be = /* @__PURE__ */ w("$ZodCheck", (e, t) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = t, (r = e._zod).onattach ?? (r.onattach = []);
}), Za = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, Qa = /* @__PURE__ */ w("$ZodCheckLessThan", (e, t) => {
  be.init(e, t);
  const r = Za[typeof t.value];
  e._zod.onattach.push((n) => {
    const i = n._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (n) => {
    (t.inclusive ? n.value <= t.value : n.value < t.value) || n.issues.push({
      origin: r,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Ua = /* @__PURE__ */ w("$ZodCheckGreaterThan", (e, t) => {
  be.init(e, t);
  const r = Za[typeof t.value];
  e._zod.onattach.push((n) => {
    const i = n._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (n) => {
    (t.inclusive ? n.value >= t.value : n.value > t.value) || n.issues.push({
      origin: r,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: n.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Rf = /* @__PURE__ */ w("$ZodCheckMultipleOf", (e, t) => {
  be.init(e, t), e._zod.onattach.push((r) => {
    var n;
    (n = r._zod.bag).multipleOf ?? (n.multipleOf = t.value);
  }), e._zod.check = (r) => {
    if (typeof r.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? r.value % t.value === BigInt(0) : Nl(r.value, t.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Pf = /* @__PURE__ */ w("$ZodCheckNumberFormat", (e, t) => {
  var a;
  be.init(e, t), t.format = t.format || "float64";
  const r = (a = t.format) == null ? void 0 : a.includes("int"), n = r ? "int" : "number", [i, o] = jl[t.format];
  e._zod.onattach.push((s) => {
    const u = s._zod.bag;
    u.format = t.format, u.minimum = i, u.maximum = o, r && (u.pattern = Tf);
  }), e._zod.check = (s) => {
    const u = s.value;
    if (r) {
      if (!Number.isInteger(u)) {
        s.issues.push({
          expected: n,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: u,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(u)) {
        u > 0 ? s.issues.push({
          input: u,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: u,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: n,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    u < i && s.issues.push({
      origin: "number",
      input: u,
      code: "too_small",
      minimum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), u > o && s.issues.push({
      origin: "number",
      input: u,
      code: "too_big",
      maximum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), Ff = /* @__PURE__ */ w("$ZodCheckMaxLength", (e, t) => {
  var r;
  be.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !Zn(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (n._zod.bag.maximum = t.maximum);
  }), e._zod.check = (n) => {
    const i = n.value;
    if (i.length <= t.maximum)
      return;
    const a = Un(i);
    n.issues.push({
      origin: a,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Nf = /* @__PURE__ */ w("$ZodCheckMinLength", (e, t) => {
  var r;
  be.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !Zn(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (n._zod.bag.minimum = t.minimum);
  }), e._zod.check = (n) => {
    const i = n.value;
    if (i.length >= t.minimum)
      return;
    const a = Un(i);
    n.issues.push({
      origin: a,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Cf = /* @__PURE__ */ w("$ZodCheckLengthEquals", (e, t) => {
  var r;
  be.init(e, t), (r = e._zod.def).when ?? (r.when = (n) => {
    const i = n.value;
    return !Zn(i) && i.length !== void 0;
  }), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (n) => {
    const i = n.value, o = i.length;
    if (o === t.length)
      return;
    const a = Un(i), s = o > t.length;
    n.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Rr = /* @__PURE__ */ w("$ZodCheckStringFormat", (e, t) => {
  var r, n;
  be.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (r = e._zod).check ?? (r.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (n = e._zod).check ?? (n.check = () => {
  });
}), Af = /* @__PURE__ */ w("$ZodCheckRegex", (e, t) => {
  Rr.init(e, t), e._zod.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), xf = /* @__PURE__ */ w("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = If), Rr.init(e, t);
}), Mf = /* @__PURE__ */ w("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = zf), Rr.init(e, t);
}), jf = /* @__PURE__ */ w("$ZodCheckIncludes", (e, t) => {
  be.init(e, t);
  const r = St(t.includes), n = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${r}` : r);
  t.pattern = n, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), $f = /* @__PURE__ */ w("$ZodCheckStartsWith", (e, t) => {
  be.init(e, t);
  const r = new RegExp(`^${St(t.prefix)}.*`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.startsWith(t.prefix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Lf = /* @__PURE__ */ w("$ZodCheckEndsWith", (e, t) => {
  be.init(e, t);
  const r = new RegExp(`.*${St(t.suffix)}$`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const i = n._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.endsWith(t.suffix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Vf = /* @__PURE__ */ w("$ZodCheckOverwrite", (e, t) => {
  be.init(e, t), e._zod.check = (r) => {
    r.value = t.tx(r.value);
  };
});
class qf {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((a) => a), i = Math.min(...n.map((a) => a.length - a.trimStart().length)), o = n.map((a) => a.slice(i)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of o)
      this.content.push(a);
  }
  compile() {
    const t = Function, r = this == null ? void 0 : this.args, i = [...((this == null ? void 0 : this.content) ?? [""]).map((o) => `  ${o}`)];
    return new t(...r, i.join(`
`));
  }
}
const Zf = {
  major: 4,
  minor: 3,
  patch: 6
}, H = /* @__PURE__ */ w("$ZodType", (e, t) => {
  var i;
  var r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Zf;
  const n = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && n.unshift(e);
  for (const o of n)
    for (const a of o._zod.onattach)
      a(e);
  if (n.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (i = e._zod.deferred) == null || i.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, u, c) => {
      let l = ht(s), f;
      for (const d of u) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (l)
          continue;
        const h = s.issues.length, p = d._zod.check(s);
        if (p instanceof Promise && (c == null ? void 0 : c.async) === !1)
          throw new gt();
        if (f || p instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await p, s.issues.length !== h && (l || (l = ht(s, h)));
          });
        else {
          if (s.issues.length === h)
            continue;
          l || (l = ht(s, h));
        }
      }
      return f ? f.then(() => s) : s;
    }, a = (s, u, c) => {
      if (ht(s))
        return s.aborted = !0, s;
      const l = o(u, n, c);
      if (l instanceof Promise) {
        if (c.async === !1)
          throw new gt();
        return l.then((f) => e._zod.parse(f, c));
      }
      return e._zod.parse(l, c);
    };
    e._zod.run = (s, u) => {
      if (u.skipChecks)
        return e._zod.parse(s, u);
      if (u.direction === "backward") {
        const l = e._zod.parse({ value: s.value, issues: [] }, { ...u, skipChecks: !0 });
        return l instanceof Promise ? l.then((f) => a(f, s, u)) : a(l, s, u);
      }
      const c = e._zod.parse(s, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new gt();
        return c.then((l) => o(l, n, u));
      }
      return o(c, n, u);
    };
  }
  Z(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = Jl(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return Gl(e, o).then((u) => {
          var c;
          return u.success ? { value: u.data } : { issues: (c = u.error) == null ? void 0 : c.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Jn = /* @__PURE__ */ w("$ZodString", (e, t) => {
  var r;
  H.init(e, t), e._zod.pattern = [...((r = e == null ? void 0 : e._zod.bag) == null ? void 0 : r.patterns) ?? []].pop() ?? Of(e._zod.bag), e._zod.parse = (n, i) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), J = /* @__PURE__ */ w("$ZodStringFormat", (e, t) => {
  Rr.init(e, t), Jn.init(e, t);
}), Qf = /* @__PURE__ */ w("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = hf), J.init(e, t);
}), Uf = /* @__PURE__ */ w("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = eo(n));
  } else
    t.pattern ?? (t.pattern = eo());
  J.init(e, t);
}), Bf = /* @__PURE__ */ w("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = df), J.init(e, t);
}), Wf = /* @__PURE__ */ w("$ZodURL", (e, t) => {
  J.init(e, t), e._zod.check = (r) => {
    try {
      const n = r.value.trim(), i = new URL(n);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? r.value = i.href : r.value = n;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Jf = /* @__PURE__ */ w("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = vf()), J.init(e, t);
}), Gf = /* @__PURE__ */ w("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = lf), J.init(e, t);
}), Kf = /* @__PURE__ */ w("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = of), J.init(e, t);
}), Hf = /* @__PURE__ */ w("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = af), J.init(e, t);
}), Yf = /* @__PURE__ */ w("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = sf), J.init(e, t);
}), Xf = /* @__PURE__ */ w("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = uf), J.init(e, t);
}), eh = /* @__PURE__ */ w("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = cf), J.init(e, t);
}), th = /* @__PURE__ */ w("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Sf(t)), J.init(e, t);
}), rh = /* @__PURE__ */ w("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = kf), J.init(e, t);
}), nh = /* @__PURE__ */ w("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Ef(t)), J.init(e, t);
}), ih = /* @__PURE__ */ w("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = ff), J.init(e, t);
}), oh = /* @__PURE__ */ w("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = yf), J.init(e, t), e._zod.bag.format = "ipv4";
}), ah = /* @__PURE__ */ w("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = mf), J.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), sh = /* @__PURE__ */ w("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = gf), J.init(e, t);
}), uh = /* @__PURE__ */ w("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = bf), J.init(e, t), e._zod.check = (r) => {
    const n = r.value.split("/");
    try {
      if (n.length !== 2)
        throw new Error();
      const [i, o] = n;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Ba(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const ch = /* @__PURE__ */ w("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = _f), J.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (r) => {
    Ba(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function lh(e) {
  if (!$a.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (n) => n === "-" ? "+" : "/"), r = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Ba(r);
}
const fh = /* @__PURE__ */ w("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = $a), J.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (r) => {
    lh(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), hh = /* @__PURE__ */ w("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = wf), J.init(e, t);
});
function dh(e, t = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3)
      return !1;
    const [n] = r;
    if (!n)
      return !1;
    const i = JSON.parse(atob(n));
    return !("typ" in i && (i == null ? void 0 : i.typ) !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const ph = /* @__PURE__ */ w("$ZodJWT", (e, t) => {
  J.init(e, t), e._zod.check = (r) => {
    dh(r.value, t.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Wa = /* @__PURE__ */ w("$ZodNumber", (e, t) => {
  H.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? qa, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const i = r.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return r;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), r;
  };
}), vh = /* @__PURE__ */ w("$ZodNumberFormat", (e, t) => {
  Pf.init(e, t), Wa.init(e, t);
}), yh = /* @__PURE__ */ w("$ZodBoolean", (e, t) => {
  H.init(e, t), e._zod.pattern = Df, e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = !!r.value;
      } catch {
      }
    const i = r.value;
    return typeof i == "boolean" || r.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), r;
  };
}), mh = /* @__PURE__ */ w("$ZodUnknown", (e, t) => {
  H.init(e, t), e._zod.parse = (r) => r;
}), gh = /* @__PURE__ */ w("$ZodNever", (e, t) => {
  H.init(e, t), e._zod.parse = (r, n) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
});
function to(e, t, r) {
  e.issues.length && t.issues.push(...dt(r, e.issues)), t.value[r] = e.value;
}
const bh = /* @__PURE__ */ w("$ZodArray", (e, t) => {
  H.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value;
    if (!Array.isArray(i))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), r;
    r.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], u = t.element._zod.run({
        value: s,
        issues: []
      }, n);
      u instanceof Promise ? o.push(u.then((c) => to(c, r, a))) : to(u, r, a);
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
});
function mr(e, t, r, n, i) {
  if (e.issues.length) {
    if (i && !(r in n))
      return;
    t.issues.push(...dt(r, e.issues));
  }
  e.value === void 0 ? r in n && (t.value[r] = void 0) : t.value[r] = e.value;
}
function Ja(e) {
  var n, i, o, a;
  const t = Object.keys(e.shape);
  for (const s of t)
    if (!((a = (o = (i = (n = e.shape) == null ? void 0 : n[s]) == null ? void 0 : i._zod) == null ? void 0 : o.traits) != null && a.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const r = Ml(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(r)
  };
}
function Ga(e, t, r, n, i, o) {
  const a = [], s = i.keySet, u = i.catchall._zod, c = u.def.type, l = u.optout === "optional";
  for (const f in t) {
    if (s.has(f))
      continue;
    if (c === "never") {
      a.push(f);
      continue;
    }
    const d = u.run({ value: t[f], issues: [] }, n);
    d instanceof Promise ? e.push(d.then((h) => mr(h, r, f, t, l))) : mr(d, r, f, t, l);
  }
  return a.length && r.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => r) : r;
}
const _h = /* @__PURE__ */ w("$ZodObject", (e, t) => {
  H.init(e, t);
  const r = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(r != null && r.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const u = { ...s };
        return Object.defineProperty(t, "shape", {
          value: u
        }), u;
      }
    });
  }
  const n = qn(() => Ja(t));
  Z(e._zod, "propValues", () => {
    const s = t.shape, u = {};
    for (const c in s) {
      const l = s[c]._zod;
      if (l.values) {
        u[c] ?? (u[c] = /* @__PURE__ */ new Set());
        for (const f of l.values)
          u[c].add(f);
      }
    }
    return u;
  });
  const i = yr, o = t.catchall;
  let a;
  e._zod.parse = (s, u) => {
    a ?? (a = n.value);
    const c = s.value;
    if (!i(c))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: c,
        inst: e
      }), s;
    s.value = {};
    const l = [], f = a.shape;
    for (const d of a.keys) {
      const h = f[d], p = h._zod.optout === "optional", y = h._zod.run({ value: c[d], issues: [] }, u);
      y instanceof Promise ? l.push(y.then((b) => mr(b, s, d, c, p))) : mr(y, s, d, c, p);
    }
    return o ? Ga(l, c, s, u, n.value, e) : l.length ? Promise.all(l).then(() => s) : s;
  };
}), wh = /* @__PURE__ */ w("$ZodObjectJIT", (e, t) => {
  _h.init(e, t);
  const r = e._zod.parse, n = qn(() => Ja(t)), i = (d) => {
    var k;
    const h = new qf(["shape", "payload", "ctx"]), p = n.value, y = (S) => {
      const O = Xi(S);
      return `shape[${O}]._zod.run({ value: input[${O}], issues: [] }, ctx)`;
    };
    h.write("const input = payload.value;");
    const b = /* @__PURE__ */ Object.create(null);
    let m = 0;
    for (const S of p.keys)
      b[S] = `key_${m++}`;
    h.write("const newResult = {};");
    for (const S of p.keys) {
      const O = b[S], T = Xi(S), F = d[S], P = ((k = F == null ? void 0 : F._zod) == null ? void 0 : k.optout) === "optional";
      h.write(`const ${O} = ${y(S)};`), P ? h.write(`
        if (${O}.issues.length) {
          if (${T} in input) {
            payload.issues = payload.issues.concat(${O}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${T}, ...iss.path] : [${T}]
            })));
          }
        }
        
        if (${O}.value === undefined) {
          if (${T} in input) {
            newResult[${T}] = undefined;
          }
        } else {
          newResult[${T}] = ${O}.value;
        }
        
      `) : h.write(`
        if (${O}.issues.length) {
          payload.issues = payload.issues.concat(${O}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${T}, ...iss.path] : [${T}]
          })));
        }
        
        if (${O}.value === undefined) {
          if (${T} in input) {
            newResult[${T}] = undefined;
          }
        } else {
          newResult[${T}] = ${O}.value;
        }
        
      `);
    }
    h.write("payload.value = newResult;"), h.write("return payload;");
    const _ = h.compile();
    return (S, O) => _(d, S, O);
  };
  let o;
  const a = yr, s = !Fa.jitless, c = s && Al.value, l = t.catchall;
  let f;
  e._zod.parse = (d, h) => {
    f ?? (f = n.value);
    const p = d.value;
    return a(p) ? s && c && (h == null ? void 0 : h.async) === !1 && h.jitless !== !0 ? (o || (o = i(t.shape)), d = o(d, h), l ? Ga([], p, d, h, f, e) : d) : r(d, h) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), d);
  };
});
function ro(e, t, r, n) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !ht(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: r,
    errors: e.map((o) => o.issues.map((a) => We(a, n, Be())))
  }), t);
}
const kh = /* @__PURE__ */ w("$ZodUnion", (e, t) => {
  H.init(e, t), Z(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), Z(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), Z(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), Z(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => Qn(o.source)).join("|")})$`);
    }
  });
  const r = t.options.length === 1, n = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (r)
      return n(i, o);
    let a = !1;
    const s = [];
    for (const u of t.options) {
      const c = u._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (c instanceof Promise)
        s.push(c), a = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return a ? Promise.all(s).then((u) => ro(u, i, e, o)) : ro(s, i, e, o);
  };
}), Eh = /* @__PURE__ */ w("$ZodIntersection", (e, t) => {
  H.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value, o = t.left._zod.run({ value: i, issues: [] }, n), a = t.right._zod.run({ value: i, issues: [] }, n);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([u, c]) => no(r, u, c)) : no(r, o, a);
  };
});
function _n(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Et(e) && Et(t)) {
    const r = Object.keys(t), n = Object.keys(e).filter((o) => r.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of n) {
      const a = _n(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n], o = t[n], a = _n(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [n, ...a.mergeErrorPath]
        };
      r.push(a.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function no(e, t, r) {
  const n = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const u of s.keys)
        n.has(u) || n.set(u, {}), n.get(u).l = !0;
    } else
      e.issues.push(s);
  for (const s of r.issues)
    if (s.code === "unrecognized_keys")
      for (const u of s.keys)
        n.has(u) || n.set(u, {}), n.get(u).r = !0;
    else
      e.issues.push(s);
  const o = [...n].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), ht(e))
    return e;
  const a = _n(t.value, r.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const Sh = /* @__PURE__ */ w("$ZodRecord", (e, t) => {
  H.init(e, t), e._zod.parse = (r, n) => {
    const i = r.value;
    if (!Et(i))
      return r.issues.push({
        expected: "record",
        code: "invalid_type",
        input: i,
        inst: e
      }), r;
    const o = [], a = t.keyType._zod.values;
    if (a) {
      r.value = {};
      const s = /* @__PURE__ */ new Set();
      for (const c of a)
        if (typeof c == "string" || typeof c == "number" || typeof c == "symbol") {
          s.add(typeof c == "number" ? c.toString() : c);
          const l = t.valueType._zod.run({ value: i[c], issues: [] }, n);
          l instanceof Promise ? o.push(l.then((f) => {
            f.issues.length && r.issues.push(...dt(c, f.issues)), r.value[c] = f.value;
          })) : (l.issues.length && r.issues.push(...dt(c, l.issues)), r.value[c] = l.value);
        }
      let u;
      for (const c in i)
        s.has(c) || (u = u ?? [], u.push(c));
      u && u.length > 0 && r.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: u
      });
    } else {
      r.value = {};
      for (const s of Reflect.ownKeys(i)) {
        if (s === "__proto__")
          continue;
        let u = t.keyType._zod.run({ value: s, issues: [] }, n);
        if (u instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof s == "string" && qa.test(s) && u.issues.length) {
          const f = t.keyType._zod.run({ value: Number(s), issues: [] }, n);
          if (f instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          f.issues.length === 0 && (u = f);
        }
        if (u.issues.length) {
          t.mode === "loose" ? r.value[s] = i[s] : r.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: u.issues.map((f) => We(f, n, Be())),
            input: s,
            path: [s],
            inst: e
          });
          continue;
        }
        const l = t.valueType._zod.run({ value: i[s], issues: [] }, n);
        l instanceof Promise ? o.push(l.then((f) => {
          f.issues.length && r.issues.push(...dt(s, f.issues)), r.value[u.value] = f.value;
        })) : (l.issues.length && r.issues.push(...dt(s, l.issues)), r.value[u.value] = l.value);
      }
    }
    return o.length ? Promise.all(o).then(() => r) : r;
  };
}), Oh = /* @__PURE__ */ w("$ZodEnum", (e, t) => {
  H.init(e, t);
  const r = Na(t.entries), n = new Set(r);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${r.filter((i) => xl.has(typeof i)).map((i) => typeof i == "string" ? St(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return n.has(a) || i.issues.push({
      code: "invalid_value",
      values: r,
      input: a,
      inst: e
    }), i;
  };
}), Th = /* @__PURE__ */ w("$ZodLiteral", (e, t) => {
  if (H.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const r = new Set(t.values);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${t.values.map((n) => typeof n == "string" ? St(n) : n ? St(n.toString()) : String(n)).join("|")})$`), e._zod.parse = (n, i) => {
    const o = n.value;
    return r.has(o) || n.issues.push({
      code: "invalid_value",
      values: t.values,
      input: o,
      inst: e
    }), n;
  };
}), Dh = /* @__PURE__ */ w("$ZodTransform", (e, t) => {
  H.init(e, t), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      throw new Pa(e.constructor.name);
    const i = t.transform(r.value, r);
    if (n.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((a) => (r.value = a, r));
    if (i instanceof Promise)
      throw new gt();
    return r.value = i, r;
  };
});
function io(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Ka = /* @__PURE__ */ w("$ZodOptional", (e, t) => {
  H.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", Z(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), Z(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Qn(r.source)})?$`) : void 0;
  }), e._zod.parse = (r, n) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(r, n);
      return i instanceof Promise ? i.then((o) => io(o, r.value)) : io(i, r.value);
    }
    return r.value === void 0 ? r : t.innerType._zod.run(r, n);
  };
}), Ih = /* @__PURE__ */ w("$ZodExactOptional", (e, t) => {
  Ka.init(e, t), Z(e._zod, "values", () => t.innerType._zod.values), Z(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (r, n) => t.innerType._zod.run(r, n);
}), zh = /* @__PURE__ */ w("$ZodNullable", (e, t) => {
  H.init(e, t), Z(e._zod, "optin", () => t.innerType._zod.optin), Z(e._zod, "optout", () => t.innerType._zod.optout), Z(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Qn(r.source)}|null)$`) : void 0;
  }), Z(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (r, n) => r.value === null ? r : t.innerType._zod.run(r, n);
}), Rh = /* @__PURE__ */ w("$ZodDefault", (e, t) => {
  H.init(e, t), e._zod.optin = "optional", Z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    if (r.value === void 0)
      return r.value = t.defaultValue, r;
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => oo(o, t)) : oo(i, t);
  };
});
function oo(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Ph = /* @__PURE__ */ w("$ZodPrefault", (e, t) => {
  H.init(e, t), e._zod.optin = "optional", Z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => (n.direction === "backward" || r.value === void 0 && (r.value = t.defaultValue), t.innerType._zod.run(r, n));
}), Fh = /* @__PURE__ */ w("$ZodNonOptional", (e, t) => {
  H.init(e, t), Z(e._zod, "values", () => {
    const r = t.innerType._zod.values;
    return r ? new Set([...r].filter((n) => n !== void 0)) : void 0;
  }), e._zod.parse = (r, n) => {
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => ao(o, e)) : ao(i, e);
  };
});
function ao(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Nh = /* @__PURE__ */ w("$ZodCatch", (e, t) => {
  H.init(e, t), Z(e._zod, "optin", () => t.innerType._zod.optin), Z(e._zod, "optout", () => t.innerType._zod.optout), Z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => (r.value = o.value, o.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: o.issues.map((a) => We(a, n, Be()))
      },
      input: r.value
    }), r.issues = []), r)) : (r.value = i.value, i.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: i.issues.map((o) => We(o, n, Be()))
      },
      input: r.value
    }), r.issues = []), r);
  };
}), Ch = /* @__PURE__ */ w("$ZodPipe", (e, t) => {
  H.init(e, t), Z(e._zod, "values", () => t.in._zod.values), Z(e._zod, "optin", () => t.in._zod.optin), Z(e._zod, "optout", () => t.out._zod.optout), Z(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (r, n) => {
    if (n.direction === "backward") {
      const o = t.out._zod.run(r, n);
      return o instanceof Promise ? o.then((a) => rr(a, t.in, n)) : rr(o, t.in, n);
    }
    const i = t.in._zod.run(r, n);
    return i instanceof Promise ? i.then((o) => rr(o, t.out, n)) : rr(i, t.out, n);
  };
});
function rr(e, t, r) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, r);
}
const Ah = /* @__PURE__ */ w("$ZodReadonly", (e, t) => {
  H.init(e, t), Z(e._zod, "propValues", () => t.innerType._zod.propValues), Z(e._zod, "values", () => t.innerType._zod.values), Z(e._zod, "optin", () => {
    var r, n;
    return (n = (r = t.innerType) == null ? void 0 : r._zod) == null ? void 0 : n.optin;
  }), Z(e._zod, "optout", () => {
    var r, n;
    return (n = (r = t.innerType) == null ? void 0 : r._zod) == null ? void 0 : n.optout;
  }), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      return t.innerType._zod.run(r, n);
    const i = t.innerType._zod.run(r, n);
    return i instanceof Promise ? i.then(so) : so(i);
  };
});
function so(e) {
  return e.value = Object.freeze(e.value), e;
}
const xh = /* @__PURE__ */ w("$ZodCustom", (e, t) => {
  be.init(e, t), H.init(e, t), e._zod.parse = (r, n) => r, e._zod.check = (r) => {
    const n = r.value, i = t.fn(n);
    if (i instanceof Promise)
      return i.then((o) => uo(o, r, n, e));
    uo(i, r, n, e);
  };
});
function uo(e, t, r, n) {
  if (!e) {
    const i = {
      code: "custom",
      input: r,
      inst: n,
      // incorporates params.error into issue reporting
      path: [...n._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !n._zod.def.abort
      // params: inst._zod.def.params,
    };
    n._zod.def.params && (i.params = n._zod.def.params), t.issues.push(Gt(i));
  }
}
var co;
class Mh {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...r) {
    const n = r[0];
    return this._map.set(t, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const r = this._map.get(t);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(t), this;
  }
  get(t) {
    const r = t._zod.parent;
    if (r) {
      const n = { ...this.get(r) ?? {} };
      delete n.id;
      const i = { ...n, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function jh() {
  return new Mh();
}
(co = globalThis).__zod_globalRegistry ?? (co.__zod_globalRegistry = jh());
const Lt = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function $h(e, t) {
  return new e({
    type: "string",
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Lh(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lo(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Vh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Zh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Qh(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Uh(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Bh(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Wh(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Jh(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Gh(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Kh(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Hh(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Yh(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Xh(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ed(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function td(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rd(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nd(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function id(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function od(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ad(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sd(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ud(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cd(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ld(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fd(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hd(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dd(e, t) {
  return new e({
    type: "boolean",
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pd(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function vd(e, t) {
  return new e({
    type: "never",
    ...R(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fo(e, t) {
  return new Qa({
    check: "less_than",
    ...R(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Jr(e, t) {
  return new Qa({
    check: "less_than",
    ...R(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function ho(e, t) {
  return new Ua({
    check: "greater_than",
    ...R(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Gr(e, t) {
  return new Ua({
    check: "greater_than",
    ...R(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function po(e, t) {
  return new Rf({
    check: "multiple_of",
    ...R(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ha(e, t) {
  return new Ff({
    check: "max_length",
    ...R(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function gr(e, t) {
  return new Nf({
    check: "min_length",
    ...R(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ya(e, t) {
  return new Cf({
    check: "length_equals",
    ...R(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function yd(e, t) {
  return new Af({
    check: "string_format",
    format: "regex",
    ...R(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function md(e) {
  return new xf({
    check: "string_format",
    format: "lowercase",
    ...R(e)
  });
}
// @__NO_SIDE_EFFECTS__
function gd(e) {
  return new Mf({
    check: "string_format",
    format: "uppercase",
    ...R(e)
  });
}
// @__NO_SIDE_EFFECTS__
function bd(e, t) {
  return new jf({
    check: "string_format",
    format: "includes",
    ...R(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function _d(e, t) {
  return new $f({
    check: "string_format",
    format: "starts_with",
    ...R(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function wd(e, t) {
  return new Lf({
    check: "string_format",
    format: "ends_with",
    ...R(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Pt(e) {
  return new Vf({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function kd(e) {
  return /* @__PURE__ */ Pt((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function Ed() {
  return /* @__PURE__ */ Pt((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function Sd() {
  return /* @__PURE__ */ Pt((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Od() {
  return /* @__PURE__ */ Pt((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Td() {
  return /* @__PURE__ */ Pt((e) => Cl(e));
}
// @__NO_SIDE_EFFECTS__
function Dd(e, t, r) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...R(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Id(e, t, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...R(r)
  });
}
// @__NO_SIDE_EFFECTS__
function zd(e) {
  const t = /* @__PURE__ */ Rd((r) => (r.addIssue = (n) => {
    if (typeof n == "string")
      r.issues.push(Gt(n, r.value, t._zod.def));
    else {
      const i = n;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = r.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), r.issues.push(Gt(i));
    }
  }, e(r.value, r)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function Rd(e, t) {
  const r = new be({
    check: "custom",
    ...R(t)
  });
  return r._zod.check = e, r;
}
function Xa(e) {
  let t = (e == null ? void 0 : e.target) ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: (e == null ? void 0 : e.metadata) ?? Lt,
    target: t,
    unrepresentable: (e == null ? void 0 : e.unrepresentable) ?? "throw",
    override: (e == null ? void 0 : e.override) ?? (() => {
    }),
    io: (e == null ? void 0 : e.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: (e == null ? void 0 : e.cycles) ?? "ref",
    reused: (e == null ? void 0 : e.reused) ?? "inline",
    external: (e == null ? void 0 : e.external) ?? void 0
  };
}
function ie(e, t, r = { path: [], schemaPath: [] }) {
  var l, f;
  var n;
  const i = e._zod.def, o = t.seen.get(e);
  if (o)
    return o.count++, r.schemaPath.includes(e) && (o.cycle = r.path), o.schema;
  const a = { schema: {}, count: 1, cycle: void 0, path: r.path };
  t.seen.set(e, a);
  const s = (f = (l = e._zod).toJSONSchema) == null ? void 0 : f.call(l);
  if (s)
    a.schema = s;
  else {
    const d = {
      ...r,
      schemaPath: [...r.schemaPath, e],
      path: r.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, a.schema, d);
    else {
      const p = a.schema, y = t.processors[i.type];
      if (!y)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
      y(e, t, p, d);
    }
    const h = e._zod.parent;
    h && (a.ref || (a.ref = h), ie(h, t, d), t.seen.get(h).isParent = !0);
  }
  const u = t.metadataRegistry.get(e);
  return u && Object.assign(a.schema, u), t.io === "input" && pe(e) && (delete a.schema.examples, delete a.schema.default), t.io === "input" && a.schema._prefault && ((n = a.schema).default ?? (n.default = a.schema._prefault)), delete a.schema._prefault, t.seen.get(e).schema;
}
function es(e, t) {
  var a, s, u, c;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = /* @__PURE__ */ new Map();
  for (const l of e.seen.entries()) {
    const f = (a = e.metadataRegistry.get(l[0])) == null ? void 0 : a.id;
    if (f) {
      const d = n.get(f);
      if (d && d !== l[0])
        throw new Error(`Duplicate schema id "${f}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      n.set(f, l[0]);
    }
  }
  const i = (l) => {
    var y;
    const f = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const b = (y = e.external.registry.get(l[0])) == null ? void 0 : y.id, m = e.external.uri ?? ((k) => k);
      if (b)
        return { ref: m(b) };
      const _ = l[1].defId ?? l[1].schema.id ?? `schema${e.counter++}`;
      return l[1].defId = _, { defId: _, ref: `${m("__shared")}#/${f}/${_}` };
    }
    if (l[1] === r)
      return { ref: "#" };
    const h = `#/${f}/`, p = l[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: p, ref: h + p };
  }, o = (l) => {
    if (l[1].schema.$ref)
      return;
    const f = l[1], { ref: d, defId: h } = i(l);
    f.def = { ...f.schema }, h && (f.defId = h);
    const p = f.schema;
    for (const y in p)
      delete p[y];
    p.$ref = d;
  };
  if (e.cycles === "throw")
    for (const l of e.seen.entries()) {
      const f = l[1];
      if (f.cycle)
        throw new Error(`Cycle detected: #/${(s = f.cycle) == null ? void 0 : s.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const l of e.seen.entries()) {
    const f = l[1];
    if (t === l[0]) {
      o(l);
      continue;
    }
    if (e.external) {
      const h = (u = e.external.registry.get(l[0])) == null ? void 0 : u.id;
      if (t !== l[0] && h) {
        o(l);
        continue;
      }
    }
    if ((c = e.metadataRegistry.get(l[0])) == null ? void 0 : c.id) {
      o(l);
      continue;
    }
    if (f.cycle) {
      o(l);
      continue;
    }
    if (f.count > 1 && e.reused === "ref") {
      o(l);
      continue;
    }
  }
}
function ts(e, t) {
  var a, s, u;
  const r = e.seen.get(t);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const n = (c) => {
    const l = e.seen.get(c);
    if (l.ref === null)
      return;
    const f = l.def ?? l.schema, d = { ...f }, h = l.ref;
    if (l.ref = null, h) {
      n(h);
      const y = e.seen.get(h), b = y.schema;
      if (b.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (f.allOf = f.allOf ?? [], f.allOf.push(b)) : Object.assign(f, b), Object.assign(f, d), c._zod.parent === h)
        for (const _ in f)
          _ === "$ref" || _ === "allOf" || _ in d || delete f[_];
      if (b.$ref && y.def)
        for (const _ in f)
          _ === "$ref" || _ === "allOf" || _ in y.def && JSON.stringify(f[_]) === JSON.stringify(y.def[_]) && delete f[_];
    }
    const p = c._zod.parent;
    if (p && p !== h) {
      n(p);
      const y = e.seen.get(p);
      if (y != null && y.schema.$ref && (f.$ref = y.schema.$ref, y.def))
        for (const b in f)
          b === "$ref" || b === "allOf" || b in y.def && JSON.stringify(f[b]) === JSON.stringify(y.def[b]) && delete f[b];
    }
    e.override({
      zodSchema: c,
      jsonSchema: f,
      path: l.path ?? []
    });
  };
  for (const c of [...e.seen.entries()].reverse())
    n(c[0]);
  const i = {};
  if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (a = e.external) != null && a.uri) {
    const c = (s = e.external.registry.get(t)) == null ? void 0 : s.id;
    if (!c)
      throw new Error("Schema is missing an `id` property");
    i.$id = e.external.uri(c);
  }
  Object.assign(i, r.def ?? r.schema);
  const o = ((u = e.external) == null ? void 0 : u.defs) ?? {};
  for (const c of e.seen.entries()) {
    const l = c[1];
    l.def && l.defId && (o[l.defId] = l.def);
  }
  e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
  try {
    const c = JSON.parse(JSON.stringify(i));
    return Object.defineProperty(c, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: br(t, "input", e.processors),
          output: br(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), c;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function pe(e, t) {
  const r = t ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(e))
    return !1;
  r.seen.add(e);
  const n = e._zod.def;
  if (n.type === "transform")
    return !0;
  if (n.type === "array")
    return pe(n.element, r);
  if (n.type === "set")
    return pe(n.valueType, r);
  if (n.type === "lazy")
    return pe(n.getter(), r);
  if (n.type === "promise" || n.type === "optional" || n.type === "nonoptional" || n.type === "nullable" || n.type === "readonly" || n.type === "default" || n.type === "prefault")
    return pe(n.innerType, r);
  if (n.type === "intersection")
    return pe(n.left, r) || pe(n.right, r);
  if (n.type === "record" || n.type === "map")
    return pe(n.keyType, r) || pe(n.valueType, r);
  if (n.type === "pipe")
    return pe(n.in, r) || pe(n.out, r);
  if (n.type === "object") {
    for (const i in n.shape)
      if (pe(n.shape[i], r))
        return !0;
    return !1;
  }
  if (n.type === "union") {
    for (const i of n.options)
      if (pe(i, r))
        return !0;
    return !1;
  }
  if (n.type === "tuple") {
    for (const i of n.items)
      if (pe(i, r))
        return !0;
    return !!(n.rest && pe(n.rest, r));
  }
  return !1;
}
const Pd = (e, t = {}) => (r) => {
  const n = Xa({ ...r, processors: t });
  return ie(e, n), es(n, e), ts(n, e);
}, br = (e, t, r = {}) => (n) => {
  const { libraryOptions: i, target: o } = n ?? {}, a = Xa({ ...i ?? {}, target: o, io: t, processors: r });
  return ie(e, a), es(a, e), ts(a, e);
}, Fd = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Nd = (e, t, r, n) => {
  const i = r;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: u, contentEncoding: c } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = Fd[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), c && (i.contentEncoding = c), u && u.size > 0) {
    const l = [...u];
    l.length === 1 ? i.pattern = l[0].source : l.length > 1 && (i.allOf = [
      ...l.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, Cd = (e, t, r, n) => {
  const i = r, { minimum: o, maximum: a, format: s, multipleOf: u, exclusiveMaximum: c, exclusiveMinimum: l } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof l == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = l, i.exclusiveMinimum = !0) : i.exclusiveMinimum = l), typeof o == "number" && (i.minimum = o, typeof l == "number" && t.target !== "draft-04" && (l >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = c, i.exclusiveMaximum = !0) : i.exclusiveMaximum = c), typeof a == "number" && (i.maximum = a, typeof c == "number" && t.target !== "draft-04" && (c <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof u == "number" && (i.multipleOf = u);
}, Ad = (e, t, r, n) => {
  r.type = "boolean";
}, xd = (e, t, r, n) => {
  r.not = {};
}, Md = (e, t, r, n) => {
}, jd = (e, t, r, n) => {
  const i = e._zod.def, o = Na(i.entries);
  o.every((a) => typeof a == "number") && (r.type = "number"), o.every((a) => typeof a == "string") && (r.type = "string"), r.enum = o;
}, $d = (e, t, r, n) => {
  const i = e._zod.def, o = [];
  for (const a of i.values)
    if (a === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof a == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      o.push(Number(a));
    } else
      o.push(a);
  if (o.length !== 0) if (o.length === 1) {
    const a = o[0];
    r.type = a === null ? "null" : typeof a, t.target === "draft-04" || t.target === "openapi-3.0" ? r.enum = [a] : r.const = a;
  } else
    o.every((a) => typeof a == "number") && (r.type = "number"), o.every((a) => typeof a == "string") && (r.type = "string"), o.every((a) => typeof a == "boolean") && (r.type = "boolean"), o.every((a) => a === null) && (r.type = "null"), r.enum = o;
}, Ld = (e, t, r, n) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Vd = (e, t, r, n) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, qd = (e, t, r, n) => {
  const i = r, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = ie(o.element, t, { ...n, path: [...n.path, "items"] });
}, Zd = (e, t, r, n) => {
  var c;
  const i = r, o = e._zod.def;
  i.type = "object", i.properties = {};
  const a = o.shape;
  for (const l in a)
    i.properties[l] = ie(a[l], t, {
      ...n,
      path: [...n.path, "properties", l]
    });
  const s = new Set(Object.keys(a)), u = new Set([...s].filter((l) => {
    const f = o.shape[l]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  u.size > 0 && (i.required = Array.from(u)), ((c = o.catchall) == null ? void 0 : c._zod.def.type) === "never" ? i.additionalProperties = !1 : o.catchall ? o.catchall && (i.additionalProperties = ie(o.catchall, t, {
    ...n,
    path: [...n.path, "additionalProperties"]
  })) : t.io === "output" && (i.additionalProperties = !1);
}, Qd = (e, t, r, n) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, u) => ie(s, t, {
    ...n,
    path: [...n.path, o ? "oneOf" : "anyOf", u]
  }));
  o ? r.oneOf = a : r.anyOf = a;
}, Ud = (e, t, r, n) => {
  const i = e._zod.def, o = ie(i.left, t, {
    ...n,
    path: [...n.path, "allOf", 0]
  }), a = ie(i.right, t, {
    ...n,
    path: [...n.path, "allOf", 1]
  }), s = (c) => "allOf" in c && Object.keys(c).length === 1, u = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  r.allOf = u;
}, Bd = (e, t, r, n) => {
  const i = r, o = e._zod.def;
  i.type = "object";
  const a = o.keyType, s = a._zod.bag, u = s == null ? void 0 : s.patterns;
  if (o.mode === "loose" && u && u.size > 0) {
    const l = ie(o.valueType, t, {
      ...n,
      path: [...n.path, "patternProperties", "*"]
    });
    i.patternProperties = {};
    for (const f of u)
      i.patternProperties[f.source] = l;
  } else
    (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = ie(o.keyType, t, {
      ...n,
      path: [...n.path, "propertyNames"]
    })), i.additionalProperties = ie(o.valueType, t, {
      ...n,
      path: [...n.path, "additionalProperties"]
    });
  const c = a._zod.values;
  if (c) {
    const l = [...c].filter((f) => typeof f == "string" || typeof f == "number");
    l.length > 0 && (i.required = l);
  }
}, Wd = (e, t, r, n) => {
  const i = e._zod.def, o = ie(i.innerType, t, n), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, r.nullable = !0) : r.anyOf = [o, { type: "null" }];
}, Jd = (e, t, r, n) => {
  const i = e._zod.def;
  ie(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Gd = (e, t, r, n) => {
  const i = e._zod.def;
  ie(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.default = JSON.parse(JSON.stringify(i.defaultValue));
}, Kd = (e, t, r, n) => {
  const i = e._zod.def;
  ie(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (r._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Hd = (e, t, r, n) => {
  const i = e._zod.def;
  ie(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  r.default = a;
}, Yd = (e, t, r, n) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  ie(o, t, n);
  const a = t.seen.get(e);
  a.ref = o;
}, Xd = (e, t, r, n) => {
  const i = e._zod.def;
  ie(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType, r.readOnly = !0;
}, rs = (e, t, r, n) => {
  const i = e._zod.def;
  ie(i.innerType, t, n);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, ep = /* @__PURE__ */ w("ZodISODateTime", (e, t) => {
  th.init(e, t), X.init(e, t);
});
function tp(e) {
  return /* @__PURE__ */ sd(ep, e);
}
const rp = /* @__PURE__ */ w("ZodISODate", (e, t) => {
  rh.init(e, t), X.init(e, t);
});
function np(e) {
  return /* @__PURE__ */ ud(rp, e);
}
const ip = /* @__PURE__ */ w("ZodISOTime", (e, t) => {
  nh.init(e, t), X.init(e, t);
});
function op(e) {
  return /* @__PURE__ */ cd(ip, e);
}
const ap = /* @__PURE__ */ w("ZodISODuration", (e, t) => {
  ih.init(e, t), X.init(e, t);
});
function sp(e) {
  return /* @__PURE__ */ ld(ap, e);
}
const up = (e, t) => {
  Ma.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (r) => Wl(e, r)
      // enumerable: false,
    },
    flatten: {
      value: (r) => Bl(e, r)
      // enumerable: false,
    },
    addIssue: {
      value: (r) => {
        e.issues.push(r), e.message = JSON.stringify(e.issues, bn, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (r) => {
        e.issues.push(...r), e.message = JSON.stringify(e.issues, bn, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, we = w("ZodError", up, {
  Parent: Error
}), cp = /* @__PURE__ */ Bn(we), lp = /* @__PURE__ */ Wn(we), fp = /* @__PURE__ */ Ir(we), hp = /* @__PURE__ */ zr(we), dp = /* @__PURE__ */ Kl(we), pp = /* @__PURE__ */ Hl(we), vp = /* @__PURE__ */ Yl(we), yp = /* @__PURE__ */ Xl(we), mp = /* @__PURE__ */ ef(we), gp = /* @__PURE__ */ tf(we), bp = /* @__PURE__ */ rf(we), _p = /* @__PURE__ */ nf(we), Y = /* @__PURE__ */ w("ZodType", (e, t) => (H.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: br(e, "input"),
    output: br(e, "output")
  }
}), e.toJSONSchema = Pd(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...r) => e.clone(Ge(t, {
  checks: [
    ...t.checks ?? [],
    ...r.map((n) => typeof n == "function" ? { _zod: { check: n, def: { check: "custom" }, onattach: [] } } : n)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (r, n) => Ke(e, r, n), e.brand = () => e, e.register = ((r, n) => (r.add(e, n), e)), e.parse = (r, n) => cp(e, r, n, { callee: e.parse }), e.safeParse = (r, n) => fp(e, r, n), e.parseAsync = async (r, n) => lp(e, r, n, { callee: e.parseAsync }), e.safeParseAsync = async (r, n) => hp(e, r, n), e.spa = e.safeParseAsync, e.encode = (r, n) => dp(e, r, n), e.decode = (r, n) => pp(e, r, n), e.encodeAsync = async (r, n) => vp(e, r, n), e.decodeAsync = async (r, n) => yp(e, r, n), e.safeEncode = (r, n) => mp(e, r, n), e.safeDecode = (r, n) => gp(e, r, n), e.safeEncodeAsync = async (r, n) => bp(e, r, n), e.safeDecodeAsync = async (r, n) => _p(e, r, n), e.refine = (r, n) => e.check(yv(r, n)), e.superRefine = (r) => e.check(mv(r)), e.overwrite = (r) => e.check(/* @__PURE__ */ Pt(r)), e.optional = () => mo(e), e.exactOptional = () => nv(e), e.nullable = () => go(e), e.nullish = () => mo(go(e)), e.nonoptional = (r) => cv(e, r), e.array = () => j(e), e.or = (r) => Wp([e, r]), e.and = (r) => Gp(e, r), e.transform = (r) => bo(e, tv(r)), e.default = (r) => av(e, r), e.prefault = (r) => uv(e, r), e.catch = (r) => fv(e, r), e.pipe = (r) => bo(e, r), e.readonly = () => pv(e), e.describe = (r) => {
  const n = e.clone();
  return Lt.add(n, { description: r }), n;
}, Object.defineProperty(e, "description", {
  get() {
    var r;
    return (r = Lt.get(e)) == null ? void 0 : r.description;
  },
  configurable: !0
}), e.meta = (...r) => {
  if (r.length === 0)
    return Lt.get(e);
  const n = e.clone();
  return Lt.add(n, r[0]), n;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (r) => r(e), e)), ns = /* @__PURE__ */ w("_ZodString", (e, t) => {
  Jn.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (n, i, o) => Nd(e, n, i);
  const r = e._zod.bag;
  e.format = r.format ?? null, e.minLength = r.minimum ?? null, e.maxLength = r.maximum ?? null, e.regex = (...n) => e.check(/* @__PURE__ */ yd(...n)), e.includes = (...n) => e.check(/* @__PURE__ */ bd(...n)), e.startsWith = (...n) => e.check(/* @__PURE__ */ _d(...n)), e.endsWith = (...n) => e.check(/* @__PURE__ */ wd(...n)), e.min = (...n) => e.check(/* @__PURE__ */ gr(...n)), e.max = (...n) => e.check(/* @__PURE__ */ Ha(...n)), e.length = (...n) => e.check(/* @__PURE__ */ Ya(...n)), e.nonempty = (...n) => e.check(/* @__PURE__ */ gr(1, ...n)), e.lowercase = (n) => e.check(/* @__PURE__ */ md(n)), e.uppercase = (n) => e.check(/* @__PURE__ */ gd(n)), e.trim = () => e.check(/* @__PURE__ */ Ed()), e.normalize = (...n) => e.check(/* @__PURE__ */ kd(...n)), e.toLowerCase = () => e.check(/* @__PURE__ */ Sd()), e.toUpperCase = () => e.check(/* @__PURE__ */ Od()), e.slugify = () => e.check(/* @__PURE__ */ Td());
}), wp = /* @__PURE__ */ w("ZodString", (e, t) => {
  Jn.init(e, t), ns.init(e, t), e.email = (r) => e.check(/* @__PURE__ */ Lh(kp, r)), e.url = (r) => e.check(/* @__PURE__ */ Uh(Ep, r)), e.jwt = (r) => e.check(/* @__PURE__ */ ad(jp, r)), e.emoji = (r) => e.check(/* @__PURE__ */ Bh(Sp, r)), e.guid = (r) => e.check(/* @__PURE__ */ lo(vo, r)), e.uuid = (r) => e.check(/* @__PURE__ */ Vh(nr, r)), e.uuidv4 = (r) => e.check(/* @__PURE__ */ qh(nr, r)), e.uuidv6 = (r) => e.check(/* @__PURE__ */ Zh(nr, r)), e.uuidv7 = (r) => e.check(/* @__PURE__ */ Qh(nr, r)), e.nanoid = (r) => e.check(/* @__PURE__ */ Wh(Op, r)), e.guid = (r) => e.check(/* @__PURE__ */ lo(vo, r)), e.cuid = (r) => e.check(/* @__PURE__ */ Jh(Tp, r)), e.cuid2 = (r) => e.check(/* @__PURE__ */ Gh(Dp, r)), e.ulid = (r) => e.check(/* @__PURE__ */ Kh(Ip, r)), e.base64 = (r) => e.check(/* @__PURE__ */ nd(Ap, r)), e.base64url = (r) => e.check(/* @__PURE__ */ id(xp, r)), e.xid = (r) => e.check(/* @__PURE__ */ Hh(zp, r)), e.ksuid = (r) => e.check(/* @__PURE__ */ Yh(Rp, r)), e.ipv4 = (r) => e.check(/* @__PURE__ */ Xh(Pp, r)), e.ipv6 = (r) => e.check(/* @__PURE__ */ ed(Fp, r)), e.cidrv4 = (r) => e.check(/* @__PURE__ */ td(Np, r)), e.cidrv6 = (r) => e.check(/* @__PURE__ */ rd(Cp, r)), e.e164 = (r) => e.check(/* @__PURE__ */ od(Mp, r)), e.datetime = (r) => e.check(tp(r)), e.date = (r) => e.check(np(r)), e.time = (r) => e.check(op(r)), e.duration = (r) => e.check(sp(r));
});
function g(e) {
  return /* @__PURE__ */ $h(wp, e);
}
const X = /* @__PURE__ */ w("ZodStringFormat", (e, t) => {
  J.init(e, t), ns.init(e, t);
}), kp = /* @__PURE__ */ w("ZodEmail", (e, t) => {
  Bf.init(e, t), X.init(e, t);
}), vo = /* @__PURE__ */ w("ZodGUID", (e, t) => {
  Qf.init(e, t), X.init(e, t);
}), nr = /* @__PURE__ */ w("ZodUUID", (e, t) => {
  Uf.init(e, t), X.init(e, t);
}), Ep = /* @__PURE__ */ w("ZodURL", (e, t) => {
  Wf.init(e, t), X.init(e, t);
}), Sp = /* @__PURE__ */ w("ZodEmoji", (e, t) => {
  Jf.init(e, t), X.init(e, t);
}), Op = /* @__PURE__ */ w("ZodNanoID", (e, t) => {
  Gf.init(e, t), X.init(e, t);
}), Tp = /* @__PURE__ */ w("ZodCUID", (e, t) => {
  Kf.init(e, t), X.init(e, t);
}), Dp = /* @__PURE__ */ w("ZodCUID2", (e, t) => {
  Hf.init(e, t), X.init(e, t);
}), Ip = /* @__PURE__ */ w("ZodULID", (e, t) => {
  Yf.init(e, t), X.init(e, t);
}), zp = /* @__PURE__ */ w("ZodXID", (e, t) => {
  Xf.init(e, t), X.init(e, t);
}), Rp = /* @__PURE__ */ w("ZodKSUID", (e, t) => {
  eh.init(e, t), X.init(e, t);
}), Pp = /* @__PURE__ */ w("ZodIPv4", (e, t) => {
  oh.init(e, t), X.init(e, t);
}), Fp = /* @__PURE__ */ w("ZodIPv6", (e, t) => {
  ah.init(e, t), X.init(e, t);
}), Np = /* @__PURE__ */ w("ZodCIDRv4", (e, t) => {
  sh.init(e, t), X.init(e, t);
}), Cp = /* @__PURE__ */ w("ZodCIDRv6", (e, t) => {
  uh.init(e, t), X.init(e, t);
}), Ap = /* @__PURE__ */ w("ZodBase64", (e, t) => {
  ch.init(e, t), X.init(e, t);
}), xp = /* @__PURE__ */ w("ZodBase64URL", (e, t) => {
  fh.init(e, t), X.init(e, t);
}), Mp = /* @__PURE__ */ w("ZodE164", (e, t) => {
  hh.init(e, t), X.init(e, t);
}), jp = /* @__PURE__ */ w("ZodJWT", (e, t) => {
  ph.init(e, t), X.init(e, t);
}), is = /* @__PURE__ */ w("ZodNumber", (e, t) => {
  Wa.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (n, i, o) => Cd(e, n, i), e.gt = (n, i) => e.check(/* @__PURE__ */ ho(n, i)), e.gte = (n, i) => e.check(/* @__PURE__ */ Gr(n, i)), e.min = (n, i) => e.check(/* @__PURE__ */ Gr(n, i)), e.lt = (n, i) => e.check(/* @__PURE__ */ fo(n, i)), e.lte = (n, i) => e.check(/* @__PURE__ */ Jr(n, i)), e.max = (n, i) => e.check(/* @__PURE__ */ Jr(n, i)), e.int = (n) => e.check(yo(n)), e.safe = (n) => e.check(yo(n)), e.positive = (n) => e.check(/* @__PURE__ */ ho(0, n)), e.nonnegative = (n) => e.check(/* @__PURE__ */ Gr(0, n)), e.negative = (n) => e.check(/* @__PURE__ */ fo(0, n)), e.nonpositive = (n) => e.check(/* @__PURE__ */ Jr(0, n)), e.multipleOf = (n, i) => e.check(/* @__PURE__ */ po(n, i)), e.step = (n, i) => e.check(/* @__PURE__ */ po(n, i)), e.finite = () => e;
  const r = e._zod.bag;
  e.minValue = Math.max(r.minimum ?? Number.NEGATIVE_INFINITY, r.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(r.maximum ?? Number.POSITIVE_INFINITY, r.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (r.format ?? "").includes("int") || Number.isSafeInteger(r.multipleOf ?? 0.5), e.isFinite = !0, e.format = r.format ?? null;
});
function D(e) {
  return /* @__PURE__ */ fd(is, e);
}
const $p = /* @__PURE__ */ w("ZodNumberFormat", (e, t) => {
  vh.init(e, t), is.init(e, t);
});
function yo(e) {
  return /* @__PURE__ */ hd($p, e);
}
const Lp = /* @__PURE__ */ w("ZodBoolean", (e, t) => {
  yh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ad(e, r, n);
});
function ye(e) {
  return /* @__PURE__ */ dd(Lp, e);
}
const Vp = /* @__PURE__ */ w("ZodUnknown", (e, t) => {
  mh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Md();
});
function Ot() {
  return /* @__PURE__ */ pd(Vp);
}
const qp = /* @__PURE__ */ w("ZodNever", (e, t) => {
  gh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => xd(e, r, n);
});
function Zp(e) {
  return /* @__PURE__ */ vd(qp, e);
}
const Qp = /* @__PURE__ */ w("ZodArray", (e, t) => {
  bh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => qd(e, r, n, i), e.element = t.element, e.min = (r, n) => e.check(/* @__PURE__ */ gr(r, n)), e.nonempty = (r) => e.check(/* @__PURE__ */ gr(1, r)), e.max = (r, n) => e.check(/* @__PURE__ */ Ha(r, n)), e.length = (r, n) => e.check(/* @__PURE__ */ Ya(r, n)), e.unwrap = () => e.element;
});
function j(e, t) {
  return /* @__PURE__ */ Dd(Qp, e, t);
}
const Up = /* @__PURE__ */ w("ZodObject", (e, t) => {
  wh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Zd(e, r, n, i), Z(e, "shape", () => t.shape), e.keyof = () => ze(Object.keys(e._zod.def.shape)), e.catchall = (r) => e.clone({ ...e._zod.def, catchall: r }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Ot() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Ot() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Zp() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (r) => Vl(e, r), e.safeExtend = (r) => ql(e, r), e.merge = (r) => Zl(e, r), e.pick = (r) => $l(e, r), e.omit = (r) => Ll(e, r), e.partial = (...r) => Ql(os, e, r[0]), e.required = (...r) => Ul(as, e, r[0]);
});
function E(e, t) {
  const r = {
    type: "object",
    shape: e ?? {},
    ...R(t)
  };
  return new Up(r);
}
const Bp = /* @__PURE__ */ w("ZodUnion", (e, t) => {
  kh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Qd(e, r, n, i), e.options = t.options;
});
function Wp(e, t) {
  return new Bp({
    type: "union",
    options: e,
    ...R(t)
  });
}
const Jp = /* @__PURE__ */ w("ZodIntersection", (e, t) => {
  Eh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ud(e, r, n, i);
});
function Gp(e, t) {
  return new Jp({
    type: "intersection",
    left: e,
    right: t
  });
}
const Kp = /* @__PURE__ */ w("ZodRecord", (e, t) => {
  Sh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Bd(e, r, n, i), e.keyType = t.keyType, e.valueType = t.valueType;
});
function Hp(e, t, r) {
  return new Kp({
    type: "record",
    keyType: e,
    valueType: t,
    ...R(r)
  });
}
const wn = /* @__PURE__ */ w("ZodEnum", (e, t) => {
  Oh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (n, i, o) => jd(e, n, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const r = new Set(Object.keys(t.entries));
  e.extract = (n, i) => {
    const o = {};
    for (const a of n)
      if (r.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new wn({
      ...t,
      checks: [],
      ...R(i),
      entries: o
    });
  }, e.exclude = (n, i) => {
    const o = { ...t.entries };
    for (const a of n)
      if (r.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new wn({
      ...t,
      checks: [],
      ...R(i),
      entries: o
    });
  };
});
function ze(e, t) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((n) => [n, n])) : e;
  return new wn({
    type: "enum",
    entries: r,
    ...R(t)
  });
}
const Yp = /* @__PURE__ */ w("ZodLiteral", (e, t) => {
  Th.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => $d(e, r, n), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function Xp(e, t) {
  return new Yp({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...R(t)
  });
}
const ev = /* @__PURE__ */ w("ZodTransform", (e, t) => {
  Dh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Vd(e, r), e._zod.parse = (r, n) => {
    if (n.direction === "backward")
      throw new Pa(e.constructor.name);
    r.addIssue = (o) => {
      if (typeof o == "string")
        r.issues.push(Gt(o, r.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = r.value), a.inst ?? (a.inst = e), r.issues.push(Gt(a));
      }
    };
    const i = t.transform(r.value, r);
    return i instanceof Promise ? i.then((o) => (r.value = o, r)) : (r.value = i, r);
  };
});
function tv(e) {
  return new ev({
    type: "transform",
    transform: e
  });
}
const os = /* @__PURE__ */ w("ZodOptional", (e, t) => {
  Ka.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => rs(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function mo(e) {
  return new os({
    type: "optional",
    innerType: e
  });
}
const rv = /* @__PURE__ */ w("ZodExactOptional", (e, t) => {
  Ih.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => rs(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function nv(e) {
  return new rv({
    type: "optional",
    innerType: e
  });
}
const iv = /* @__PURE__ */ w("ZodNullable", (e, t) => {
  zh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Wd(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function go(e) {
  return new iv({
    type: "nullable",
    innerType: e
  });
}
const ov = /* @__PURE__ */ w("ZodDefault", (e, t) => {
  Rh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Gd(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function av(e, t) {
  return new ov({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Aa(t);
    }
  });
}
const sv = /* @__PURE__ */ w("ZodPrefault", (e, t) => {
  Ph.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Kd(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function uv(e, t) {
  return new sv({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Aa(t);
    }
  });
}
const as = /* @__PURE__ */ w("ZodNonOptional", (e, t) => {
  Fh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Jd(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function cv(e, t) {
  return new as({
    type: "nonoptional",
    innerType: e,
    ...R(t)
  });
}
const lv = /* @__PURE__ */ w("ZodCatch", (e, t) => {
  Nh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Hd(e, r, n, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function fv(e, t) {
  return new lv({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const hv = /* @__PURE__ */ w("ZodPipe", (e, t) => {
  Ch.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Yd(e, r, n, i), e.in = t.in, e.out = t.out;
});
function bo(e, t) {
  return new hv({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const dv = /* @__PURE__ */ w("ZodReadonly", (e, t) => {
  Ah.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Xd(e, r, n, i), e.unwrap = () => e._zod.def.innerType;
});
function pv(e) {
  return new dv({
    type: "readonly",
    innerType: e
  });
}
const vv = /* @__PURE__ */ w("ZodCustom", (e, t) => {
  xh.init(e, t), Y.init(e, t), e._zod.processJSONSchema = (r, n, i) => Ld(e, r);
});
function yv(e, t = {}) {
  return /* @__PURE__ */ Id(vv, e, t);
}
function mv(e) {
  return /* @__PURE__ */ zd(e);
}
const ss = E({
  id: g(),
  name: g(),
  slug: g(),
  status: ze(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: E({}).partial().passthrough(),
  output: E({}).partial().passthrough().nullable(),
  createdAt: g(),
  startedAt: g().nullable(),
  endedAt: g().nullable()
}).passthrough(), gv = E({ analyses: j(ss) }).passthrough(), bv = E({
  name: g().min(1).max(100),
  outputLocation: E({ s3BucketId: D(), path: g().optional() }).passthrough(),
  analysisSchemaId: D().int().gt(0).lte(9007199254740991),
  version: D(),
  input: Ot(),
  labId: D().optional()
}).passthrough(), _v = E({
  analysisId: g().nullable(),
  analysisSlug: g().nullable(),
  success: ye()
}).passthrough(), us = E({ id: D(), name: g(), versions: j(D()) }).passthrough(), wv = E({ analysisSchemas: j(us) }).passthrough(), Pr = E({
  id: D(),
  name: g(),
  version: D(),
  valueSchemaVersionId: D(),
  message: g().nullable(),
  createdAt: g(),
  schema: E({}).partial().passthrough()
}).passthrough(), kn = E({ id: D(), name: g(), valueSchema: Pr }).passthrough(), cs = E({
  analysisSchemaId: D(),
  version: D(),
  createdAt: g(),
  description: E({ short: g().nullable(), long: g().nullable() }).partial().passthrough(),
  inputs: j(kn),
  outputs: j(kn)
}).passthrough(), kv = E({ versions: j(cs) }).passthrough(), Ev = E({ logs: j(g()) }).passthrough(), ls = E({
  id: g(),
  taskArn: g(),
  name: g(),
  status: g(),
  analysisId: g(),
  startedAt: g(),
  endedAt: g(),
  memory: D(),
  vcpus: D()
}).passthrough(), Sv = E({ tasks: j(ls) }).passthrough(), Ov = E({
  totalCost: D(),
  tasks: j(
    E({ name: g(), cost: D() }).passthrough()
  ),
  runner: D(),
  storageCost: D(),
  vpcCost: D()
}).passthrough(), fs = E({
  analysisSchemaId: D(),
  version: D(),
  name: g()
}).passthrough(), Tv = E({ next: j(fs) }).passthrough(), Dv = E({ success: ye() }).passthrough(), Iv = E({ valueSchemas: j(Pr) }).passthrough(), zv = E({
  name: g().min(1),
  schema: Hp(g(), Ot()),
  message: g().min(1).optional()
}).passthrough(), Rv = E({ versions: j(Pr) }).passthrough(), hs = ze([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), Gn = ze([
  "admin",
  "credits_unlimited",
  "files_read",
  "keypair_read",
  "lab_create",
  "labmember_read",
  "labmember_write",
  "lab_read",
  "notebook_read",
  "notebook_write",
  "plexus_read",
  "plexus_write",
  "tinkerbox_launch",
  "tinkerbox_read",
  "user_update"
]), Kn = E({
  id: g(),
  firstname: g().nullable(),
  lastname: g().nullable(),
  email: g().nullable(),
  keyPairId: D(),
  roles: j(hs),
  permissions: j(Gn)
}).passthrough(), Pv = E({ user: Kn }).partial().passthrough(), Fv = E({ email: g() }).passthrough(), Nv = E({ success: ye() }).passthrough(), Cv = E({ otp: g() }).passthrough(), Av = E({ success: ye() }).passthrough(), xv = E({ token: g() }).passthrough(), Mv = E({
  token: g(),
  tokenType: Xp("Bearer"),
  expiresIn: D(),
  expiresAt: g().datetime()
}).passthrough(), ds = E({
  clientId: g(),
  name: g().nullable(),
  uri: g().nullable(),
  scopes: j(g()),
  connectedAt: g().datetime()
}).passthrough(), jv = E({ apps: j(ds) }).passthrough(), $v = E({ token: g() }).passthrough(), Lv = E({ valid: ye() }).passthrough(), Vv = E({ name: g(), permissions: j(Gn) }).passthrough(), ps = E({
  id: D(),
  instanceProfile: g().nullable(),
  securityGroup: g().nullable()
}).passthrough(), Ht = E({
  id: D(),
  name: g(),
  labId: D().nullish(),
  userId: g().nullish(),
  status: ze([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: g().nullish(),
  lastLogin: g().nullish(),
  keypairId: D().nullish()
}).passthrough(), qv = E({
  infra: j(ps),
  keyPairs: j(g()),
  tinkerBoxes: j(Ht)
}).passthrough(), Zv = E({ count: D().gte(1).lte(15) }).passthrough(), Qv = E({
  firstname: g().min(1),
  lastname: g().min(1),
  email: g().regex(
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/
  ).email(),
  password: g().min(8)
}).passthrough(), Uv = E({ users: j(Kn) }).passthrough(), Bv = E({
  firstname: g().nullable(),
  lastname: g().nullable(),
  email: g().nullable()
}).partial().passthrough(), vs = E({ tinkerBox: Ht, keyMaterial: g() }).passthrough(), Wv = E({ tinkerBoxes: j(vs) }).passthrough(), ys = E({
  labName: g(),
  ec2Cost: D(),
  s3Cost: D(),
  efsCost: D(),
  totalCost: D()
}).passthrough(), Jv = E({ clients: j(ys) }).passthrough(), ms = E({
  name: g(),
  labName: g(),
  usage: g(),
  cost: D()
}).passthrough(), Gv = E({ tinkerBoxes: j(ms) }).passthrough(), Kv = E({ tinkerboxes: j(Ht) }).passthrough(), Hv = E({ tinkerBox: Ht }).passthrough(), Yv = E({ name: g() }).passthrough(), gs = E({
  id: D(),
  date: g(),
  tinkerBoxName: g(),
  lastLoginDate: g().nullable(),
  lastCommandDate: g().nullable(),
  lastCommand: g().nullable(),
  activeProcesses: ye(),
  status: ze([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  tinkerBoxId: D(),
  autoStopTime: g().nullable()
}).passthrough(), Xv = E({ allLastActivity: j(gs) }).passthrough(), ey = E({ name: g().nullable() }).partial().passthrough(), bs = E({
  id: D(),
  name: g(),
  s3BucketId: D(),
  keyPairId: D()
}).passthrough(), ty = E({ labs: j(bs) }).passthrough(), ry = E({
  name: g(),
  numTinkerBoxes: D().optional().default(1)
}).passthrough(), ny = E({ labId: D(), taskId: g() }).passthrough(), iy = E({ id: g(), labId: D(), logs: g() }).passthrough(), Hn = E({
  id: D(),
  labId: D(),
  userId: g(),
  role: ze(["OWNER", "MEMBER"]),
  user: E({
    firstname: g().nullable(),
    lastname: g().nullable(),
    email: g().nullable(),
    id: g()
  }).partial().passthrough()
}).passthrough(), oy = E({ labMember: Hn.nullable() }).passthrough(), ay = E({ labMembers: j(Hn) }).passthrough(), _s = E({
  id: D(),
  labId: D(),
  userId: g(),
  role: ze(["OWNER", "MEMBER"])
}).passthrough(), sy = E({ labMember: _s }).passthrough(), uy = E({ role: g() }).passthrough(), cy = E({ labMemberId: D(), role: g() }).passthrough(), ly = E({ success: ye() }).passthrough(), fy = E({
  client_secret: g().nullable(),
  status: g().nullable(),
  payment_status: g()
}).passthrough(), hy = E({
  name: g(),
  email: g().regex(
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/
  ).email(),
  message: g()
}).passthrough(), dy = E({ path: g(), s3BucketId: D().optional() }).passthrough(), py = E({ success: ye() }).passthrough(), vy = E({ url: g() }).passthrough(), ws = E({
  isFolder: ye(),
  bucketId: D().optional(),
  path: g()
}).passthrough(), yy = E({ contents: j(ws) }).passthrough(), my = E({ files: j(g()) }).passthrough(), gy = E({
  buckets: j(
    E({
      id: D().int().gte(-9007199254740991).lte(9007199254740991),
      bucket: g(),
      region: g(),
      prefix: g().nullish()
    }).passthrough()
  )
}).passthrough(), by = E({
  source: E({
    isFolder: ye(),
    bucketId: D().optional(),
    path: g()
  }).passthrough(),
  target: E({
    isFolder: ye(),
    bucketId: D().optional(),
    path: g()
  }).passthrough()
}).passthrough(), _y = E({
  fileTransfers: j(
    E({
      id: D().int().gte(-9007199254740991).lte(9007199254740991),
      name: g(),
      userId: g(),
      progress: D(),
      user: Ot()
    })
  )
}).passthrough(), ks = E({
  id: D(),
  name: g(),
  analysisSchemaId: D(),
  analysisSchemaVersion: D(),
  config: E({}).partial().passthrough()
}).passthrough(), wy = E({ templates: j(ks) }).passthrough(), ky = E({
  name: g().min(1).max(255),
  analysisSchemaId: D().int().gte(-9007199254740991).lte(9007199254740991),
  analysisSchemaVersion: D().int().gt(0).lte(9007199254740991),
  triggerLocation: E({
    bucketId: D().int().gt(0).lte(9007199254740991),
    folderPath: g().max(2048)
  }).passthrough(),
  config: Ot()
}).passthrough(), Ey = E({
  id: D(),
  name: g(),
  s3BucketId: D(),
  triggerFolder: g(),
  analysisSchemaId: D(),
  analysisSchemaVersion: D(),
  config: E({}).partial().passthrough()
}).passthrough(), Sy = E({
  id: D(),
  name: g(),
  schema: E({}).partial().passthrough()
}).passthrough(), Oy = E({
  id: D(),
  formId: D(),
  data: E({}).partial().passthrough(),
  dateCreated: g()
}).passthrough(), Ty = E({
  id: D(),
  name: g(),
  displayName: g(),
  hichip: g(),
  source: g(),
  bucket: g(),
  bedpeKey: g(),
  hicKey: g(),
  category: g()
}).passthrough(), Dy = E({
  id: D(),
  sampleId: D(),
  cluster: g(),
  chr: g(),
  start: D(),
  end: D(),
  size: D(),
  genes: g()
}).passthrough(), Iy = E({
  plotId: g(),
  status: ze(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: g(),
  outputKey: g(),
  inputs: E({}).partial().passthrough(),
  endedAt: g().nullable(),
  downloadUrl: g().nullable()
}).passthrough(), zy = E({
  sample: g(),
  range: g(),
  genomeBuild: ze(["hg19", "hg38"]),
  color: g().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: g(),
  flank: D(),
  bedpe: g()
}).passthrough(), Yn = E({
  id: D(),
  title: g(),
  content: g(),
  createdAt: g(),
  updatedAt: g(),
  isActive: ye()
}).passthrough(), Ry = E({ announcements: j(Yn) }).passthrough(), Py = E({ announcement: Yn.nullable() }).passthrough(), Es = E({
  id: g(),
  title: g(),
  createdAt: g(),
  updatedAt: g(),
  language: g(),
  userId: g().nullable(),
  readonly: ye()
}).passthrough(), Fy = E({ notebooks: j(Es) }).passthrough(), Ny = E({ language: g() }).passthrough(), Xn = E({
  id: g(),
  title: g(),
  createdAt: g(),
  updatedAt: g(),
  language: g(),
  content: g(),
  userId: g().nullable(),
  readonly: ye()
}).passthrough(), Cy = E({ notebook: Xn }).passthrough(), Ay = E({ success: ye() }).passthrough(), xy = E({ content: g() }).passthrough(), My = E({ title: g() }).passthrough(), jy = E({ notebook: Xn }).passthrough(), $y = E({ title: g() }).passthrough(), _o = {
  AnalysisDto: ss,
  AnalysesDto: gv,
  CreateAnalysisBodyDto: bv,
  CreateAndLaunchAnalysisResponseDto: _v,
  AnalysisSchemaDto: us,
  AnalysisSchemasDto: wv,
  ValueSchemaDto: Pr,
  AnalysisSchemaInputOutput: kn,
  AnalysisSchemaVersionDto: cs,
  AnalysisSchemaVersionsDto: kv,
  AnalysisLogsDto: Ev,
  TaskDto: ls,
  TasksDto: Sv,
  AnalysisCostBreakdownDto: Ov,
  AnalysisNextDto: fs,
  AnalysisNextListDto: Tv,
  SuccessDto: Dv,
  ValueSchemasDto: Iv,
  PublishValueSchemaVersionBodyDto: zv,
  ValueSchemaVersionsDto: Rv,
  UserRole: hs,
  Permission: Gn,
  UserDto: Kn,
  MeResponse: Pv,
  RequestOtpBody: Fv,
  RequestOtpResponse: Nv,
  LoginBody: Cv,
  LoginResponse: Av,
  LoginCliResponse: xv,
  IssueTokenResponse: Mv,
  ConnectedAppDto: ds,
  ConnectedAppsResponse: jv,
  VerifyTokenBody: $v,
  VerifyTokenResponse: Lv,
  RoleDto: Vv,
  Infra: ps,
  TinkerBox: Ht,
  InfraPool: qv,
  CreateInfraPoolBody: Zv,
  CreateUserBody: Qv,
  UsersDto: Uv,
  UpdateUserBody: Bv,
  TinkerBoxInventory: vs,
  TinkerBoxInventoryList: Wv,
  ClientUsage: ys,
  ClientsUsage: Jv,
  TinkerBoxWithUsage: ms,
  TinkerBoxesWithUsage: Gv,
  GetTinkerBoxesResponse: Kv,
  LaunchTinkerBoxResponse: Hv,
  UpdateTinkerBoxBodyDto: Yv,
  TinkerBoxLastActivityDto: gs,
  AllLastActivityDto: Xv,
  LaunchLabTinkerBoxBody: ey,
  Lab: bs,
  LabsResponse: ty,
  CreateLabBody: ry,
  CreateLabResponse: ny,
  GetLabCreationTaskResponse: iy,
  LabMemberDto: Hn,
  LabMemberResponse: oy,
  LabMembersResponse: ay,
  LabMember: _s,
  AddLabMemberResponse: sy,
  UpdateLabMemberBody: uy,
  UpdateLabMemberResponse: cy,
  DeleteLabMemberResponse: ly,
  CheckoutSession: fy,
  ContactBody: hy,
  CreateDirectoryBody: dy,
  CreateDirectoryResponse: py,
  PresignedUrlResponse: vy,
  FilePath: ws,
  ContentsResponse: yy,
  DeleteFilesResponse: my,
  GetBucketsResponse: gy,
  MoveFileBody: by,
  FileTransfersResponse: _y,
  ActionTemplateDto: ks,
  ActionTemplatesDto: wy,
  CreateActionBodyDto: ky,
  ActionDto: Ey,
  FormSchema: Sy,
  FormSubmission: Oy,
  SampleDto: Ty,
  SampleClusterDto: Dy,
  PlotDto: Iy,
  PlotContactsArgs: zy,
  Announcement: Yn,
  ActiveAnnouncements: Ry,
  LatestAnnouncement: Py,
  NotebookWithoutContentDto: Es,
  GetNotebooksDto: Fy,
  CreateNotebookBody: Ny,
  NotebookDto: Xn,
  CreateNotebookDto: Cy,
  DeleteNotebookDto: Ay,
  SaveNotebookBody: xy,
  DuplicateNotebookBody: My,
  DuplicateNotebookDto: jy,
  EditNotebookTitleBody: $y
};
class Wy {
  constructor(t) {
    Ft(this, "fetch");
    this.fetch = t;
  }
  async download(t, r, n = null, i = !0) {
    let a = `/files/presigned/${encodeURIComponent(r)}/url?method=download`;
    t && (a += `&bucket=${t}`), n && (a += `&limit=${n}`);
    const u = (await this.fetch(
      a,
      { method: "GET" },
      _o.PresignedUrlResponse
    )).url;
    if (i) {
      const c = document.createElement("a");
      c.href = u, c.download = "", c.target = "_blank", c.click(), document.body.appendChild(c), c.click(), setTimeout(() => {
        document.body.removeChild(c);
      });
    }
    return u;
  }
  async upload(t, r, n) {
    const i = [];
    let a = `/files/presigned/${encodeURIComponent(n)}/url?method=upload`;
    r && (a = a += `&bucket=${r}`);
    const u = (await this.fetch(
      a,
      { method: "GET" },
      _o.PresignedUrlResponse
    )).url, c = new XMLHttpRequest();
    return c.open("PUT", u), c.addEventListener("error", () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }), c.onerror = () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }, c.upload.addEventListener("progress", (l) => {
      const f = l.loaded / l.total;
      for (const d of i)
        d.onProgress(f);
    }), c.upload.addEventListener("load", () => {
      for (const l of i)
        l.onComplete();
      c.upload.removeEventListener("progress", () => null);
    }), c.send(t), {
      subscribe(l) {
        i.push(l);
      }
    };
  }
}
const Ly = async (e) => {
  if (!(await fetch(e, {
    method: "GET",
    credentials: "include"
  })).ok)
    throw new Error("Failed to refresh token");
};
function Jy(e) {
  async function t(r, n = {}, i, o = !0) {
    const a = { "Content-Type": "application/json", ...n.headers }, s = await fetch(`${e}${r}`, {
      ...n,
      headers: a,
      credentials: "include"
    });
    if ((s.status === 401 || s.status === 403) && o)
      return await Ly(`${e}/auth/token/refresh`), t(
        r,
        { headers: a, ...n, credentials: "include" },
        i,
        !1
      );
    if (!s.ok) {
      const u = await s.text();
      throw new Error(u);
    }
    if (i) {
      const u = await s.json();
      return i.parse(u);
    } else
      return s;
  }
  return t;
}
export {
  By as APIClient,
  Wy as S3,
  Jy as createFetch,
  Ly as refreshToken,
  _o as schemas
};
//# sourceMappingURL=client.js.map
